export const dummyQusetions = [
    {
        "id": 1,
        "sub_categories" : 2,
        "title": "A process that involves continuously improving and detailing a plan as more detail",
        "type" : {
            "value" : "SINGLE_CHOICE"
        },
        "image" : 'https://cdn-skill.splashmath.com/panel-uploads/GlossaryTerm/3040dedda62a46f59a5faf3c1ca2817d/1545817463_Triangle-math-geometry.png',
        "options": {
            "choices": [
                { "k" : "A","t":"Identifying resources 1","s" : 1 },
                { "k" : "B","t":"Identifying resources 2","s" : 3 },
                { "k" : "C","t":"Identifying resources 3","s" : 2 },
                
            ]
        },
        "answer" : {
            "keys": ["A"],
            "answer" : "Identifying resources 3",
            "e": "This is the explanation of this question"
        }


    },
    {
        "id": 2,
        "sub_categories" : 2,
        "title": "A process that involves continuously improving and detailing a plan as more detail",
        "type" : {
            "value" : "SINGLE_CHOICE"
        },
        "image" : 'https://cdn-skill.splashmath.com/panel-uploads/GlossaryTerm/3040dedda62a46f59a5faf3c1ca2817d/1545817463_Triangle-math-geometry.png',
        "options": {
            "choices": [
                { "k" : "A","t":"Identifying resources 1","s" : 1 },
                { "k" : "B","t":"Identifying resources 2","s" : 3 },
                { "k" : "C","t":"Identifying resources 3","s" : 2 },
                
            ]
        },
        "answer" : {
            "keys": ["A"],
            "answer" : "Identifying resources 3",
            "e": "This is the explanation of this question"
        }


    },
    {
        "id": 3,
        "sub_categories" : 3,
        "title": "A process that involves continuously improving and detailing a plan as more detail",
        "type" : {
            "value" : "SINGLE_CHOICE"
        },
        "image" : 'https://cdn-skill.splashmath.com/panel-uploads/GlossaryTerm/3040dedda62a46f59a5faf3c1ca2817d/1545817463_Triangle-math-geometry.png',
        "options": {
            "choices": [
                { "k" : "A","t":"Identifying resources 1","s" : 1 },
                { "k" : "B","t":"Identifying resources 2","s" : 3 },
                { "k" : "C","t":"Identifying resources 3","s" : 2 },
            ]
        },
        "answer" : {
            "keys": ["A"],
            "answer" : "Identifying resources 3",
            "e": "This is the explanation of this question"
        }


    }
]

const sampleData = [
    {
        "id": "1cf81fca-e697-4252-bb43-8f21b8f20789",
        "user_answer": [{"W": "B"},{"X": "D"},{"Y": "E"}],
        "mark_for_review": false,
        "is_correct": false,
        "is_answered": false,
        "display": 1,
        "title": "Your company is planning to deploy a corporate accounting software project. It will take more than a year to complete, have a budget of more than $5 million, and be implemented at 16 corporate locations around the world. The project sponsor wants to bring in an outside resource to be the project manager. This person, the sponsor’s brother-in-law, has many years of finance experience but no experience or training in project management. You are a PMP; what should you do?",
        "description": null,
        "image": null,
        "type": {
            "value": "DRAG_DROP",
            "name": "Drag & Drop",
        },
        "options":{
              "left": [
                  {
                      "k": "W",
                      "t": "Identifying resources Identifying",
                      "s": 1
                  },
                  {
                      "k": "X",
                      "t": "Identifying resources",
                      "s": 2
                  },
      
                  {
                      "k": "Y",
                      "t": "Influencing resources",
                      "s": 3
                  },
                  {
                      "k": "Z",
                      "t": "Assigning resources",
                      "s": 4
                  },
                  {
                      "k": "Zz",
                      "t": "Assigning resources resources",
                      "s": 5
                  }
              ],
              "right": [
                  {
                      "k": "A",
                      "t": "Identifying resources Identifying resources Identifying resources Identifying resources",
                      "s": 1
                  },
                  {
                      "k": "B",
                      "t": "Influencing resources",
                      "s": 2
                  },
                  {
                      "k": "C",
                      "t": "Assigning resources 1",
                      "s": 3
                  },
                  {
                      "k": "D",
                      "t": "Assigning resources 2",
                      "s": 4
                  },
                  {
                      "k": "E",
                      "t": "Assigning resources 3",
                      "s": 5
                  },
      
              ],
              "direction": "left"
            },
        "explanation_image": null,
        "correct_answer": [{"W": "B"},{"X": "D"},{"Y": "E"},{"Z": "C"},{"Zz": "A"}],
        "explanation": "There is no fixed duration for the estimation span. However, the team limits its estimation to the next few weeks at most. [Agile Practice Guide, 1st edition, Page 61]"
    },
        
    {
      "id": "c2b7c575-ff3b-4a1b-97af-9fb8f53da6bc",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 2,
      "title": "While using facilitated sessions to gather high-level business requirements for a software development project, one of your customers proposes a requirement that may not be technologically possible to meet. If the customer insists on the requirement, what should you do first?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "You should document the requirement and include it as a risk"
          },
          {
            "k": "B",
            "s": 2,
            "t": "You should document the requirement to meet customer expectations"
          },
          {
            "k": "C",
            "s": 3,
            "t": "You should not document the requirement"
          },
          {
            "k": "D",
            "s": 4,
            "t": "You should listen to the customer and understand his viewpoint"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "A project manager must communicate honestly and openly with the customer. When a customer insists on specific requirements, a project manager should listen to him or her and understand his or her point of view. Then, the project manager must gather facts and explain convincingly to the customer why he or she is right or wrong. Project managers should neither accept nor deny critical requests from the customer until they have sufficient factual information. Thus, in this situation, you should first listen to the customer and understand his viewpoint. [PMI Code of Ethics and Professional Responsibility]"
    },
    {
      "id": "c5284d9e-4baf-4ede-92f8-29566f59a2e3",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 3,
      "title": "After conducting a bidder conference, you receive an email from one of the bidders requesting additional information. The information was neither included in your request for proposal, nor did anyone ask for it during the bidder conference. You realize the answer to this question is critical to understanding the scope of the project. If the answer is not communicated to bidders, they cannot size their teams accurately or estimate the total duration of the project. The answer also greatly affects cost. However, the answer contains some proprietary information that, if disclosed to a competitor, may reveal the future product strategy of your company. Such a disclosure could be disastrous for a major product launch you are planning next year. You decide to send the answer to all the bidders, but you realize one of the bidders is also working closely with one of your competitors on a similar project. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Send this information to all bidders except the bidder working with your competitor."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Don’t send this information in writing; instead, telephone each bidding company."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Require all bidders to sign a nondisclosure agreement. You may then send the information to each company that signed the NDA."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Send this information to only the supplier who requested it."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The best choice is to require all bidders to sign a non-disclosure agreement (NDA) before sending them this additional information, and then provide the additional information to each bidder that has signed an NDA. Project managers are required to act fairly and provide equal access to information to all authorized parties. Sending the information to only some of the bidding companies would represent a violation of the PMI Code of Ethics and Professional Conduct. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "a39ed253-1d14-42a9-a303-8f4ea60ff2de",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 4,
      "title": "Your team has delivered a number of projects for your organizational clients and is known for speedy and reliable delivery of awarded projects. However, on the last few projects, there have been some customer complaints regarding the quality of some deliverables. To create quality products on all new projects, you are now considering investing in training the project team members and purchasing high-end equipment. Such costs are:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Failure costs"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Appraisal costs"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Costs of Nonconformance"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Prevention costs"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Investments in training and equipment are examples of prevention costs. Appraisal costs include the testing, losses due to destructive testing, and inspections. Collectively, these costs are called Cost of Conformance. [PMBOK® Guide 6th edition, Page 282]"
    },
    {
      "id": "a21285f8-b92e-4550-a414-158229c89479",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 5,
      "title": "Agile methods and practices have both direct and indirect benefits. In Agile projects, which of the following Agile techniques also helps in managing quality of deliverables?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Backlog grooming"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Rapid feature delivery"
          },
          {
            "k": "C",
            "s": 3,
            "t": "User story sizing"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Team chartering"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "If the team does not pay attention to quality, it will soon become impossible to release anything rapidly. This is an indirect benefit of rapid feature delivery. [Agile Practice Guide, 1st edition, Page 56]"
    },
    {
      "id": "9c67fc57-cd1f-4c12-848f-476dc279d356",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 6,
      "title": "During a risk review meeting, the project manager learns that the company has just approved a new policy that prohibits the use of overtime. This restriction represents a new constraint for the project.\n\nWhere should this newly identified constraint be documented?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The constraint register"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The risk register"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The assumption log"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The change log"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "A risk review meeting is conducted as part of the Monitor Risks process. The risk register, assumption log, and issue log, among others, may be updated as a result of this process. The question describes a situation which may need to be documented in some or all of these project documents. The assumption log (sometimes referred to as the assumptions and constraints log) is a project document used to record all assumptions and constraints throughout the project life cycle. Since the question asks where the newly identified 'constraint' should be documented, it is best to choose the document that specifically deals with 'constraints'. Therefore, of the choices offered, the assumption log is the best answer to the question asked. [PMBOK Guide  Sixth Edition, Page(s) 458]"
    },
    {
      "id": "fd8efeb8-6a89-4817-865f-8f820c8f127e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 7,
      "title": "An Agile team is currently developing an inventory control system. Two programmers on the team are arguing and recommending different development approaches. One is of the view that the system should be built from scratch, while the other believes that the existing system should be enhanced and patched. How should you resolve this conflict?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Select the patch work approach as that will save time for the organization."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Ask the product owner to choose the right approach."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Ask the entire team to analyze both approaches and select the one that will deliver higher business value."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Develop the product from scratch as that will bring the system closer to requirements."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "This has to be a team decision. Ask the entire team to analyze both approaches and select the one that will deliver higher business value. [Agile Practice Guide, 1st edition, Page 4]"
    },
    {
      "id": "5c9db719-3b20-4a09-a064-cad0e1e809a7",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 8,
      "title": "A pharmaceutical company invested $5,000,000 in a project to develop a new drug to treat hypertension, which was terminated before completion. However, before the project was canceled, testing indicated that a side effect of the drug was the stimulation of hair growth. The pharmaceutical company is now in the initiation stage of a new project to develop the drug as a treatment for hair loss.\n\nHow should the $5,000,000 spent on the previous project be treated with respect to the benefits analysis of the new project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Investment costs that must be included as a cost to the new project"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Sunk costs that should not influence future decisions"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Opportunity costs that should be considered before approving the new project"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Included in the payback period for the new project"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "When a project is terminated prematurely, there is a chance that some useful business value will already have been generated, such as in the scenario described where a side effect of the drug was the stimulation of hair growth. This situation allows the premature closure to be less of a failure due to sunk costs. However, sunk costs are the costs that have already been incurred and cannot be recovered. The $5,000,000 represents sunk costs which are not relevant to the new project and should not influence the decision of whether or not to proceed with the new project. For example, if a real estate investor buys a home and invests $300,000 in the home and renovations, but the market value of the renovated house is only $250,000. The fact that the real estate investor spent $300,000 (sunk costs) does not influence the amount for which the renovated home can be sold. [PMBOK Guide  Sixth Edition, Page(s) 34-35, 671]"
    },
    {
      "id": "24362c3c-38d1-40cc-a330-46836164e654",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 9,
      "title": "A number of projects are under consideration for the upcoming quarter. The Director of Global Systems strongly believes that one of the projects, a system upgrade, is needed and aligned with the long-term business strategy.\n\nAt the executive steering committee meeting scheduled to select projects for the upcoming quarter, what action should the Director take?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Advocate for the project with the highest NPV"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Select a project sponsor"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Present the merits of the system upgrade project"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Select a project manager"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Projects are selected for many reasons. Not all desired projects can be undertaken by an organization. Decisions as to which projects an organization is to take on are often part of an executive steering committee's responsibility. To get a certain project sponsored and chartered, the Director in this scenario must present the merits and value to the business to the steering committee. Upon selection and approval, the project charter for the project can be commissioned and the project made official. [PMBOK Guide Sixth Edition, Page(s) 75-77]"
    },
    {
      "id": "68987714-068b-4327-868b-96cae5154303",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 10,
      "title": "As part of project initiation, the project manager reviews the business case, creates the stakeholder register, and helps the sponsor with the development of the project charter.\n\nWhat else should the project manager do before moving on to project planning?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Develop the stakeholder engagement plan"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Conduct benefits analysis with relevant stakeholders"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Send bid documents to prospective sellers"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Determine the project budget and develop the schedule"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The Project Management Professional (PMP)^® Examination Content Outline contains a list of tasks for each domain, with which PMP aspirants are expected to be familiar. Task 2 of the Business Environment domain states, \"Evaluate and deliver project benefits and value.\" While it's the project sponsor who is generally accountable for the development and maintenance of the project business documents (the business case and benefits management plan), it's the responsibility of the project manager to provide recommendations and oversight to keep the success measures of the project business documents, project management plan, and project charter in alignment with one another and with the goals and objectives of the organization. The business case, along with the benefits management plan, serves as one of the inputs to the Develop Project Charter process. According to the scenario, the project manager reviewed the business case and developed the stakeholder register. Therefore, of the choices provided, what missing to complete the development of the project charter is the benefits management plan. In other words, conducting benefits analysis with relevant stakeholders that have just been identified is what the project manager should do before moving on to project planning."
    },
    {
      "id": "0b4f9277-4313-42ba-849a-67572836c928",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 11,
      "title": "A Project Manager leaves the company and is replaced. The new Project Manager wants to start guiding the team toward project success.\n \nWhat should the new Project Manager do first?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Look over the project charter to identify goals and deliverables."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Review the project diary and look for notes made by the former Project Manager."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Modify the project schedule, adding a new activity related to the knowledge transfer process."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Revisit the project budget to determine if extra time is required."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The Project Charter is one of the most important project documents. It defines many aspects of the project which are critical to the new Project Manager's understanding of the project strategy, as well as the tactical execution. Any other actions before reading the official project charter will be made with a bias. [PMBOK Guide Sixth Edition page 75]"
    },
    {
      "id": "9f7ed10e-9463-4a28-9a59-0ac23b30d4ff",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 12,
      "title": "On Agile projects, the product backlog serves as the prime documentation of a project’s scope. A Scope Statement, on the other hand, documents the project’s scope on predictive traditional projects. The product backlog, in contrast to scope statements on traditional projects, is considered to be more:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Dynamic and complete"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Dynamic and incomplete"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Static and complete"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Static and incomplete"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The product backlog is dynamic and incomplete; it is a live project artifact. [Agile Practice Guide, 1st edition, Page 52]"
    },
    {
      "id": "7c0cc44a-5612-4c54-a6c2-96f7859ca2af",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 13,
      "title": "In light of rising fuel costs, a car manufacturer is responding to market demand by initiating a project to increase the fuel efficiency of their cars. The company executives aim to improve the market share and profitability of the company.\n\nIn this scenario, which of the following is not one of the four fundamental categories of factors that led to the initiation of the project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Meet regulatory or legal requirements"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Create, improve, or fix products, processes, or services"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Satisfy stakeholder requests or needs"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Implement or change business or technological strategies"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The question states that the car manufacturer is responding to market demand and does not indicate that the project would satisfy any legal requirements. Governments sometimes regulate the fuel efficiency of cars, but the question specifically states that the project is in response to market demand rather than government requirements. Note, the question is asking for the answer choice which is 'not' one of the four fundamental categories of factors that led to the initiation of the project. Therefore, meeting regulatory, legal, or social requirements is the best answer. [PMBOK Guide  Sixth Edition, Page(s) 9]"
    },
    {
      "id": "444148a8-a22f-4796-9bee-a58233149520",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 14,
      "title": "An open-source technology has been agreed upon by all the major organizations across the industry. Your organization encourages its projects to work in a hybrid of project management approaches. The open-source consortium mandates a continuous integration approach.\n\nWhich of the following should your organization to assess prior to deciding where or not to join the consortium and implement continuous integration in future projects?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The skillsets of project managers, scrum masters, and product owners in the technology within the organization"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The external business environment to evaluate the benefits of contributing to the open-source technology"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The potential for the organization to convert to a completely agile environment to handle the continuous delivery requirement"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The intellectual property provided by the other organizations to take\nwhat can be leveraged without joining the consortium"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "When organizations take on new initiatives or projects, the organization must survey the conditions surrounding the potential project. Selecting unsuitable projects for an organization can be costly and a waste of resources. Therefore, organizations must survey the internal and external business environment to assist in the decisions as to which projects to charter. This is true to any type of project, whether the project is managed using an agile, predictive, or hybrid project management approach. In the scenario, your organization is mainly using hybrid methodologies to manage its projects. The organization does not necessarily need to alter their project management approach at this point. It must, however, determine what the benefit or loss of taking on a particular project is. [PMBOK Guide  Sixth Edition, Page(s) 10-11]"
    },
    {
      "id": "9b5a0c3e-255f-48c3-ab65-bfbf27dde819",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 15,
      "title": "In a meeting with all the project managers of a department-wide improvement program, the program manager states the program’s mission and authority relationships.\n\nAs one of the project managers attending the meeting, what do the mission and authority relationships represent to your project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Organizational process assets"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Matrix organization"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Enterprise environmental factors"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Project requirements"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Any condition or factor that stems from outside the project or even outside the project’s enterprise is considered an enterprise environmental factor. The program’s mission, values, and authority relationships are outside the project’s immediate control, yet they factor into how the project operates within the enterprise. Hence these are good examples of enterprise environmental factors. [PMBOK Guide Sixth Edition, Page(s) 557]"
    },
    {
      "id": "7dee2ca5-35c9-4cb5-9a5e-84cc6cc2dc9a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 16,
      "title": "Your project team is trying to digitize a manual business workflow. The project has already taken a couple of years without any significant releases. Frustrated with the project’s progress, the user department has already started developing their own tools to support their manual processes. With every new tool introduced by the user department, the scope of your project increases as now you have to include this newly added functionality into your design; creating a never-ending problem of scope creep. How should you handle this situation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Escalate the issue to the sponsor as this can jeopardize the whole project."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Revert back to original project scope and disregard any new functionality."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Meet with the user group, understand their concerns and reach an agreement on the way forward."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Issue a change request for extension of time."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Rather than taking any extreme measures, you should first try to resolve the issue. It is recommended that you meet with the user group, understand their concerns and reach an agreement on the way forward. [PMBOK® Guide 6th edition, page 523]"
    },
    {
      "id": "ec8d63e6-3f19-4183-aa5e-598eed1775a0",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 17,
      "title": "You have been hired as a consultant by a manufacturing firm. You have been asked to develop a standardized project management approach for the organization. You are currently considering the entire continuum of project management which is Agile on one end and waterfall on the other. Before you can decide which model to select, you need to conduct a/an: ",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Impact assessment"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Organization culture assessment"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Feasibility analysis"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Root cause analysis"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The first thing you need to do is conduct the organization’s culture assessment. Impact assessment should be conducted only once the new approach has been selected and approved. Root cause and feasibility analysis are irrelevant to the problem at hand and are rather related to issues and individual projects respectively. [Agile Practice Guide, 1st edition, Page 75]"
    },
    {
      "id": "a0b6bdaa-73c5-4011-aa25-c11b6da37515",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 18,
      "title": "A company is struggling to define the scope of a new project that has multiple phases with a high level of dependency between the phases. \n \nHow should the Project Manager approach this challenge?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Contract with a third-party company that specializes in helping businesses define scope of work on large projects."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Work with project stakeholders to recommend an iterative approach that will then help to define the project's scope."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Construct a project management plan that provides extra time within the schedule, then seek to revise the scope of work."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Suspend final delivery dates for the project in order to have time to revise the schedule once there is clarity on the scope of work."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Iterative life cycle approach allows feedback for unfinished work to improve and modify that work. As company is struggling to define the scope, option B is the right approach. [The Agile Practice Guide (2017), Planning for Iteration-Base Agile, page 55; PMBOK® Guide Sixth Edition page 524]"
    },
    {
      "id": "58ae0820-5556-427f-9178-88797c29fb0f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 19,
      "title": "Which of the following is a collaborative approach to defining requirements and business-oriented functional tests for software products based on capturing and illustrating requirements using realistic examples instead of abstract statements?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Work Breakdown Structure (WBS)"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Specifications by Example (SBE)"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Work Instructions (WI)"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Requirements Manual (RM)"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Specifications by Example (SBE) is a collaborative approach to defining requirements and business-oriented functional tests for software products based on capturing and illustrating requirements using realistic examples instead of abstract statements. [Agile Practice Guide, 1st edition, Page 154]"
    },
    {
      "id": "ba24bdcd-d1ef-4512-8b00-c2b646bd5d2f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 20,
      "title": "Which of the following terms refers to the deferred cost of work not done at an earlier point in the product life cycle?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Technical debt"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Opportunity cost"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Sunk cost"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Net present value"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Technical debt refers to the deferred cost of work not done at an earlier point in the product life cycle. [Agile Practice Guide, 1st edition, Page 154]"
    },
    {
      "id": "6806883d-dfe0-4cab-bc42-aa503aa6402b",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 21,
      "title": "A project requires the use of various contractors to complete the project deliverables, and you have scheduled a bidder conference as part of the procurement process.\n\nWhich of the following values is best represented by holding a bidder conference?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Responsibility"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Honesty"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Respect"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Fairness"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "A bidder conference is a meeting between the buyer and prospective sellers before proposal submittal. They are used to ensure that all potential bidders have a clear and common understanding of the procurement and no bidders receive preferential treatment. Of the available choices, providing equal access to information best exemplifies the value of fairness. [PMBOK Guide  Sixth Edition, Page(s) 487]"
    },
    {
      "id": "ed200f60-2470-4a1d-9d1d-c8f4245feb98",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 22,
      "title": "During a recent staff meeting, a corporate executive stated that the existing corporate structure would not meet the future needs of the organization.\n\nIn this context, what might a project manager say about driving change at the organizational level?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The change control board (CCB) is a formally chartered group responsible\nfor evaluating and approving organizational changes."
          },
          {
            "k": "B",
            "s": 2,
            "t": "An approved change request is required to restructure an organization."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Operations drive change with the production of goods and services."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Projects drive change by moving an organization from the current state\nto a desired future state."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Projects drive change in organizations. From a business perspective, a project is aimed at moving an organization from one state to another state to achieve a specific objective. Before the project begins, the organization is commonly referred to as being in the current state. The desired result of the change driven by the project is described as the future state.\n\nIn this scenario, the executive believes that the current corporate structure is inadequate and a reorganization is necessary to meet future organizational objectives. In this case, a project may be initiated to transform the organizational structure from the current state to a desired future state. [PMBOK Guide Sixth Edition, Page(s) 6]"
    },
    {
      "id": "8b49807f-3b8c-47e6-bf45-c32bc2aa7899",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 23,
      "title": "If the customer wants to incorporate new ideas or features not originally planned into a not-to-exceed time and materials arrangement, which of the following approaches is recommended?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Issuing a new contract for the additional work."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Replacing original work with new work."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Converting the not-to-exceed time and material arrangement to a fixed-price arrangement."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Adding new work to the scope of work."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "When customers want to incorporate new ideas in a not-to-exceed time and material arrangement, they will have to manage to a given capacity and replace original work with new work. [Agile Practice Guide, 1st edition, Page 78]"
    },
    {
      "id": "261ffa1c-13d4-4681-98a4-892437821589",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 24,
      "title": "You are responsible for migrating some critical business applications for the local servers over to a cloud platform. Some non-critical support applications, which are currently integrated with these critical applications, will also be required to move. Although the high-level scope of the project is known, due to the complexity of the project, the detailed requirements can only be determined as the project progresses. Which of the following planning tools should you use for this project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Progressive elaboration"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Change requests"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Predictive approaches"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Change control"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Since detailed requirements can only be determined later in the project, this calls for progressive elaboration of project requirements. The rest of the choices are irrelevant. [PMBOK® Guide 6th edition, page 185]"
    },
    {
      "id": "08948c5b-06d2-46d2-9ab2-14d09a8f50e3",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 25,
      "title": "As a result of multiple regulatory changes, a governmental agency is added as a key stakeholder on a complex project. The Project Manager wants to develop an understanding of this new stakeholder and identify any new high-level risks that may result from the change.\n \nWhat should the Project Manager do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Meet with the new stakeholders."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Identify needed changes to the assumption log."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Review the stakeholder engagement plan."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Check with the project sponsor regarding the benefits management plan."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Meetings are used to develop an understanding of significant project stakeholders. They can take the form of facilitation workshops, small group guided discussions, and virtual groups using electronics or social media technologies to share ideas and analyze data. [PMBOK Guide Sixth Edition page 528]"
    },
    {
      "id": "d9901097-e290-49d0-bdda-b0c00983fe3e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 26,
      "title": "You have recently started working as a project manager for a public school construction project. Your analysis shows that the cost estimate for the project seems to be unreasonable, and it could take at least 25 percent more funding to complete the project. What should you do if your sponsor wants to undertake the project with another project manager in case you refuse to accept it?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Continue with the project and document the limited budget as a constraint"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Resign from the project and let the sponsor assign a new project manager"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Submit detailed facts to the supervisor supporting your argument"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Conduct a customer focus meeting to explain the facts"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Project managers have the responsibility to present truthful and accurate information regarding costs, schedules, and resources. Submit the facts that substantiate your argument. If your argument is valid, then the sponsor might agree with you. Talking to customers is not appropriate. Continuing the project might cause it to fail. It is inappropriate to resign from the project without presenting the facts. [PMI Code of Ethics and Professional Responsibility]"
    },
    {
      "id": "913ca82f-de69-44e9-b48c-14b7ea62279f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 27,
      "title": "You are helping a software development team transition from traditional to Agile approaches. You tell the team that the single most important attribute of any product or feature is:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The ideal days estimated to develop the minimum viable product or feature."
          },
          {
            "k": "B",
            "s": 2,
            "t": "The time required to deliver the product or feature."
          },
          {
            "k": "C",
            "s": 3,
            "t": "The value customers associate with that product or feature."
          },
          {
            "k": "D",
            "s": 4,
            "t": "The velocity at which the team takes on the development of that product or feature."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "A successful project, product or feature is the one that delivers value to the customer. Customers usually do not care how teams develop products, however they do care if the product delivers value to them or not. [Agile Practice Guide, 1st edition, Page 4]"
    },
    {
      "id": "5e3da8b6-b1f9-48fa-83a5-8a04e19b6c29",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 28,
      "title": "There is a heavy demand for new houses in your city's expensive neighborhood. RECON, a construction company, has employed you as a project manager to assess the benefit of building new energy-efficient houses in that neighborhood, even though it takes more expensive technology to build such houses. You have started gathering data to perform a detailed payback analysis to submit a report to your management. Since the full financial impact of building energy-efficient houses is difficult to estimate, you would like to prepare a rough cost-benefit analysis and include it with the report. Which of the following describes the effort you are undertaking in this scenario?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "You are developing a business case to provide as an input to the Develop Project Charter process."
          },
          {
            "k": "B",
            "s": 2,
            "t": "You are developing a risk management plan to provide as an input to the Perform Quantitative Risk Analysis process."
          },
          {
            "k": "C",
            "s": 3,
            "t": "You are developing a cost management plan to provide as an input to the Estimate Costs process."
          },
          {
            "k": "D",
            "s": 4,
            "t": "You are developing a cost-benefit analysis to provide as an input to the Plan Risk Management process."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "An organization's business need may arise due to advances in technology, a demand from the market or a legal requirement. The business need and cost-benefit analysis are documented in a business case. A business case determines whether the project is worth the investment. Payback analysis is also part of a business case. The business case and other documents are used as an input to the Develop Project Charter process. Hence, you are making efforts to build a business case to input to the Develop Project Charter process. [PMBOK® Guide 6th edition, Page 77]"
    },
    {
      "id": "bd4c4ad2-c6af-4c1e-b010-2efb6cdcac90",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 29,
      "title": "Who has the responsibility to monitor, record, and report the realized benefits throughout the project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Human resources manager"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Project manager"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Project sponsor"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Benefits owner"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The project benefits management plan is the document that specifies how and when the benefits of the project will be delivered. The plan describes the mechanisms that should be in place to measure those benefits. A well-thought-out benefits management plan would specify a\nbenefits owner who is the individual or group responsible for monitoring, recording, and reporting the realized benefits throughout the project."
    },
    {
      "id": "c8d64aa4-38d8-451a-adfb-fa737599da11",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 30,
      "title": "You are closing out a project you have run in a foreign company and are vacating the warehouses and offices you occupied during the project. One of the warehouses contains a large amount of a particular chemical used to manufacture the product that was a project deliverable. This chemical is on a local toxic and hazardous materials list, and as such, cannot be shipped back to your corporate headquarters in your home country. The warehouse manager informs you that a local government agency will handle disposal for a small fee and will even provide expedited service for a larger fee. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Fees paid to local governments for services are bribes, and should not be paid"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Advise the warehouse officer to leave the material"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Request that the owner of the property dispose it on their own"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Arrange for the local authorities to handle the disposal"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Arrange for the local authorities to handle the disposal. Fees paid to a local government for a standard service that government provides is not a bribe. Abandoning the chemical in the warehouse, with or without notifying the property owner is inappropriate. Project managers are required to follow all rules, regulations, policies, and processes, and failure to do so is a violation of the PMI Code of Ethics and responsibility. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "ca0bb590-f966-429b-bbe5-f2991da9caa4",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 31,
      "title": "Mark is managing a telecom network deployment project. The buyer of the telecom network is an external entity. Recently, the customer requested that all future project updates be posted to their information system automatically. In order to implement this, the project team needs to customize their project management information system so it can be integrated with the customer’s information system. This is a new customer requirement that was not a part of the original project’s scope. \nWhat should the project manager do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Initiate the formal change control process."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Ask the project team to customize the project management information system."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Request that the customer terminate the current contract and award a new contract."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Ignore the request; this is outside the project’s scope."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Change requests do come. They are never ignored; they are managed through the integrated change control process. This does not require terminating the contract. Implementing the new requirement without following the change control process is not advisable. [PMBOK® Guide 6th edition, Page 113]"
    },
    {
      "id": "f0a42b10-587a-4d60-9d63-cde32debea0c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 32,
      "title": "A project team trying Agile methods for the first time is considering Agile reporting methods. Historically the team has been reporting on project baselines and has used earned value management for status reporting. What should be the new approach?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Continue using earned value management for project reporting."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Consider ways to report project’s ROI."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Agile teams do not report project progress."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Consider ways to report demonstrable value delivery to customers."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Agile favors empirical and value-based measurements instead of predictive measurements such as POC and earned value management techniques. Agile measures what the team delivers, not what the team predicts it will deliver. Agile is based on working products of demonstrable value to customers. [Agile Practice Guide, 1st edition, Page 61]"
    },
    {
      "id": "19ac3905-d661-4f84-97a4-12cec902e022",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 33,
      "title": "Kate has been asked to conduct the feasibility of a new CRM system. So far, the business has been relying on its traditional manual customer relationship management processes, but now it is struggling to keep up with the competition. In this scenario, the business’ requirement of acquiring a state-of-the-art CRM system to boost its customer relations management capabilities is an example of:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Project requirements"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Non-functional requirements"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Business requirements"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Functional requirements"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Business requirements describe the higher-level needs of the organization as a whole, such as the business issues or opportunities. Other choices are much lower level requirements. [PMBOK® Guide 6th edition, Page 148]"
    },
    {
      "id": "26b8578e-b90e-4bd0-a7bc-a04b8174b877",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 34,
      "title": "One of your project team members comes to your office and says she had a telephone conversation with your customer’s executive director, who is also a member of the royal family in the country where your project is. He has requested a number of significant changes in the project scope and schedule. You have questions about these changes. Which one of the following BEST describes what you should do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Prepare a transcript of the discussion between your team member and the director. Send an email to him requesting a detailed description of changes in the scope"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Prepare a transcript of the discussion between your team member and the director. Send a formal letter through courier service requesting a detailed description of changes in the scope"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Prepare a transcript of the discussion between your team member and the director. Send an email to him requesting a detailed description of changes in the scope, also request him to call you directly instead of talking to a junior team member"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Ask the appropriate member of the customer‘s management team to advise the correct protocol for discussing these issues with the executive director"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Ask your customer's management team to advise you on the best communications mechanism to avoid engaging in behaviors that may be disrespectful or offensive. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "0835d5b9-db36-4272-95a0-fb77839e404a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 35,
      "title": "When one factor used to determine the effort required to produce a unit of work is increased while all other factors remain fixed, a point will eventually be reached at which additions of that one factor start to yield progressively decreased productivity. This is known as:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The law of diminishing returns"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The Pareto Law"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The 100 percent rule"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The theory of constraints"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "When one factor used to determine the effort required to produce a unit of work is increased while all other factors remain fixed, a point will eventually be reached at which additions of that one factor start to yield progressively decreased productivity. This is commonly known as the law of diminishing returns. [PMBOK® Guide 6th edition, Page 197]"
    },
    {
      "id": "babb3b50-873d-4117-8cd9-3f41099f48ca",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 36,
      "title": "You are working at a firm where your responsibilities include selecting the right programs or projects, prioritizing the work, and providing the needed resources. Your primary objective is to manage all of the various programs, projects, and operations together as a group to meet the firm's strategic business objectives.\n\nWhich of the following best describes the work you are performing?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Operations management"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Project management"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Program management"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Portfolio management"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "A portfolio is a collection of projects, programs, subsidiary portfolios, and operations managed as a group to achieve strategic objectives. Of the available options, only portfolio management includes operations management as a subsidiary. Therefore, portfolio management is the best answer to the question asked.  [PMBOK Guide  Sixth Edition, Page(s) 11-17]"
    },
    {
      "id": "a6715ee2-5aed-4b61-adc6-0af05a4bb7fa",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 37,
      "title": "The Make-or-Buy analysis is a technique used as part of the Plan Procurement Management process. It can determine whether the project team can produce a particular product or service, or if it should be purchased. The analysis to arrive at a decision should include:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Indirect costs only"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Direct as well as Indirect costs"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Staffing costs only"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Direct costs only"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The analysis should include both indirect as well as direct costs. [PMBOK® Guide 6th edition, Page 473]"
    },
    {
      "id": "8e912db8-5ca8-4a13-8914-ff826450de8c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 38,
      "title": "A Project Manager is working with three key stakeholders. Each stakeholder has a different vision regarding the project and its goal. They each feel strongly about their opinion. The Project Manager needs to obtain approval of the project charter.\n \nWhat should the Project Manager do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Conduct a stakeholder analysis."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Use negotiation to ensure the three stakeholders are in agreement."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Request that the project sponsor resolve the conflict."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Use the project kick-off meeting to settle the project goals."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Projects experiencing a high degree of change require active engagement and participation with project stakeholders. To facilitate timely, productive discussion and decision making, adaptive teams engage with stakeholders directly rather than going through layers of management. [PMBOK Guide Sixth Edition page 488]"
    },
    {
      "id": "9a2bc9ae-8818-4f3e-b1bf-455d09acf467",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 39,
      "title": "You are authorized to approve expenditures above $15,000. For the last several weeks, you have been negotiating the terms and pricing of a contract with a vendor, and you want to keep costs as low as possible. This has been an exceedingly difficult negotiation process. A colleague suggests you tell the vendor you can only approve expenses below $10,000 as a way to keep the price low. What do you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Tell the vendor you are only authorized to approve expenses under $10,000"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Do not follow the colleague‘s advice"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Put a deadline on the negotiation completion"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Ask for binding arbitration"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Do not follow your colleague's advice. Providing false or misleading information for any reason is a violation of the PMI Code of Ethics. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "679a5629-9ab0-433e-ad8c-53f11f9d2314",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 40,
      "title": "To utilize a few employees who are not assigned to any projects this month, the functional manager can authorize a project specifically for them. There are two project ideas that have been vetted. One is an IT project to implement a new software tool. Another is a charity project for the community. Alas, there is only enough budget for one of the projects.\n\nHow should the functional manager approach the project chartering?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Evaluate the business value of each of the projects to determine which\none brings more value to the company"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Charter the IT project of the new software tool implementation since it\nis likely to provide a long-term tangible benefit"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Charter the charity project for the community since it is likely to have\na positive, long-lasting, intangible, public benefit"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Charter both projects with a reduced scope that can be covered by the\navailable budget to gain a little value from each"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The question states that the functional manager can only sponsor and charter one project at this point. The functional manager then must select a project that makes the most sense for the functional area and the company. What is best is a factor of many things. In this scenario, since the project selection method is not provided, business value is the deciding factor. Business value is the net quantifiable benefit derived from a business endeavor. The benefit may be tangible, intangible, or both. Business value is considered the return, in the form of elements such as time, money, goods, or intangibles in return for something exchanged. As such, factoring in the value to be gained or lost by chartering a project is the most viable variable for the functional manager to consider. [PMBOK Guide Sixth Edition, Page(s) 7]"
    },
    {
      "id": "fcf2544f-7c96-425f-91a6-7774b03eb738",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 41,
      "title": "A project's deliverable on the critical path is lagging behind schedule. The cost performance index (CPI) is 1.3. The Project Manager is able to put the project back on schedule.\n \nWhat is the most likely outcome for the project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "There will be activities performed in parallel."
          },
          {
            "k": "B",
            "s": 2,
            "t": "There will be a revised scope."
          },
          {
            "k": "C",
            "s": 3,
            "t": "There will be an increase in costs and risks."
          },
          {
            "k": "D",
            "s": 4,
            "t": "There will be rework."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The Cost Performance Index (CPI) is above 1, therefore the project is spending money at a rate lower than planned. Since the project is behind schedule, it's Schedule Performance Index (SPI) is less than 1. In order to increase the SPI to 1, there is most likely an increase in cost (perhaps from crashing or fast-tracking) that will lower the CPI towards 1. This will most likely increase risks associated with the project when trying to do more in less time. [PMBOK Guide Sixth Edition page 215]"
    },
    {
      "id": "45c1e176-9814-403b-88c1-a73ce4278231",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 42,
      "title": "Three years back, your organization awarded a fixed price contract to a reputable local contractor to construct a new airport terminal in the city. A few days back, you received a change request from the contractor requesting to adjust the contract’s price. The contractor is claiming that as a result of the recent national recession, the prices of raw materials have gone up and he cannot complete the rest of the project at the contract price. Is the contactor’s request legitimate?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "No, the price hike due to recession must be adjusted against the contractor’s profit."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Yes, unless there is no Economic Price Adjustment provision in the contract."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Yes, you cannot penalize the contactor for price escalations due to force majeure."
          },
          {
            "k": "D",
            "s": 4,
            "t": "No, the price of the contract is fixed and cannot be changed."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Unless there is no provision for economic price adjustment due to inflation, a fixed price contract’s value cannot be changed. Usually fixed price contracts spanning over one year in duration have this provision built into the contract. [PMBOK® Guide 6th edition, Page 471]"
    },
    {
      "id": "1fa05089-dc32-4b49-9a25-c5da0537d11a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 43,
      "title": "You have developed a short list of vendors that have submitted bids for a project you are managing. One vendor has quoted USD $3.5 million, another vendor has quoted USD $4.2 million, and the final vendor has quoted USD $5.1 million. What is the most important thing to consider when selecting the winning bid?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Price"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Vendor experience"
          },
          {
            "k": "C",
            "s": 3,
            "t": "How well the vendor meets the selection criteria and project requirements"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Incentive payments such as early completion bonuses and late performance penalties"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "How well the vendor meets the formal vendor selection criteria and project requirements is the most important thing to consider. Price and experience may be listed as part of these criteria, but they are not the sole indicators of how well a vendor will perform. The PMI Code of Ethics and Professional Conduct requires project managers to attend to the best interest of the project as a whole, as well as follow all project process and policies, such as those regarding procurement. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "d25cc45f-7a0a-49f3-90c3-9e0561518d95",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 44,
      "title": "When a person multi-tasks between two projects, that person is not 50% on each project. Instead, due to the cost of task switching, the person is somewhere between 20% to 40% on each project. Which of the following is not a cause behind this general loss of productivity?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "People assigned to multiple projects are more likely to make mistakes when they multi-task."
          },
          {
            "k": "B",
            "s": 2,
            "t": "People assigned to multiple projects are less likely to remember project contexts."
          },
          {
            "k": "C",
            "s": 3,
            "t": "People assigned to multiple projects are more likely to have competing priorities."
          },
          {
            "k": "D",
            "s": 4,
            "t": "People assigned to multiple projects are not loyal to any of the projects."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "People are more likely to make mistakes when they multi-task. Task-switching consumes working memory and people are less likely to remember their context when they multi-task. However, multi-tasking should not affect a person’s loyalties. [Agile Practice Guide, 1st edition, Page 45]"
    },
    {
      "id": "5712fcaf-b96f-4dd2-93d9-60633a95bd92",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 45,
      "title": "You are managing a project with four phases and feel the project has completed the work required to move to the next phase.\n\nWhat should you do next?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Perform validation of the project deliverables that have been completed in the current phase"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Hold a kick-off meeting for the next phase and assign roles and responsibilities to the stakeholders"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Determine if the quality of the project deliverables comply with the quality specifications"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Gather stakeholders to compare the project and business documents with\nthe project's performance"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "A phase gate, also known as a phase review, is held at the end of a phase. During a phase review, the project's performance and progress are compared to project and business documents. These documents may include the project charter, project management plan, project business case, and benefits management plan. At the phase gate, a determination is made whether or not to proceed with the next phase, repeat the current phase (or elements of it), remain in the phase, or end the project.\n\nTo emphasize the point, one should keep in mind that while having completed and accepted deliverables is an important step in concluding a project or phase, project/phase success is not measured solely based on accepted deliverables. Other factors should be considered. Probably the simplest example would be this one: what if the deliverables have been completed and accepted, but the project/phase ended up being over budget and/or behind schedule? This is why gathering stakeholders to compare the business documents with the project's performance is a better answer than any of the other choices provided. [PMBOK Guide  Sixth Edition, Page(s) 20-21]"
    },
    {
      "id": "5ffa403b-7f11-4ef5-a277-5e9a8076d9ae",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 46,
      "title": "You are the project manager for a consulting firm. After obtaining formal acceptance and receiving final payment, you are preparing the final project report. The report includes an assessment of whether the results achieved the benefits that the project was undertaken to address. You have already collected the performance results, and you now need to gain a better understanding of the intended project benefits.\n\nWhat should you do next to accomplish this objective?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Look at the agreements with the client"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Check the business documents"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Survey relevant project stakeholders"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Review the procurement management plan"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The question implies that the Close Project or Phase process is underway. All of the answer choices may provide information that will be useful in this process. However, the question is specifically asking for a source of information for the intended project benefits. Business documents, such as the business case and the benefits management plan are among the inputs to the Close Project or Phase process. The benefits management plan outlines the target benefits of the project and perfectly addresses the need expressed in the question. Since the benefits management plan is not listed as an answer choice, the business documents become the best answer to the question asked.\n\nOne may argue that a seller should not have access to the business documents of the buyer. This is typically true. And the question does not suggest otherwise. The thing is that both the buyer and the seller manage the engagement between them as a project. Therefore, both would have had created business documents. The benefits of the project for the buyer would be documented in the business documents of the buyer, and the benefits of the project for the seller would be documented in the business documents of the seller. [PMBOK Guide Sixth Edition, Page(s) 125, 127-128]"
    },
    {
      "id": "e25a9083-6e2d-4008-9af6-d5c2d4ef8fea",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 47,
      "title": "On traditional projects, a change control board is usually established to authorize change requests. Who is responsible to authorize changes on an Agile project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "End users"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Agile team"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Scrum master"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Product owner"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Product owners have the ultimate responsibility of the project success. They prioritize the project backlog and authorize change requests on an Agile project. [Agile Practice Guide, 1st edition, Page 41]"
    },
    {
      "id": "29b697a8-4f7d-46c4-8964-9530f72ea80c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 48,
      "title": "How can an Agile team ensure that the features an Agile team is developing and releasing delivers the maximum value to the business?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Servant-leader collaborates with the team."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Team collaborates with the feature users/customers."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Product owner collaborates with feature users/customers."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Team collaborates with the product owner."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The product owner represents the customer on an Agile team; the Agile team doesn’t directly collaborate with the customer. Only customers/end users can determine the value of a required (or already developed) feature. [Agile Practice Guide, 1st edition, Page 41]"
    },
    {
      "id": "e7494218-020b-4b12-b37f-ad11fe56101c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 49,
      "title": "Your project is dependent on the output of a deliverable being created by another project team. That deliverable is three weeks late, a fact that you communicated in your weekly status reports. At the most recent company-wide status meeting, the manager of that project reported that the project is on time. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Continue reporting the late deliverable in your own status report"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Continue reporting the late deliverable in your own status report and notify the appropriate management of the incorrect information in the other project‘s status report"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Do nothing"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Point out the error to the other project manager"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Continue reporting the late deliverable in your status report and notify the appropriate management that the information being reported by the other project manager is incorrect. Project managers are required by the PMI Code of Ethics to follow project processes and policies and report timely and accurate information. Further, project managers are also requires to report to appropriate management when they observe others failing to uphold relevant policies, processes. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "e5e7de79-b8a8-4ad1-828e-c9c32582f766",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 50,
      "title": "A project manager is explaining to the stakeholders how the new project will mainly focus on the intangible benefits. To provide a better explanation, the project manager wants to give an example of an intangible benefit.\n\nWhich of the following is best for the project manager to use as an example?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Monetary assets"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Stockholder equity"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Market share"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Brand recognition"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The question divides potential benefits of a project into two groups, tangible and intangible. Tangible benefits are those that can be relatively easily expressed in monetary value, for example, anything that results in the production of a material, software, or service adds value to the organization’s assets, increases stockholder equity, and so on. Intangible benefits are those that cannot be directly and easily expressed in monetary value, however, in the long-term can bring value to the organization. Examples of intangible benefits could be brand recognition, public benefit, or trademarks. [PMBOK Guide  Sixth Edition, Page(s) 7]"
    },
    {
      "id": "6235bba5-7e67-4e09-8807-9f63fdcb7a0a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 51,
      "title": "You are managing a project that requires an environmental permit to do work. The approval is in the final stages when a confidential, reliable report is brought to your notice. The report indicates there is a high risk of an environmental hazard due to the project. Your manager tells you it is better to keep quiet at this stage since losses from terminating the project might be very high. You must:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Wait for the project to start and see if the information in the report is true"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Keep quiet about the matter since you will follow your manager's instructions"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Inform the necessary authorities of the hazard, even if it means cancelling the project"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Send an email to your manager documenting the matter and disowning ownership of the project"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The best option is to inform the necessary authorities about the report so that the right decision can be made, even if it means the project will be cancelled. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "83c1c586-6528-4cf7-a91d-21d9fbae0c40",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 52,
      "title": "A Project Manager for a construction firm meets with stakeholders. All stakeholders agree on a 20 month lifecycle for a project. After work has begun, the Project Manager learns that stakeholders would like project completion within no more than 16 months.\n \nWhat should be the first step in the Project Manager’s response?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Meet with key stakeholders to discuss ways to reduce some project requirements."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Add team members to work more quickly just this one time in order to satisfy stakeholder requirements."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Refuse to modify the time line, explaining that scope creep should be discouraged."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Identify agreed-upon tasks in the original project and assign additional duties as needed to meet the new, shorter timeline."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "If it is possible to reduce the requirements for a project with the sponsor and key stakeholders, this is preferred over crashing, fast-tracking, change-control, and other methods which will most likely increase risk and create issues with a shortened timeframe. [PMBOK® Guide Sixth Edition page 177-178]"
    },
    {
      "id": "91f6e104-79a6-4d58-bb47-34e29e8cf436",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 53,
      "title": "On October 3rd (represented by the red line in the Gantt chart below), the project sponsor calls you to check on the project's progress and stresses that the project cannot go over the originally planned budget. You want to determine the cost performance that must be maintained for the remainder of the project to achieve the original project budget. The method used to determine the earned value is based on percent complete.\r\n\r\nWhat is the project's current TCPI based on the original budget, and what does this mean for the project?",
      "description": "",
      "image": "https://storage.pmcbd.net/uploads/question/aaff832a-6844-42d1-b108-ee27a0d1c70d.jpg",
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The current TCPI is 1.15, and corrective action is required to meet the original budget."
          },
          {
            "k": "B",
            "s": 2,
            "t": "The current TCPI is 1.15, and no corrective action is required."
          },
          {
            "k": "C",
            "s": 3,
            "t": "The current TCPI is 0.87, and corrective action is required to meet the original budget."
          },
          {
            "k": "D",
            "s": 4,
            "t": "The current TCPI is 0.87, and no corrective action is required."
          },
          {
            "k": "E",
            "s": 5,
            "t": "None"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The question is asking to calculate the to-complete performance index (TCPI) based on the original budget. In other words, what is the efficiency that must be maintained to complete the project on plan. The TCPI can be calculated as (BAC - EV) / (BAC - AC), where BAC is budget at completion, EV is earned value, and AC is actual costs. The BAC for this project can be determined by the summation of the planned values for each of the individual activities listed in the chart, which is:\n\n$500 + $1,000 + $5,000 + $1,000 + $500 = $8,000\n\nThe EV is the sum of the planned work completed for each activity multiplied by the percentage of completion of the corresponding activity. Note, since the scenario mentions that the method used to determine the earned value is based on percent complete, the earned value of a partially completed work package is calculated by multiplying the planned value of the work package by its the percent complete:\n\n  * 100% for System Analysis\n  * 75% for System Design\n  * 50% for System Development\n\nEV = (100% * $500) + (75% * $1,000) + (50%  * $5,000) = $500 + $750 + $2,500 = $3,750\n\nThe AC is the sum of the costs for the first three activities:\n\n  * $600 for System Analysis\n  * $500 for System Design\n  * $2,000 for System Development\n\nAC = $600 + $500 + $2,000 = $3,100\n\nTCPI = (BAC - EV) / (BAC - AC) = ($8,000 - $3,750) / ($8,000 - $3,100) = 0.87\n\nThe TCPI value of less than 1 indicates that the project is currently on track to complete under budget, and there is some room for the current cost performance to slip without running over budget. With the project running under budget, the cost performance should continue to be monitored, but there is no reason for corrective action at this time.\n\nNote that TCPI can also be calculated using an estimate at completion (EAC). Since the question indicates that the original budget is still valid and must be met, the EAC was not used in the calculation nor was it provided in the scenario.\n\nAlso note, the sponsor is concerned only with the budget. Nothing in the scenario refers to the schedule which may or may not be met."
    },
    {
      "id": "aa27564f-dd50-41c5-a00d-fe9eb8fd8642",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 54,
      "title": "Your organization requires a comprehensive business analysis activity to precede project initiation for all complex and high value projects. In complex and high value projects, which of the following activities will typically be performed by a business analyst prior to the project initiation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Finalize the project scope statement and the WBS dictionary"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Determine problems, identify business needs and viable solutions"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Establish the project’s scope baseline"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Define project scope and develop WBS"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Typical business analyst’s responsibilities would include determining problems, identifying business needs, and recommending viable solutions for meeting those needs. [PMBOK® Guide 6th edition, Page 132]"
    },
    {
      "id": "5f2096f4-a504-4691-aa07-e7f879630ff3",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 55,
      "title": "Large organizations typically manage a wide range of projects; from small projects to large initiatives requiring long-term commitments. Which of the following factors can be used in scaling such projects:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Team size, geographical distribution and regulatory compliance."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Team size, geographical distribution, regulatory compliance, organizational complexity and technical complexity."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Team size, geographical distribution, regulatory compliance, organizational complexity, technical complexity, and funds availability."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Team size, geographical distribution, regulatory compliance and organizational complexity."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "In large organizations, there may be a mixture of small projects and large initiatives requiring long-term commitments to manage these programs using scaling factors such as team size, geographical distribution, regulatory compliance, organizational complexity, and technical complexity. Funds availability is a constraint applicable to all projects. [PMBOK® Guide 6th edition, Page 178]"
    },
    {
      "id": "0e68c8b0-d314-4171-8dcd-a14938448408",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 56,
      "title": "Your manufacturing project is contractually required to complete on a specific date. No additional funding or work is permitted beyond that date. You have just discovered a quality problem that affects less than 1 percent of the product produced by this project. Identifying the cause and implementing corrective action will cause the project to complete after the contract deadline. What do you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Compress the schedule"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Do nothing"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Notify the project stakeholders immediately"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Fast track the project"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Report this to the project stakeholders immediately. Once they are notified, a plan forward can be developed within the terms of the contract. Project managers are bound by the code of ethics to disclose accurate and timely information about the project. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "767ba064-1e62-4a51-ac58-b24507f59284",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 57,
      "title": "An organization structured in such a way that it only manages to contribute a subset of the aspects required for delivering value to customers is known as:",
      "description": "",
      "image": "https://storage.pmcbd.net/uploads/question/da9fc3b1-a23d-4c1f-bf4f-2549c9bbb1b2.jpg",
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Projectized organization"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Matrix organization"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Value-driven organization"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Siloed organization"
          }
        ]
      },
      "explanation_image": "https://storage.pmcbd.net/uploads/question/e8db2664-6cdb-45b9-a2fb-579bd70e626c.jpg",
      "correct_answer": "D",
      "explanation": "An organization that is structured in such a way that it only manages to contribute a subset of the aspects required for delivering value to customers is known as a siloed organization. [Agile Practice Guide, 1st edition, Page 154]"
    },
    {
      "id": "f94a1279-1814-4aa2-9dbf-8b1f7110d177",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 58,
      "title": "Rather than formalizing an entire contracting relationship in a single document, Agile teams recommend documenting the mostly fixed items in a master agreement and separating all other items subject to change. Isolating the more changing elements of a contractual relationship:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Simplifies modifications and thus flexibility."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Over-simplifies contracting and thus increases risk."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Complicates contracting and thus decreases risk."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Encourages modifications and thus makes the contract redundant."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Isolating the more changing elements of a contract into a single document simplifies modifications and thus flexibility. [Agile Practice Guide, 1st edition, Page 77]"
    },
    {
      "id": "1ae47574-e46b-430e-8b20-ec49a654a614",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 59,
      "title": "You are trying to decide on a way to implement a company-wide initiative. A proposed solution costs $120 million but has a 60% chance of saving $200 million and a 40% chance of saving only $90 million.\n\nWhat does $36 million represent?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Level of confidence that you will save $200 million"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Net path value for saving $200 million"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Expected monetary value (EMV)"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Earned Value (EV)"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "EMV for a project is calculated by multiplying the value of each possible outcome by its probability of occurrence and adding the products together. A common use of this type of calculation is in decision tree analysis, a technique used in the Perform Quantitative Risk Analysis process.\n\nGiven the details in this scenario, the solution has a chance of having two quantified outcomes. For each outcome, you multiply the probability by the impact value, accounting for the amount that must be invested in the solution.\n\nNet Path Value 1 = 0.60 x (200-120) = 0.60 x 80 = 48\nNet Path Value 2 = 0.40 x (90-120) = 0.40 x -30 = -12\n\nThen, to calculate the expected monetary value of the proposed solution, you add the two net path values together. If one of the values is negative, of course, you subtract.\n\nExpected Monetary Value = 48 - 12 = $36 million [PMBOK Guide) Sixth Edition, Page(s) 435]"
    },
    {
      "id": "e395b5c0-ec2d-4254-b97c-ccfb872c2af6",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 60,
      "title": "For a complex project with a loosely defined scope, which of the following contracting approaches can help an Agile team define a contractual relationship in a way that the team gets control over the expenditure while at the same time limiting the supplier’s financial risk of over-commitment?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Aggregating the scope into a time & materials contract."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Decomposing the scope into cost-reimbursable macro-deliverables."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Decomposing the scope into fixed-price micro-deliverables."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Aggregating the scope into a fixed-price contract."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "A fixed price contract will hedge the buyer’s risk but will not limit the supplier’s financial risk. On the other hand, a time & materials or a cost-reimbursable arrangement will not give the buyer any control over the cost. The recommended approach is to decompose the project scope into fixed-price micro-deliverables, such as user stories. For the buyer, this gives more control over how the money is spent. For the supplier, it limits the financial risk of over-commitment to a single feature or deliverable. [Agile Practice Guide, 1st edition, Page 77]"
    },
    {
      "id": "61250fe8-399a-4bf0-a921-2bb9c30ad952",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 61,
      "title": "Your current project has a 12-month timeline and a budget of $100,000. You are 6 months into the project, and you have spent $60,000, but only 40% of the work is complete. You do not anticipate that the cost performance will change and you estimate that the project will eventually spend $150,000 at its completion.\n\nWhich of these statements is true about your project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The estimate to complete this project is $150,000."
          },
          {
            "k": "B",
            "s": 2,
            "t": "There is not enough information given to evaluate the project."
          },
          {
            "k": "C",
            "s": 3,
            "t": "To complete the remaining work, your team needs to have a cost\nperformance of 67%."
          },
          {
            "k": "D",
            "s": 4,
            "t": "The schedule efficiency of your team is 70% of the rate originally planned."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The total budget or BAC = $100,000. A budget for the project can be seen as its planned value (PV). The cost so far or AC is $60,000. You have completed 40% of the work which is the EV or 40% of $100,000 or $40,000. To find the correct answer, you will have to calculate the earned value analysis parameters provided in three out of the four answer choices. The correct answer is the calculation of the TCPI. Based on the scenario, \"you estimate that the project will eventually spend $150,000 at its completion\" implying the estimate at completion (EAC) is $150,000. Therefore, the calculations are as follows:\n\nTCPI = (BAC - EV) / (EAC - AC) = (100,000 - 40,000) / (150,000 - 60,000) = 60,000 / 90,000 = 0.67 meaning your team needs to maintain a cost performance of 67% to complete the project with the current EAC. [PMBOK Guide Sixth Edition, Page(s) 266-267]"
    },
    {
      "id": "fabaeb8f-f2d5-4756-965f-9cfae72314c4",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 62,
      "title": "You are conducting a feasibility analysis of multiple available options to deliver a certain capability to the organization. Each of the available options involves an upfront initial investment followed by periodic maintenance costs. Further each option promises a different revenue stream for the business. Which of the following analytical techniques evaluates investment potential considering time-value of money?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Discounted cash flow"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Pareto analysis"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Monte Carlo technique"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Earned value management"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Discounted cash flow analysis uses future free cash flow projections and discounts them to arrive at a present value estimate, which is used to evaluate the potential for investment. The rest of the choices are incorrect because Pareto analysis is carried out to identify the most significant factors out of many; earned value management is carried out to monitor and control cost of an ongoing project; while the Monte Carlo is a simulation technique used to analyze project risks. [PMBOK® Guide 6th edition, Page 473]"
    },
    {
      "id": "291ecc87-4761-435d-ba53-a782007cd6c7",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 63,
      "title": "Your sponsor has committed to building a high-speed rail from one major inland city, Azules, to the coast. You have two possible routes, either Brazos or Corazon. You draw a decision tree that considers each route's costs, odds, and rewards of high demand and low demand. At this point, you do not want to calculate the expected monetary value. Rather, you want to find the net path value of each route to Brazos.\r\n\r\nHow would you quantify the two net path values of the route to Brazos?",
      "description": "",
      "image": "https://storage.pmcbd.net/uploads/question/a1352bdc-6ad3-4e03-a2e4-677aae76909a.jpg",
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "22 billion and 16 billion"
          },
          {
            "k": "B",
            "s": 2,
            "t": "2 billion and -4 billion"
          },
          {
            "k": "C",
            "s": 3,
            "t": "9.6 billion and 1.2 billion"
          },
          {
            "k": "D",
            "s": 4,
            "t": "1.6 billion and 0.8 billion"
          },
          {
            "k": "E",
            "s": 5,
            "t": "None"
          }
        ]
      },
      "explanation_image": "https://storage.pmcbd.net/uploads/question/2bb4bdd7-6ded-4ce5-9749-6523754236d9.jpg",
      "correct_answer": "B",
      "explanation": "The net path value is an important calculation in quantifying the expected monetary value when performing decision tree analysis as part of the Perform Quantitative Risk Analysis process. Note, the net path value is different from the expected monetary value (EMV). The calculation of the EMV takes into account the probabilities of each branch, while the net path value simply subtracts the investment (which is typically expressed as a negative value) from the value of the node (which is typically expressed as a positive value). The net path value is used in the formula for estimated monetary value for each decision. Also note, the net path value is not to be confused with the net present value.\n\nRemember: when you net something, you should consider both positive and negative flows. In a decision tree, the formula to compute net path value is to subtract the path reward minus the cost of the decision.\n\nThe question is asking to calculate the two net path values of the route to Brazos. Based on the calculations provided, the two net path values of the route to Brazos are 2 billion and -4 billion."
    },
    {
      "id": "996528ce-66c5-4594-b37c-4811402b0629",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 64,
      "title": "A Project Manager receives the following for a new project:\n\n-assumptions\n-restrictions\n-preliminary scope\n \nAfter receiving this information, what should the Project Manager do first?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Review and understand the business case and project goals."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Put together the project team and assign project tasks."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Build the project schedule and determine the critical path."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Ensure project charter approval is obtained from the sponsor."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The business case and project goals need to be understood first before a charter can be written. Building a team and a schedule come later in the process. [PMBOK® Guide Sixth Edition page 30-32]"
    },
    {
      "id": "b882cc99-1c87-4f13-a861-855128714d98",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 65,
      "title": "A project manager was involved in preparation of the project charter for an external project. One of the inputs to the project charter was a statement of work (SOW). The SOW may have been received from the customer as part of any of the following except:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "As part of a contract"
          },
          {
            "k": "B",
            "s": 2,
            "t": "As part of the business case"
          },
          {
            "k": "C",
            "s": 3,
            "t": "As part of a request for proposal"
          },
          {
            "k": "D",
            "s": 4,
            "t": "As part of a request for information"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The statement of work (SOW) is a narrative description of products or services to be delivered by the project. For an external project, the SOW may be received as part of a bid document such as the request for proposal, request for information, request for bid or as part of a contract. It is usually not part of the business case. [PMBOK® Guide 6th edition, Page 477]"
    },
    {
      "id": "3e021eac-bf4e-4dac-a0f8-873bee3758d4",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 66,
      "title": "Traditional approaches govern vendor relationships by fixed milestones or phase gates focused on intermediate artifacts. On the other hand Agile approaches require: ",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Full deliverables of incremental business value."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Incomplete deliverables at the end of each iteration."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Partial but frequent deliveries."
          },
          {
            "k": "D",
            "s": 4,
            "t": "One delivery at the end of the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Agile approaches prefer working products/features rather than partially developed products/features. Incomplete or partial deliveries are not required as they don’t have business value. On the other extreme, one delivery at the end of the project is a waterfall approach. Agile teams focus on complete deliverables of incremental business value. [Agile Practice Guide, 1st edition, Page 77]"
    },
    {
      "id": "537d4af3-7d0a-4465-bccb-f2ddb9f66837",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 67,
      "title": "Agile approaches emphasize early and frequent delivery. However, this accelerated delivery might not suit some organizations due to their ability to accommodate rapid deliveries. If an organization resists a project’s outcome, which of the following risks becomes more likely to occur? ",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Project costs skyrocket."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Story points get doubled for each item in the backlog."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Scope creep becomes unmanageable."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Targeted return on investment is delayed."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "If an organization is resistant to the project’s outcome, the targeted return on investment is delayed due to initial challenges related to the organizational change management. The rest of the risks are not directly related to the problem at hand. [Agile Practice Guide, 1st edition, Page 73]"
    },
    {
      "id": "7b816fce-82af-435d-803b-157def85e2c8",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 68,
      "title": "You are building a dam for a state government. Your organization is considered a specialist in dam design and overall management of construction activities. However, your organization lacks resources to execute the earth-works involved. You have subcontracted all the project’s earth-works to a local subcontractor. The quality of the subcontractor’s work is acceptable, but the subcontractor is not conforming to your organization’s health and safety standards. You escalated this to the subcontractor’s project manager, but he turned down your request. The subcontractor’s project manager is of the view that the request is out of the contract’s scope and none of the contract provisions require him to conform to your organization’s standards. You are agitated since you believe health and safety standards are globally accepted, and the contract does not have to explicitly state them. Further, according to the state law, you cannot terminate the contract since the subcontractor has not violated any provision of the contract. What should you do?",
      "description": "",
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Negotiate a contact amendment with the subcontractor requiring compliance to the standards"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Withhold the subcontractor’s payments to force compliance"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Terminate the contract immediately since you will not compromise health and safety standards"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Go for judicial arbitration as stated in the contact’s ADR provisions"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Your actions should be legal and legitimate. Termination and withholding payments are illegal options. Further amicable solution is always preferred over arbitration. The best way to deal with this situation to offer a price for compliance to the required standards and amend the contract accordingly. [PMBOK® Guide 6th edition, Page 492]"
    },
    {
      "id": "8b576891-a957-412b-bc99-4655228b5322",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 69,
      "title": "An Agile team working on a data center migration project has accrued substantial technical debt. What should be done now?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Increase the team size."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Re-prioritize the backlog."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Develop a minimum viable product."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Drop stories from the backlog."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Technical debt refers to the deferred cost of work not done at an earlier point in the product life cycle. This is sunk cost and cannot be recovered. However, the team must ensure that the current product backlog is updated with current organizational priorities. [Agile Practice Guide, 1st edition, Page 154]"
    },
    {
      "id": "1461ab78-7a0f-447f-96dd-22761b55a079",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 70,
      "title": "A project sponsor is developing the project charter. She understands that the project would have to take into consideration conditions that are not under the immediate control of the project team.\n\nWhich of the following is an example of such conditions?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Project monitoring and reporting methods"
          },
          {
            "k": "B",
            "s": 2,
            "t": "An approved template of a project charter"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Legislation on overtime pay for the project team"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Historical information and lessons learned repository"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The question describes enterprise environmental factors (EEFs), which are conditions, not under the immediate control of the team, that influence, constrain, or direct the project. These conditions can be internal and/or external to the performing organization. EEFs are one of the inputs to the Develop Project Charter process. The legislation, which imposes overtime pay is an example of a legal requirement which is not under the immediate control of the project team and is external to the organization. The incorrect answer choices represent organizational process assets. Among the available options, only the legislation that may impose overtime pay for the project team represents a constraint that is considered an enterprise environmental factor. [PMBOK Guide Sixth Edition, Page(s) 78]"
    },
    {
      "id": "7a66c46b-2b0d-4db1-9659-c7288e2eb16b",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 71,
      "title": "You are leading a state-of-the-art technology development project that requires some programming skills that are rare in the market. You hired a programmer that has some basic skills in this domain and you expected that the resource will come up to speed with a little training. However, once the programmer started, it became clear that you need to hire an expert. You can still utilize this resource on other activities but the project budget is limited to accommodate hiring an expert. What should you do resolve this issue?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Issue a change request."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Update the issue register."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Document this as a project risk."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Talk to the programmer in person."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The scenario makes it clear that it is now a budget issue. You need to analyze the costs of hiring an expert along with other schedule impacts due to hiring time requirements and a new resource coming up to speed, etc. Once you quantify all these impacts, you need to issue a change request seeking the adjustments to project baselines. [PMBOK® Guide 6th edition, page 83]"
    },
    {
      "id": "948b80e3-4a1f-4d6f-b16c-f14c1e583b4e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 72,
      "title": "You have recently been successful in passing the Project Management Professional exam. Others within the organization you work for are also pursuing the certification and have sought your assistance. They have requested that you provide them with a detailed list of the questions that you had on the exam. What is the FIRST course of action you should take?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Indicate that you cannot disclose questions you saw on the exam"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Pretend you do not recall any of the questions"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Offer your coworkers a listing of all the questions you recall from the exam"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Report the violation to the PMI"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The first course of action is to indicate that you cannot disclose questions you saw on the exam. PMI requires the candidates and those seeking certification to maintain and respect the confidentiality of the contents of the PMP examination. The PMI code of conduct mandates respecting copyrights of others. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "fe32f86c-6f1f-4dc7-bf71-0921efef8f44",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 73,
      "title": "Andy’s project stakeholders are not happy as the project is lagging behind schedule. During the executive committee meeting, Andy requests all stakeholders to keep their calm as most of the project deliverables have been completed and only quality inspections of these deliverables is pending. He assures the stakeholders that he is planning to crash the project to meet the completion deadline. What should be the stakeholders’ biggest concern now?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Crashing at this stage might result in an exponential cost increase and more time will be required to recover that cost."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Crashing at this stage might result in undetected errors, decreased profits, and increased post-implementation risks."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Stakeholders do not know the PMBOK® Guide jargon; crashing is a valid schedule compression technique."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Why Andy hasn’t chosen to fast-track the project instead of crashing the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Meeting project schedule objectives by rushing planned quality inspections may result in undetected errors, decreased profits, and increased post-implementation risks. The other choices are incorrect. [PMBOK® Guide 6th edition, Page 273]"
    },
    {
      "id": "97eaf42a-9027-432d-99e5-ab6020a1519f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 74,
      "title": "Your project requires reporting cost performance based on both direct and indirect costs accrued by the project. This is the first time the organization has demanded the inclusion of indirect project costs for monitoring and reporting purposes. If the management approach proves successful, this will be then mandated on all future organizational projects. How would you classify the cost of electric utilities for your office?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "An indirect cost"
          },
          {
            "k": "B",
            "s": 2,
            "t": "A direct cost"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Appraisal cost"
          },
          {
            "k": "D",
            "s": 4,
            "t": "A specific cost"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The cost of electric utilities for the office would be considered as an indirect cost. Indirect costs are also known as overhead, general, or administrative costs. They are the costs allocated by the project team as a cost of doing business. Examples include salaries of management indirectly involved in the project and the cost of electric utilities. [PMBOK® Guide 6th edition, Page 246]"
    },
    {
      "id": "1d9e3900-9e19-4b70-9f8a-3859becf0093",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 75,
      "title": "You are managing an Agile software development project and currently engaging with the product owner to refine the product backlog. What should be your prime focus during this activity?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Selecting highest value requirements."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Reviewing processes."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Collecting business requirements."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Optimizing project costs"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "In Agile, the product owner creates the backlog for and with the team. The backlog helps the teams see how to deliver the highest value without creating waste. [Agile Practice Guide, 1st edition, Page 41]"
    },
    {
      "id": "77de58f2-5c55-4da0-b742-794072f64b48",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 76,
      "title": "Joe, a member of another project team, advised Marilyn that he was concerned the final requirements document released by the project manager intentionally misrepresented the requirements gathered. Joe stated that many requirements included had only a plurality of supporters. Corporate project management methodology specifies that plurality support is the minimum level of support for requirements. What should Marilyn do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Report the project manager to his or her manager. Requirements must be supported by more than 50 percent of the team."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Do nothing. The corporate methodology permits decisions to be made by a plurality, rather than a majority. A plurality decision is based on the largest block of supporters, even if that block is not a majority."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Notify the project sponsor there is a discrepancy and suggest a formal requirements review."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Discuss the issue with another project manager."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "There is no wrongdoing in this scenario, so no action is required of Marilyn. Using a plurality to determine requirements is consistent with the company's project management methodology. PMI's code of ethics requires project managers to follow all policies, rules, and regulations. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "22d6d5d4-d00d-459d-8d94-19bc2c6e80f9",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 77,
      "title": "Midway into project execution, new cybersecurity laws take an immediate effect and require audits of the system. The project has a well thought out project management plan. The audits may come at any time throughout the system’s development.\n\nWhat is the best way for the project manager and team to address the risk of audits disrupting the project plans?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Handle the audits as an unplanned spike"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Reschedule the audits to the end of the project"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Request that the sponsor removes the audits"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Inform stakeholders that the project will miss its objectives"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Plan-driven managed projects can utilize some of the tools and techniques from agile methodology to support their project management. Incorporating agile methods with traditional plan-driven methods would make the overall project management approach hybrid. In the scenario described, the project team could use the agile technique of a spike. A spike is a short timeboxed effort established to address a risk, explore possible solutions, answer a question, or gather information, to name but a few common examples. While this may sound counter-intuitive, of the choices provided, addressing the audit as a spike is the best answer to the question asked. [PMBOK Guide Sixth Edition, Page(s) 48-49; Agile Practice Guide - First Edition, Pages(s) 53, 56, 154]"
    },
    {
      "id": "c66ee8ec-5ddc-46fc-8a53-2747608fc7e4",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 78,
      "title": "You are managing a project for a company that in conjunction with another vendor has been contracted by a client to develop a customer relationship management (CRM) system for their business. Early in project execution, the client terminates the other vendor for undisclosed reasons and asks if your company can complete the entire project. You had recognized and analyzed this scenario during project planning, and now this opportunity has materialized.\n\nWhat should you do first?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Check the risk register for a risk response plan"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Accept the opportunity and ask for an addendum to the existing contract"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Seek an expert opinion to determine whether or not to accept the opportunity"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Submit a change request to update the project management plan and baselines"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The question indicates that you, as the project manager, had recognized and analyzed the possibility of taking over the entire project during project planning, which implies that this risk had been documented in the risk register along with its agreed-upon risk response. Keep in mind that risks can either be threats (negative risks) or opportunities (positive risks). In the scenario described the risk is considered an opportunity. Realized risks (either negative or positive) should trigger the Implement Risk Responses process. The risk register serves as an input to the Implement Risk Responses process and records the agreed-upon risk responses for each individual risk and the nominated owners for each response plan. Therefore, of the available answer choices, checking the risk register for a risk response plan is what you should do first. [PMBOK Guide Sixth Edition, Page(s) 397, 450]"
    },
    {
      "id": "75805e90-a344-4eed-b084-5289e2b77eac",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 79,
      "title": "Your organization has submitted bids for multiple projects at the department of defense and luckily has won most of the projects. Although this is a time for celebration, you are concerned about the organization’s ability to execute all of the projects at the same time due to resource availability. Project schedules were submitted as part of the bids and now it is your contractual obligation to start all of the projects in the next few weeks. Further, you are not allowed to subcontract the projects due to security issues. How shall you deal with this situation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Subcontract any work that your organization was doing prior to winning these new projects so that all organizational resources can now be allotted to the new projects."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Analyze the awarded projects and organizational capabilities and pull out from the projects that cannot be delivered according to your commitments."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Start all of the projects and distribute all available resources between them. The projects will struggle initially but overcome this problem by acquiring new resources and get them to speed as soon as possible."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Subcontract small parts of projects’ scope. That should be all right as you are not subcontracting the entire project scope."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "It is not only your contractual obligation but your ethical and moral duty to be fair and transparent with your clients. If you know that you won’t be able to meet your contractual obligations, you should not undertake such engagements. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "19bd9043-009c-4ebd-9b27-7bf9a01dd13e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 80,
      "title": "In a manufacturing project, you have requested bids to procure stainless-steel products. However, your sponsor insists that you conduct bidder conferences before selecting sellers. What mandatory standard in the PMI Code of Ethics and Professional Conduct is met by conducting bidder conferences?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Responsibility"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Honesty"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Fairness"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Respect"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Bidder conferences or vendor conferences are used to provide a clear understanding of the procurement process to all prospective sellers. This process ensures that the mandatory standard of fairness is followed in the bidding process. Fairness in this case means making opportunities equally available to all qualified candidates. [PMBOK® Guide 6th Edition, Page 487 and PMI Code of Ethics and Professional Responsibility]"
    },
    {
      "id": "9e3eb21f-b1f1-4d30-ae89-c492131e259c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 81,
      "title": "Which of the following approaches deliberately spends less time trying to define and lock project scope early during the project and spends more time establishing the process for requirements gathering, scope definition and refinement?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Kanban methods"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Waterfall methods"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Agile methods"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Predictive methods"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Agile methods deliberately spend less time trying to define and lock project scope early during the project and spend more time establishing the process for requirements gathering, scope definition and refinement. [PMBOK® Guide 6th edition, Page 133]"
    },
    {
      "id": "30adcf8d-6610-497d-912e-379bb8209b65",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 82,
      "title": "You are managing a project to manufacture 3,000 fence posts for a customer. The customer has called you to refuse the first shipment of posts they received because the weight was more than defined in the contract. The increased weight will likely increase your customer’s fuel costs to distribute them to their own customers. The customer is demanding the posts be remanufactured. What do you tell your project stakeholders?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Nothing, you can cover the cost from the project contingency reserves."
          },
          {
            "k": "B",
            "s": 2,
            "t": "There was a failure in quality control processes."
          },
          {
            "k": "C",
            "s": 3,
            "t": "The contract should be renegotiated."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Keeping shipping costs low were not a requirement for your project, so no rework was required."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Tell your project stakeholders there was a failure in quality control processes, and as a result the fence posts were outside the acceptable control range. Project managers are required by PMI's Code of Ethics to acknowledge and accept responsibility for their errors and omissions; in this situation the error was the failure to control the quality program. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "922cda76-f378-469e-8c10-9ed606e1029a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 83,
      "title": "On your construction project, you are eight weeks away from achieving a milestone for which your client will award you a $10,000 bonus. However, the workers union of your supplier has announced a strike. If your supplier cannot settle the dispute within three weeks, the supply interruption could delay your project. There is a 20% chance the strike exceeds three weeks, and you predict the delay will cost $50,000.\n\nWhat is the expected monetary value (EMV) of this risk?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "(-$2,000)"
          },
          {
            "k": "B",
            "s": 2,
            "t": "$18,000"
          },
          {
            "k": "C",
            "s": 3,
            "t": "$50,000"
          },
          {
            "k": "D",
            "s": 4,
            "t": "250000"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The expected monetary value (EMV) is often used in decision tree analysis as part of the Perform Quantitative Risk Analysis process. EMV is calculated by multiplying the impact of each possible outcome by its probability of occurrence and adding the products together. Opportunities or potential gains are taken as positive values, while threats or potential losses are taken as negative values. In this scenario, you need to find both the threat and the opportunity for the risk described:\n\n  * There is a 20% chance that you will lose $50,000.\n  * There is an 80% chance that you will achieve the milestone that allows you to claim a $10,000 bonus.\n\nUsing the EMV formula:\nEMV = (-$50,000 x 20%) + ($10,000 x 80%) = -$10,000 + $8,000 = -$2,000.\n\nSome users wonder as to where did the number 80% come from. Here is why: the scenario indicates that there is a 20% chance the strike exceeds three weeks. This implies that there is an 80% chance (100% - 20% = 80%) that the strike does not exceed three weeks. Therefore, there is a 20%\nchance of a $50,000 loss and an 80% chance of getting the $10,000 bonus. [PMBOK Guide  Sixth Edition, 2017, Page(s) 435]"
    },
    {
      "id": "bd12a12f-e63f-4f89-8dd7-a9d333a1c905",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 84,
      "title": "In preparation for an upcoming project status meeting, you have determined the value of the work completed thus far is $100,000 with a budget at completion (BAC) of $1,000,000. At this point in the project, you have spent 12% of the project budget. The value of work planned to be completed at this point is $115,000.\n\nWhat will you report at the project status meeting?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The project is performing well in terms of cost but not in terms of schedule"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The project is not performing well both in terms of cost and schedule"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The project is currently behind schedule"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The project is currently over budget"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "To determine the status of the project, the schedule variance and cost variance (or, alternatively, the cost performance index (CPI) and schedule performance index (SPI)) must be calculated. The earned value (EV), which is the actual work completed in the scenario described, is stated as $100,000. The planned value (PV), which is the value of work planned to be completed at this point in the scenario, is stated as $115,000. The actual cost (AC), which is the portion of the project budget you have spent so far in the scenario described, is 12% of the budget of $1,000,000 which is $120,000. The calculations of the cost variance (CV) and the schedule variance (SV) are shown below:\n\nCV = EV - AC = $100,000 - $120,000 = -$20,000\nSV = EV - PV = $100,000 - $115,000 = -$15,000\n\nBoth the schedule variance and the cost variance are negative at this point in the project. Therefore, at the project status meeting, you should report that the project is not performing well both in terms of cost and schedule.\n\nAlternatively, you can calculate the CPI and the SPI:\nCPI = EV / AC = $100,000 / $120,000 = 0.83\nSPI = EV / PV = $100,000 / $115,000 = 0.87\n\nBoth the schedule variance and the cost variance are less than 1 at this point in the project. Therefore, the same conclusion can be made: the project is not performing well both in terms of cost and schedule.  [PMBOK Guide Sixth Edition, Page(s) 267]"
    },
    {
      "id": "ca6edb51-af8d-4833-88d8-648569186124",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 85,
      "title": "You are managing a hazardous waste cleanup project at a manufacturing plant. A major milestone is due to be complete in two weeks. Based on your project plans filed with a municipal authority and a federal agency, both authorities have notified you that their inspectors will visit the site the week after your milestone.\n\nTo avoid fines, rework, and related delays, what is your best course of action?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Ask the agencies to postpone their inspections another week"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Invite the inspectors to a milestone party to win them over"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Hold sitewide training to get your staff ready to inspect"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Conduct an equivalent inspection to verify the deliverables"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The Control Quality process is concerned with the correctness of the work and meeting quality requirements. Verified deliverables are an output of this process and an input to the Validate Scope process which will be carried out by the project team together with the municipal\nauthority and the federal agency to determine if the acceptance criteria have been met. Inspections can be used among the tools and techniques of both the Control Quality process and the Validate Scope process. Therefore, prior to the inspection of the Validate Scope process, to avoid fines, rework, and related delays, and verify the deliverables, conducting an equivalent inspection as part of the Control Quality process is the best course of action for you, as the project manager, to take. [PMBOK Guide  Sixth Edition, Page(s) 166, 303, 305]"
    },
    {
      "id": "f5298fdd-ea36-43a6-b8c3-40578f8cbc76",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 86,
      "title": "A customer indicates that they would like to add functionality. Although this request is made during the execution phase of the project, the Project Manager finds that the cost for the addition would be small. The additional functionality, if successful, would increase the opportunity for profit. \n \nWhat should the Project Manager do next?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Agree that the functionality would offer a great opportunity, but the proposed addition is out of scope."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Schedule a meeting with the company's management team, and present the customer's request for additional functionality as a good opportunity."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Move forward, using the project's management reserve to add the requested functionality."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Identify an already-developed feature that could be combined with the new functionality, and use the combination to meet the customer's request."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "By building a small increment and then testing and reviewing it, the team can add value in terms of new functionalities or additional awarded projects. Important factor for a successful implementation and value capture is the response time of the team [PMBOK® Guide Sixth Edition Project and Development Life Cycles, page 19]"
    },
    {
      "id": "45955461-5221-4a43-9e98-23ff1f9f9efd",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 87,
      "title": "All requested changes to a contract go through Contract Change Control Systems of both parties. The Contract Change Control system documents all requested changes for future reference. However, requested but unresolved changes might not make it up to either party’s Change Control Systems. If you are contesting a dispute, where can you find a record of such requested changes?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Project correspondence"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Project management plan"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Approved change requests log"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Procurement management plan"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "If a contract change request is rejected early in the process, it might not make it up to either party’s change control system and hence might not get documented as a rejected change request. You can obtain a record of such requested changes in your project’s correspondence with the customer in this case. [PMBOK® Guide 6th edition, Pages 496, 499]"
    },
    {
      "id": "e68aba10-cb98-492d-82d7-d34e4e394859",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 88,
      "title": "A project manager gives monthly status updates to the key stakeholders. After every status update meeting, a copy of the presentation, the updated action tracker, and the stakeholder feedback must be:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Emailed to all the participants of the meeting"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Emailed to the project sponsor"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Updated to the project management information system"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Added to the project folder as an organizational process asset"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "All of the choices are actions that can be performed next. However, emailing the mentioned documents to the stakeholders and the project sponsor depends on their needs and the communication management plan requirements. Further, updating the project management information system is conditional on the availability of the system. Hence, these three actions may or may not be done. However, adding a copy of these documents to the project folder is an absolute must for the project manager. [PMBOK® Guide 6th edition, Page 388]"
    },
    {
      "id": "e1b985ad-4517-4742-86ac-0006d69f0fc0",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 89,
      "title": "A project manager is in the process of determining the budget for a new project that will acquire specialty parts from an overseas vendor to reduce the cost. Recently, the government of the country where the vendor is located announced a change in economic policy that involves sharply increasing their money supply to stimulate their economy.\n\nWhat should the project manager do in this situation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Modify the business case"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Increase the management reserves"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Account for changes in the exchange rates"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Change the organization's budget policies"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Any significant changes in a country's economic policy would likely affect the currency exchange rates. As a result, the cost of goods bought from that country would also change. When relying on goods from abroad, the fluctuations of currencies need to be understood and built into the Determine Budget process. Therefore, in this situation, the project manager needs to account for changes in the exchange rates when determining the project budget."
    },
    {
      "id": "3448c062-fa47-49fb-932d-c7ea9fd2256e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 90,
      "title": "During a challenging shareholder meeting, the customer indicates that they will reject an iteration's deliverable. \n \nWhat should the Project Manager do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Send a request to the project sponsor, asking them to update the project charter then reassign the responsibilities and authorities."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Meet with the project team to add new and improved features to replace the features that were rejected."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Work with stakeholders to create a shared approach that will address the issues of concern."
          },
          {
            "k": "D",
            "s": 4,
            "t": "File a change request with the change control board (CCB) in order to add budget to the baseline."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Project managers should engaging stakeholders at appropriate project stage to obtain, confirm, or maintain their contined commitment to the success of the project.  [PMBOK® Guide Sixth Edition page 524]"
    },
    {
      "id": "b1a97cea-5864-4c90-a2c4-efbd0bb39e2b",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 91,
      "title": "Marvin has worked for a retail company as a project manager. With his positive thinking and strong managerial skills, he turned many potentially disastrous projects into successes. Because of his expertise, his employer’s senior executives offered him a group project manager position for a newly started environmental project. However, Marvin learned that, in his newly assigned project, he might have to offer bribes to obtain government licenses. What should Marvin do in such a situation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Accept the position and offer bribes because project managers must complete projects on time and within budget"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Reject the offer because project managers should not engage in an unethical conduct"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Investigate to find out if it is customary to offer bribes in that part of the country"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Accept the offer because project managers must obey their higher-ups"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Project managers must adhere to the code of ethics and professional conduct. They must maintain fairness and honesty. Since the new job requires some illegal and unethical activities, Marvin must reject the offer. [PMI code of Ethics and Professional Conduct]"
    },
    {
      "id": "6c223130-fce0-4bb5-ab15-ee5a7f8558ec",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 92,
      "title": "During a highly-regulated project, the project sponsor and a high-level executive have asked for changes that appear to disregard legal requirements. \n \nWhat should be the first step in the Project Manager's response?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Immediately schedule a meeting with the stakeholders to review the situation."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Send the change control board (CCB) a change request."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Check with the organization's relevant legal practitioner for guidance."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Review the organization's lessons learned database for precedents and direction."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "This is the best FIRST step before going to the CCB because this is a highly regulated industry [PMBOK Guide Sixth Edition (2018), Part 2 page 545; Project Managers Portable Handbook, 3rd Ed 6.3 Legal Considerations and Execution]"
    },
    {
      "id": "c2a9ce83-004e-4939-8011-df9baeab72c0",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 93,
      "title": "You are leading a project in a very difficult environment. A number of key stakeholders are resisting the outcome of the project. You escalated this issue to the sponsor but he is disengaged and unresponsive to requests to help clear the political roadblocks. How would you deal with this situation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Terminate the project in the best interest of key stakeholders."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Re-confirm the business value of the project and setup a meeting with the project sponsor."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Document this as a project risk and accept this risk."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Document this in the project’s issue register and issue a change request."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "You cannot resolve this issue unless you get to the root cause of this. You need to set up a meeting with the sponsor and try to understand the reason behind her disengagement. The project might have lost its business value so you need to re-evaluate that before you walk in to that meeting. [PMBOK® Guide 6th edition, page 528]"
    },
    {
      "id": "cb52f3d2-97b0-4e1b-aa97-51c559180a33",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 94,
      "title": "While creating the project charter, you review the business case and learn that, unlike previous projects, this project will source non-sustainable wood for the product, which substantially reduces project cost. Your company has had some financial difficulties lately, but you know it has high environmental standards and always marketed and prided itself on producing goods that are 'green'.\n\nWhat is your best course of action?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Update the business case to specify sustainable wood to be used in the\nproject"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Continue to create the project charter according to the business case"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Hold on the development of the project charter and ask the sponsor for\nadvice"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Specify in the project charter the use of a sustainable wood source"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "One of the project manager's responsibilities is providing recommendations and oversight to keep the project business case, project management plan, project charter, and project benefits management plan success measures in alignment with one another and with the goals and objectives of the organization. In this scenario, the company image for producing 'green' goods would be compromised if the non-sustainable wood was used in the product. Therefore, in order to uphold the company image, it is your job as a project manager to understand why the non-sustainable wood was prescribed for use in the business case. In the vast majority of our questions, consulting with the project sponsor is typically an incorrect answer. But not in this case. By contacting the sponsor and explaining your discovery to her, you can hopefully rectify the situation, making this the best answer to the question asked. [PMBOK Guide) Sixth Edition, Page(s) 29]"
    },
    {
      "id": "20ae9744-2f28-45bc-b7ab-5c4c159a6062",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 95,
      "title": "Joe has been managing a project for Exton Oil Corp. This project involves redesigning filling stations across the state. The redesign involves new gas pumps, security cameras, convenience stores, and use of environmentally friendly materials in the construction. While the redesigning work proceeds, Joe’s design engineer suggests a secondary alarm system for gas pumps to alert the attendant in case of a spill. Although this suggestion is not in the project requirements, Joe is impressed with the engineer’s recommendation. What should be the next step for Joe with regard to the engineer’s suggestion?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Reject his recommendation as it requires additional funding"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Create an issue log to document the engineer‘s suggestion for future use"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Initiate the formal change control process to find the impact of his recommendation"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Approve his recommendation and allocate resources and funds"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Change requests should always be recorded in written form and entered in the change management system to determine the impact of the change on the scope, budget, schedule and quality. Thus, Joe must initiate the formal change control process. After approval from the change control board, Joe can allocate resources and funds to implementing the change. Hence, Joe must initiate the change first. [PMBOK® Guide 6th edition, Page 113]"
    },
    {
      "id": "c6977366-f6c3-49f5-b049-2d5102339c64",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 96,
      "title": "You have been commissioned by your company to propose a cost-efficient strategy for a new leading-edge server farm. While researching options, you identify the power source to be a large expense of maintaining servers. You narrow the power source choices down to four options with the following attributes:\n\n* Chemical energy has an investment of $1,000,000, return on investment of 25%, and NPV of $200,000\n\n* Solar energy has an investment of $1,500,000, a payback period of 3 years, and NPV of $350,000\n\n* Wind energy has an investment of $2,000,000, a payback period of 2 years, and NPV of $250,000\n\n* Thermal energy has an investment of $1,800,000, a benefit-cost ratio of 2, and NPV of $175,000\n\nWhich of these power options should you propose based on the net present value (NPV)?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Chemical energy"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Solar energy"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Wind energy"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Thermal energy"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The four options include extraneous information, namely the investment amount (which is already factored into the NPV calculation), as well as the payback period (PBP), return on investment (ROI), and benefit-cost ratio (BCR), all of which are other types of project selection techniques that can be used by themselves or along with NPV calculations. However, the question specifically asks to base the answer on the NPV, i.e., select the project with the highest NPV. You should, therefore, have keyed in only on the term NPV when selecting the correct answer. The correct answer is 'solar energy' since its NPV is $350,000, which is the largest of all the projects under consideration. [PMBOK Guide Sixth Edition, Page(s) 33-34]"
    },
    {
      "id": "bba93f3a-9f96-4ef3-8b69-25a49277d41d",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 97,
      "title": "You are leading a project for a restaurant chain to reduce the average time a customer spends in the drive-through lanes. As part of the development of the project charter, you compare your company's drive-through processes to three competitors with the fastest drive-through lanes.\n\nWhat technique are you using in this scenario?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Brainstorming"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Questionnaires"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Focus groups"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Benchmarking"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Benchmarking involves comparing your processes to those of comparable organizations considered to be 'best in class' and use the information to improve performance. While benchmarking is a data-gathering technique, it is not listed in the PMBOK Guide  as one of the techniques used in the Develop Project Charter process described in the scenario. However, the PMBOK Guide lists the data-gathering techniques for the process and clarifies that the techniques include, 'but are not limited' to brainstorming, focus groups, and interviews. In the scenario, you are managing a project to find reasons for your slower drive-through lane times and propose a solution. By comparing your company's drive-through lane processes to other fast food restaurants that have faster drive-through lanes, you can most likely find reasons for your slower drive-through lane times. [PMBOK Guide  Sixth Edition, Page(s) 143, 80]"
    },
    {
      "id": "4bf39f18-a2b1-4221-8a23-fb5c6882a4af",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 98,
      "title": "You have just started leading a World Bank healthcare development project in a developing country in which it is customary to offer lunch when a project is initiated. Although your team members are willing to accept the offer, you decide to refuse the offer since you know the PMI’s Code of Ethics and Professional Conduct does not allow you to accept gifts. Which of the following statements about your decision is correct?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Your decision is wrong because you should obey the norms and customs of others as long as you do not favor them."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Your decision is correct because you are engaging yourself in unethical behavior by accepting the lunch."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Your decision is correct because you are following the PMI’s Code of Ethics and Professional Conduct."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Your decision is wrong because conduct rules only apply to local projects, not international projects."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Although the PMI Code of Ethics and Professional Conduct does not allow gift-taking, project managers should respect the norms and customs of others as long as they do not show favoritism based on those norms. Therefore, in this situation, your decision is incorrect because you should respect the norms and customs of others as long as you do not favor them. The PMI code of conduct applies to both local and international projects. [PMI Code of Ethics and Professional Responsibility]"
    },
    {
      "id": "b9c0ceae-d1fe-4286-bcc7-567d44ee5d1f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 99,
      "title": "You are currently initiating a hydro-power plant capacity upgrade project with a goal to increase the output by fifty percent. Prior to commencing project planning, you want to ensure that you have considered and documented all applicable enterprise environmental factors for this project. Which of the following is an enterprise environmental factor for your project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Configuration management knowledge base"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Change control procedures"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Commercial databases"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Historical information"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Commercial databases are considered enterprise environmental factors. The other choices are organizational process assets. [PMBOK® Guide 6th edition, Pages 39-41]"
    },
    {
      "id": "949e95a8-1fb5-4053-be09-82bf9bb1e135",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 100,
      "title": "A Project Manager is having difficulty obtaining consistent input from stakeholders, and needs their input to identify strategic and operational assumptions and constraints.\n \nHow can the Project Manager improve stakeholder input?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Use political awareness techniques."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Institute checklist policies."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Research effective meeting management techniques."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Make use of effective facilitation techniques."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Facilitation is the ability to effectively guide a group event to a successful decision, solution, or conclusion. A facilitator ensures that there is effective participation, that participants achieve a mutual understanding, that all contributions are considered, that conclusions or results have full buy-in according to the decision process established for the project, and that the actions and agreements achieved are appropriately dealt with afterward. [PMBOK Guide Sixth Edition page 80]"
    },
    {
      "id": "ed6269cc-e6c8-4b0a-910d-3e1a644f4662",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 101,
      "title": "A project manager is holding a meeting with relevant stakeholders to perform a benefits analysis for a project that has been selected by the company. The project is codenamed Project Tiger and has a net present value of $3,000,000. One of the meeting participants asks about Project Panther, which was estimated to have a net present value of $2,500,000. The project manager explains that Project Panther was rejected because the company did not have the resources to support both projects.\n\nWhat else might the project manager state in this scenario?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The $2,500,000 is the opportunity cost"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The $2,500,000 is considered sunk cost"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The $500,000 is the opportunity cost"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The $3,000,000 is considered sunk cost"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Opportunity cost is the value of the best alternative given up when a choice is made. The company gave up the $2,500,000 associated with Project Panther in order to pursue Project Tiger. Therefore, the $2,500,000 can be considered the opportunity cost associated with accepting Project Tiger. [PMBOK Guide Sixth Edition, Page(s) 34-35]"
    },
    {
      "id": "7d920af1-4bfe-41c8-a342-a295974d8e47",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 102,
      "title": "Your project is halfway through the third iteration. One of the key stakeholders emails a change request that would make one of the backlog items unwanted by the business. How should you respond to this change request?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Reject any change requests unless they come through the product owner."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Ask the team to remove the item from the backlog."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Trigger the integrated change control process."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Work with the product owner to have this item removed from the backlog."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Since the product owner is ultimately responsible for the product, you need to work with them to have the item removed from the backlog. [Agile Practice Guide, 1st edition, Page 41]"
    },
    {
      "id": "e346326b-1d11-437f-afe4-283051f71c75",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 103,
      "title": "Mary is currently drafting a stakeholder engagement plan for her new website development project. Her organization has strict communication guidelines. Mary wants to ensure that her stakeholder engagement strategy aligns with the organizational communications guidelines. Where can she find these guidelines?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Lessons learned library"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Corporate knowledge base"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Stakeholder register"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Project contract"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Mary is looking for the organizational policy on project communications. This is a part of the organizational process assets which are stored in corporate knowledge bases. [PMBOK® Guide 6th edition, Page 520]"
    },
    {
      "id": "44ba85cb-b9ed-4ac9-af90-22f50711fa52",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 104,
      "title": "The organization’s leadership wants projects to include more agile methodologies.\n\nBefore mandating any agile methods to be used in a project, what should be done first?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Pause current projects to align them to the new agile cadence"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Ask employees to vote on who wants to take part in agile projects"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Assess organizational culture and readiness for the transformation"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Provide agile training to those who will be part of the pilot project team"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Organizations seeking to blend a traditional plan-driven project management approach with certain agile methodologies should first assess their organizational culture and readiness to undertake such an initiative. Evolving the organization from carrying out its projects using one project management approach to another takes time and is recommended to undertake gradually and incrementally. In the scenario, senior leadership within the organization is promoting the inclusion of more agile practices into the current project methodologies. Such an organizational change to hybrid modalities may or may not be difficult. To know the extent of the difficulty an organization may endure, assessments of the organization’s readiness for learning, adapting, and applying new methods must be done first. [PMBO  Guide Sixth Edition, Page(s) 28, 38, 42, 44, 74]"
    },
    {
      "id": "2038a096-4a0e-4849-8a2c-645be4d1e3dd",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 105,
      "title": "Your organization has recently been hired by a government authority to integrate different aviation processing, control and services systems, delivered by different vendors, to launch a newly built airport. You are encountering significant integration issues that would require design changes and the authority is repeatedly failing to deliver timely decisions. You conduct a root cause analysis and find out that the staff at the authority is not experienced enough to make such significant technical decisions in a timely manner. This has a risk of causing significant delays and increased cost on the project. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Rather than presenting problems to the authority, present them available solutions along with any supporting data that is available."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Create a consortium with all involved vendors and mutually select solutions to all integration issues."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Check if the delays are allowed by the contract, and if not, sue the authority."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Issue a change request for additional budget and time to complete the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "You and other vendors cannot just make design change decisions by themselves. You need to encourage and facilitate the authority to make timely decisions. The scenario makes it clear that the staff doesn’t have enough technical expertise to make technical decisions in a timely manner. You can help the situation by presenting the authority with available solutions along with any data that is available to support the right decision. [PMBOK® Guide 6th edition, page 527]"
    },
    {
      "id": "fb7d81ec-aff0-4624-9ad7-e3b6ccfdd290",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 106,
      "title": "You are managing an ERP system design and development project for your organization. The team spent months collecting business and system requirements before the scope was agreed and signed off. The development effort took over a year in isolation and no significant issues were witnessed during the unit, integration and performance testing stages. However, during user acceptance testing you found out that some of the organizational processes have now changed and the system is now incompatible with the current business requirements. Fixing these issues will require an additional eight months for development and testing. Who is at fault here?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The project team"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The project manager, team and the sponsor"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The project manager and the team"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The project manger"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The scenario makes it clear that the product was developed using a pure waterfall lifecycle where the requirements were defined upfront and the development was later done in isolation. On waterfall-based projects, the project manager is ultimately accountable for the project’s success and failure (On Agile-based projects, the whole team shares the accountability). [PMBOK® Guide 6th edition, page 51]"
    },
    {
      "id": "b8d1d9ed-ebc8-4695-a699-f6a606d83d37",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 107,
      "title": "A project is started based on the approved scope. As the project design is being implemented, a team member says that the product will not meet the requirements in certain situations. Correcting the issue will not only cause an increase in scope and costs, but the project will also miss the deadline. The project sponsors do not have additional funding to support the project.\n \nConsidering this information, what should the Project Manager do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Conduct a risk analysis and update the project sponsor."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Enact the Perform Integrated Change Control process."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Resolve the issue to satisfy the customer."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Contact the customer and negotiate for risk acceptance."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The Risk Register exists for the project team and stakeholders to understand potential problems with the project. Since the team member may not have all the answers, it is necessary to first perform a full risk analysis and update the project sponsor before making any decisions."
    },
    {
      "id": "4481100c-787b-4d79-b9a7-eb4984d49b8a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 108,
      "title": "A project has a 90% chance of making $200,000 profit and a 10% chance of incurring a loss of $50,000.\n\nIf you calculate the expected monetary value, what is the expected outcome of the project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Profit"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Loss"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Cannot be determined"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Break even"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Expected monetary value is calculated using the formula EMV = Probability x Impact for both the opportunity and the threat.\n* Total profit = 0.90 x $200,000 = $180,000\n* Total loss = 0.10 x -$50,000 = -$5,000\n* EMV = $180,000 - $5,000 = $175,000\nTherefore, the project is predicted to make a profit. [PMBOK^® Guide Sixth Edition, Page(s) 435]"
    },
    {
      "id": "8d2720ca-397b-44e7-b126-f64dded46c30",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 109,
      "title": "You are developing the project management plan for a project to develop an interactive computer-based visualization that will demonstrate the efficacy of a new drug versus a competitor's drug and placebo. A completed visualization must be available for a convention that is scheduled in six months, after which time the visualization will no longer provide any value.\n\nWhat might you do to ensure the project delivers the intended benefits?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Hold daily Scrum meetings to demonstrate the product increment and gain feedback from stakeholders"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Use a traditional project management approach where the scope is fixed\nand time and cost are variable"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Incorporate the DSDM framework of constraint-driven delivery within the\nexisting predictive model"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Implement a change control system that will prevent any changes to the scope, schedule, and cost"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "With traditional waterfall project management, the project's baselines are fixed by the scope, schedule, and cost baselines. Typically, the scope is well-defined during initial project planning, and time and cost are estimated. Thus, even with a robust change control process, the scope is fixed, but the time and cost might still vary. For example, if a project is approved to construct a parking garage, the scope can be determined in great detail, and the scope is not likely to change, but in order to complete the project scope, the project may run under/over budget and schedule. \n\nIn this scenario, the project has a fixed time for completion that cannot be changed. Thus, of the three main project constraints, time is of paramount importance and must be fixed even at the expense of cost and scope. The dynamic system development method (DSDM) is an agile framework that flips the triangle of constraints upside down. With this approach, instead of the scope being fixed with time and cost being variable, the project's time and cost are held fixed, and the scope is allowed to vary. It can be useful for projects where the scope cannot be well-defined upfront, as is the case with many knowledge-based or software development projects.\n\nIn this case, the visualization could be progressively elaborated with features being added and refinements made until the project reaches the deadline, and the product is released. With this approach, the product owner will prioritize the backlog of features so that the most important features are developed first, which may leave some less important features undeveloped. This, in turn, would allow the project team to build the most valuable features and functionality within the non-discretionary timeframe.\n\nNote, the development of a project management plan in the scenario implies that a traditional waterfall project management framework is employed. When DSDM, an agile methodology, is combined with a predictive model, the project becomes a hybrid. In this hybrid environment, the\ncost and schedule baselines can be fixed with a rigorous change management system, whereas the scope can be left with minimal (if any) constraints. [PMBOK Guide Sixth Edition, Page(s) 133; Agile Practice Guide Pages(s) 110]"
    },
    {
      "id": "990b5bc3-9682-41b4-b61f-e0d4ee310805",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 110,
      "title": "You are currently leading a massive project team to deliver a new electrical power transmission network in a remote area of the country. A number of identified project risks did occur during the project but all were successfully managed in accordance to their contingency plans. Your project is now nearing completion, but a previously unidentified risk has arisen, and it could significantly affect one of the project deliverables. What do you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Transfer the risk"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Include the issue in the project risk log"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Develop a risk mitigation plan"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Notify the project stakeholders immediately"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Notify the project stakeholders immediately about the new risk. Once the stakeholders have been made fully aware of the circumstances and potential impacts, a plan to deal with this risk can be developed. The PMI Code of Ethics and Professional Conduct requires project managers to provide accurate and timely project information at all times and to follow all project processes and policies. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "cff70c0a-91ac-4aaf-b8eb-95c59a6689d8",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 111,
      "title": "A customer is not satisfied with the delivered product, saying that it was not what they expected. The Project Manager is surprised, because the agile development team delivered the product several iterations early.\n \nWhat is one way that the Project Manager could have avoided this result?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Required team sign off for each of the constant changes to the requirements"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Set aside more resources for product testing after changes are made"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Made sure that the customer was aware of the value of demostration"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Ensured that the team fully participated in developing the project scope"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The customer was not engaged enough in the project.  the iteration review is the best mechanism for the team to demonstrate working software and for the customer to give feedback to ensure that their expectations are met. [PMBOK®  Guide Sixth Edition page 524; The Agile Practice Guide Demonstrations/Reviews, page 55"
    },
    {
      "id": "8cf7cded-f970-4b4d-bb30-04c356aa580d",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 112,
      "title": "Agile teams measure WIP during the beginning of the project and determine the available options for rapid product delivery. Which of the following is the recommended approach when comparing different delivery options?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Deliver upfront designs instead of value."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Deliver detailed designs as early as possible."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Deliver value instead of upfront designs."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Deliver detailed designs at least halfway through the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Upfront designing is waterfall. When selecting delivery options, Agile teams choose value over upfront designs. This is the fundamental difference between Agile and traditional approaches. [Agile Practice Guide, 1st edition, Page 59]"
    },
    {
      "id": "5d0062c1-a927-4cdf-9707-252035a45c1d",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 113,
      "title": "You are a project manager at an organization with a project management office (PMO), which maintains complete control of all projects. The PMO has just created a project charter for a project to evaluate and streamline their product offerings and has named you as the project manager.\n\nYou are employed by which type of PMO organization?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Supportive"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Controlling"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Directive"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Initiative"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The question describes a project management office (PMO) that maintains complete control over projects. Directive PMOs take control of the projects by directly managing the projects. Additionally, a directive PMO assigns project managers, and they report directly to the PMO, as is described by the question. Based on the description provided by the question, the directive PMO is the best answer choice. [PMBOK Guide  Sixth Edition, Page(s) 48]"
    },
    {
      "id": "ae974eae-ae7f-4212-a8eb-c24303531a32",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 114,
      "title": "You are managing a project for a customer who has offered an incentive for meeting all deadlines. At this time, the project is running on a compressed schedule but is continuing to have regular quality meetings to ensure the project’s output meets the customer’s requirements. Your manager, however, is concerned the meetings will cause further project delays and missed deadlines, which would, in turn, result in the loss of potential incentive payments. He insists that the meetings be stopped immediately and that all project effort be focused on making on-time deliveries. What do you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Add project resources."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Cancel all meetings."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Further compress the schedule."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Refuse the request and explain to your manager that you are obligated to adhere to all quality management plans for the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Refuse the request and explain to your manager that you are obligated to adhere to all quality management plans for the project. Failing to do so would not only deliver a possibly defective product to the customer, but is also a violation of the PMI Code of Ethics. The Code requires project managers to follow all project processes and polices. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "9705ff6c-61bd-4cb0-aa0c-ac05f4efeb69",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 115,
      "title": "As a project manager, you are in the initiation stage of a new project. You are currently preparing for a meeting to conduct a benefit analysis with relevant stakeholders to validate project alignment with organizational goals and expected business value.\n\nWhat should the project manager do to prepare for the meeting?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Review the project management plan"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Examine the project business documents"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Read the stakeholder engagement plan"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Study the project alignment plan"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The project business documents include the business case and benefits management plan which are created as part of pre-project work. The business case is a documented economic feasibility study used to establish the validity of the benefits of a selected component lacking sufficient definition, and that is used as a basis for the authorization of further project management activities. The benefits management plan is the documented explanation defining the processes for creating, maximizing, and sustaining the benefits provided by a project. These documents will contain the relevant information which can be used in preparation for the meeting described by the question. Additionally, with the project in the initiation stage, items described in the other answer choices are not yet available to be used as a source of information. [PMBOK^® Guide Sixth Edition, Page(s) 29, 33]"
    },
    {
      "id": "4b427d3f-58ef-445c-82ed-74718cf9b703",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 116,
      "title": "Your sponsor has committed to building a high-speed rail from one major inland city, Azules, to the coast. You have two possible routes, either Brazos or Corazon.\r\n\r\nGiven each route's costs, odds, and rewards of high demand and low demand in this decision tree, how would you quantify the expected monetary value of the route to Corazon?",
      "description": "",
      "image": "https://storage.pmcbd.net/uploads/question/ba2496cf-a8af-4b81-ba17-44acc57b2a7d.jpg",
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "7.2 billion"
          },
          {
            "k": "B",
            "s": 2,
            "t": "-4.8 billion"
          },
          {
            "k": "C",
            "s": 3,
            "t": "-18 billion"
          },
          {
            "k": "D",
            "s": 4,
            "t": "-8.8 billion"
          },
          {
            "k": "E",
            "s": 5,
            "t": "None"
          }
        ]
      },
      "explanation_image": "https://storage.pmcbd.net/uploads/question/8534acfc-97c5-474a-9dca-e7c7d1816964.jpg",
      "correct_answer": "D",
      "explanation": "The expected monetary value is an important calculation in performing decision tree analysis as part of the Perform Quantitative Risk Analysis process. You must account for not only the cost of the decision but the probability and payoff for each effect.\n\nIn a decision tree, the EMV for a decision is calculated by multiplying the value of each possible profit outcome by its probability of occurrence and adding the products together.\n\nThe value of each possible outcome is the net path value. Remember: when you net something, you must consider all positive and negative flows.\n\nThe formula to compute net path value is to subtract the path reward minus the cost of its decision. For building the route to Corazon, here are the steps to compute the expected monetary value:\n\nEMV = 0.6(-8B) + 0.4(-10B) = -4.8B + (-4.0)B = -8.8B\n\nOther answer choices do not properly factor the net path value (the payoff minus the cost of the decision) and sum the effects.\n\nBelow is the completed decision tree with all the net path values and the resulting expected monetary value of each choice. The EMV for the Corazon route is -8.8 billion (note this is a negative number). The EMV for the Brazos route is 0.8 billion. The question is asking to calculate the expected monetary value of the route to Corazon. Therefore, -8.8B is the correct answer."
    },
    {
      "id": "8a5a5b9b-3f55-487c-ad7a-8da4fa56a8d0",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 117,
      "title": "George is managing a complex financial application development project in an Agile environment. One of the critical success factors for the project is agility and responsiveness to change. In order to foster an Agile environment, George must take a hard look on which of the following processes with an aim to streamline them?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Quality management processes."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Agile processes."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Production processes."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Lengthy processes, causing bottlenecks."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The scenario doesn’t give enough context to determine if there are any issues with the production or quality management processes. George needs to focus on processes that are impeding the team’s agility and progress. Lengthy processes that are causing bottlenecks is the best response to this question. [Agile Practice Guide, 1st edition, Page 35]"
    },
    {
      "id": "52a3a235-6ac5-416b-b3c7-562d7b9f8c45",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 118,
      "title": "A project manager is organizing a meeting to gain approval for the project management plan. Before the meeting is scheduled, the organization announces a restructuring, which is effective immediately and impacts several key stakeholders for the project. To ensure the appropriate stakeholders are invited to the meeting, the project manager needs to update the relevant project documentation to reflect the new organizational structure.\n\nWhat is the best course of action?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Cancel the meeting and wait for the instructions from the project sponsor"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Update the stakeholder register to reflect the new organizational structure"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Schedule the meeting with the original list of project stakeholders"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Submit a change request to update the stakeholder register"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Based on the scenario provided, the new organizational structure resulted in changes among project stakeholders. Stakeholder identification is an ongoing process that can be done at any point throughout the project life cycle. Once new information about stakeholders becomes available, the stakeholder register should be updated. Since the stakeholder register is a project document, a change request is not typically required to update the stakeholder register. Regardless, no change requests are required until the project management plan has been approved. Therefore, of the available choices, updating the stakeholder register to reflect the new organizational structure is the best course of action for the project manager to take in this situation. [PMBOK Guide  Sixth Edition, Page(s) 83]"
    },
    {
      "id": "30bf2bd6-0805-4a33-b16f-f6e8ec071f78",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 119,
      "title": "A project manager is leading a new product development project. During project execution, the competitive advantage of this new product is threatened when another company is first to market with a similar product. This risk had been identified during initial planning and placed on a watch list.\n\nWhat should the project manager do next?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Analyze the impact of the risk on the project objectives"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Risks on the watch list do not have planned responses and can be ignored"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Apply the contingency response plan developed for this risk"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Terminate the project since the competitive advantage has been lost"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The question implies that the project manager needs to perform the Implement Risk Response process for an identified risk that has been placed on the watch list. The risk register may include a watch list for low priority risks or risks that require further analysis. While the competitive threat may be considered a high-priority risk or a risk requiring a prompt analysis and appropriate response plan, the scenario suggests this risk was placed on the watch list (for reasons not specified in the question text). A response plan is not developed for risks placed on the watch list; rather, these risks are monitored throughout the project. In case their potential impact on the project changes, further analysis is required to develop a risk response. Since an identified project risk has occurred in this scenario, and there is no response planned for this risk, the most logical next step for the project manager is, among the available choices, to analyze the impact of this risk to the project objectives to determine the best course of action. [PMBOK Guide  Sixth Edition, Page(s) 427, 440, 450"
    },
    {
      "id": "aa7d89e1-d8f1-450c-a356-8fba508d8f8a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 120,
      "title": "Some stakeholders are disappointed that not all of their needs were included in the final requirements documentation. A senior project manager suggests using a document that relates the planned capabilities with the business objective that each capability satisfies. This document would demonstrate how each requirement adds business value. \n\nTo what type of document is the senior project manager referring?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Requirements traceability matrix (RTM)"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Business register"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Requirements management plan"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Context diagram"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The RTM is a grid that links the product requirements to the business objectives. It provides a means to track requirements throughout the project lifecycle helping to ensure that requirements approved in the requirements documentation are delivered at the end of the project. Using an RTM will assist in ensuring and showing that each requirement adds business value by linking it to the business and project objectives. Each requirement has attributes associated with it that help to define the requirement further. One of the attributes that can be used is the owner of the requirement, who will manage it throughout the project. Based on the scenario described, the RTM is the document to which the senior project manager was referring. [PMBOK Guide)  Sixth Edition, Page(s) 148-149]"
    },
    {
      "id": "e4c1b3b8-aa99-4707-a908-bfec944658d3",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 121,
      "title": "An organization is considering rolling out a new technology that could enhance employee productivity and excitement. Some have warned that the new technology could be out-of-date soon after roll out and there would be substantial costs in material and end-user training. Management is unsure whether to green light this project.\n\nWhat is the best course of action for the organization to take before making a decision?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Validate the scope of the technology roll out to confirm that the technology increases employee productivity and excitement"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Determine if the benefits of the project implementation will be greater than the costs in material and end-user training"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Conduct a benefit analysis to validate the project's alignment with organizational strategy and  expected business value"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Survey developers of the technologies under consideration to better understand all the technical specifications and uses"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "There are many reasons to initiate a project. New technology is one such  option. Nonetheless, what is most important is how a project aligns with business needs and strategies. Analyzing business needs and strategies helps determine whether or not a project brings value to the business. Other information and criteria may assist in making a more educated and comprehensive decision, but the most important aspect to consider is the business value to be gained or lost by initiating and completing a project, not the technology on its own. [PMBOK Guide Sixth Edition, Page(s) 77-78]"
    },
    {
      "id": "e89bccb9-d60e-4922-be70-cba55b8061e7",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 122,
      "title": "Two weeks ago, you accepted a consulting engagement to manage a project for a customer. Today, you get a call from a previous client asking you to take over management of a project already in progress, with a much higher pay rate than the project you are already on. Both are full-time jobs. Which of the following is the best response?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Accept the new project and end your current engagement"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Ask your existing customer if they can postpone their project until the new one is finished"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Decline the new project, citing workload and prior commitments"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Accept the new position and keep your existing position"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The best choice is to decline the new project. PMI's code of professional conduct requires project managers to fulfill commitments they have made and to do what they say they will do. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "52bd6dd0-7211-4a81-a9e4-b0e8c5b8e727",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 123,
      "title": "A product deliverable is undergoing acceptance testing. A senior-level stakeholder raises concern that an essential product feature for their department was not developed. The Project Manager wants to avoid this issue in the future.\n \nWhat is one way to accomplish this goal?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Properly manage stakeholder expectations."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Prepare a change management plan."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Ensure a scope management plan gets approved."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Hold a product demo with stakeholders."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "A scope management plan documents how the project and product scope will be deﬁned, validated, and controlled. [PMBOK Guide Sixth Edition page 137]"
    },
    {
      "id": "b9899510-0fa0-47ac-8275-e9234a96c5a3",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 124,
      "title": "Many project managers have seen a graph that shows “Influence of Stakeholders” starting out high and declining as the project progresses. In contrast, it also shows the “Cost of Changes” starting out low and increasing as the project progresses. What is the key insight a project manager should gain from this graph?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Make changes as early in the project as possible."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Place the project on hold until all changes are made."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Stakeholder influence is not important at the end of the project."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Set aside money for expected changes at the end of the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Changes should be made as early as possible in the project to avoid additional cost and delays. The influence of stakeholders is high at the start of the project and low towards the end. In contrast, the cost of making changes in a project is low at the start of a project and high towards the end. [PMBOK® Guide 6th edition, Page 549]"
    },
    {
      "id": "931fb121-3894-4cef-9133-2088469d15b2",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 125,
      "title": "Your organization encourages employees to involve themselves in professional activities or organizations. Since you are a PMP and an active member of PMI’s local chapter, you encourage other employees to become certified, as well. You just received an email from PMI stating it is investigating two recently certified PMPs from your organization for allegations of contract fraud. They have asked you to send information about all relevant people in your organization. How should you respond?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Provide no information"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Provide all requested information"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Provide only non-confidential information"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Notify the appropriate management immediately"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Notify the appropriate management immediately. While it is imperative that you cooperate with PMI as they investigate ethics complaints, you must also comply with your organization's policies on sharing confidential information. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "f96d1c2b-1b93-49cd-8d98-d260d2d42328",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 126,
      "title": "You have just joined a new organization as a project manager. You have heard a number of rumors about the procurement manager having possible underhanded dealings with suppliers. However, you have no proof these rumors are true. Your project requires a large number of dump trucks. Company policy mandates that all purchases go through the procurement department rather than the department employees. The value of the dump truck purchase is US$395,000, and the contract went to a supplier your company regularly uses. Shortly after taking delivery of the dump trucks, you learn the procurement manager is driving a new car. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Do nothing"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Talk to the supplier to find out if there was a bribe involved in the project"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Ask the procurement manager about the purchase of her new car"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Report this to the appropriate management"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "No action is required in this situation. Although PMI's Code of Ethics requires project managers to report illegal or unethical activity to the appropriate management, you have no evidence that there has been any wrongdoing in this situation. Therefore, reporting or investigating the procurement manager's new car purchase is unwarranted. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "51b7c988-a361-48b8-8d90-0b6153477f3a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 127,
      "title": "To promote continuous improvement, your organization uses a methodology that involves defining the objectives and scope of the project, measuring to obtain data, analyzing the collected data to find the root causes, improving by developing a solution, and controlling by evaluating the implemented solution.\n\nWhat quality improvement method is your organization using?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Total Quality Management (TQM)"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Six Sigma"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Quality function deployment (QFD)"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Deming's PDCA cycle"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The Six Sigma method of quality improvement focuses on increasing the effectiveness and efficiencies of projects and eliminating defects and waste. The Six Sigma method is more comprehensive than prior process improvement initiatives such as Total Quality Management (TQM) and Continuous Quality Improvement (CQI). The scenario describes the steps in the methodology currently in place in your organization. Those steps are the phases of Six Sigma:\n\nDefine: The objectives and scope of the project are defined. Relevant information about the process and customer are collected.\nMeasure: Data on the current situation and process metrics are collected.\nAnalyze: Collected data are analyzed to find the root cause(s) of the problem.\nImprove: Solution(s) to the problem are developed and implemented.\nControl: The implemented solution(s) are evaluated, and mechanisms are\nimplemented to hold the gains, which may include standardization.\n\nTherefore, based on the description of these steps, the quality improvement method your organization uses is Six Sigma. [PMBOK Guide  Sixth Edition, Page(s) 296, 275]"
    },
    {
      "id": "5eea63c1-13f0-4467-ade9-44870ec5d762",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 128,
      "title": "An internal project is almost complete. The project manager wants to have a final meeting with the sponsor to discuss how to maximize the value of the deliverables after the project’s deliverable is deployed.\n\nWhat does the project manager use to back up the conversation with the sponsor?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The benefits management plan"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The project charter"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The business case"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The activity list"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The benefits management plan is the documented explanation defining the processes for creating, maximizing, and sustaining the benefits provided by a project. The benefits management plan defines how the deliverables should be maintained, so the deliverables can provide the highest benefit after they are delivered and not under the purview of the project. The incorrect answer choices are not likely to have post-deployment information. Therefore, of the choices provided, the benefits management plan is the best response. [PMBOK Guide  Sixth Edition, page 33, 125]"
    },
    {
      "id": "12cdb50b-4f8a-4706-a1ef-229e2e93e2ed",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 129,
      "title": "The project manager is concerned that the new system planned to be delivered by the project may not be adopted by the end users in the department due to their anti-change culture and resistance to new initiatives as seen in the past.\n\nWhat is the best course of action for the project manager?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Build an FAQ website and respond to every end user inquiry quickly"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Have the sponsor announce the value of the new system and how everybody\nis to benefit from it"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Meet with the end users and listen to what they have to say"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Get the new system in the hands of end users as early as possible and\nlet them see its benefits"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Achieving and managing stakeholder engagement in the project can be easy in some cases, incredibly difficult in others, and every point in between. According to the scenario, there is a culture of hesitation and resistance to new programs and projects in the department. Based on the past projects, the end users in the department felt disenfranchised and uninvolved. The project manager must overcome these stakeholder engagement hurdles by encouraging more stakeholder involvement and buy-in. The first step towards achieving that starts with open dialogue and active listening. The other methods of communicating and engaging with these stakeholders can potentially be useful, if determined appropriate, at a later time. Communication skills as well as interpersonal and team skills are among the tools and techniques that can be used by project managers as part of the Manage Stakeholder Engagement process implied by the scenario. [PMBOK Guide  Sixth Edition, Page(s) 527"
    },
    {
      "id": "d25ac917-58b9-4355-8b5b-5e55d6a1787d",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 130,
      "title": "An organization has established a threshold for all projects that the expected incremental revenue must exceed costs by at least 25%. The current project is projected to have a benefit-cost ratio (BCR) of 1.75.\n\nBased on this information, what can be said about the project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The BCR does not meet the minimum threshold established by the organization; therefore, the project should not be undertaken."
          },
          {
            "k": "B",
            "s": 2,
            "t": "The BCR meets but does not exceed the minimum threshold; therefore, the\nproject should not be undertaken."
          },
          {
            "k": "C",
            "s": 3,
            "t": "The BCR exceeds the minimum threshold and is in alignment with corporate strategy; therefore, the project can be undertaken."
          },
          {
            "k": "D",
            "s": 4,
            "t": "There is not enough information in the question to calculate the BCR and make an informed decision about the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "In order to correctly answer the question, one must understand benefit-cost ratio. The benefit-cost ratio (BCR) represents the benefits divided by the costs. In this case, the benefits are the expected incremental revenues from the project, and the costs are represented by the project budget. Typically, the revenues and costs are adjusted for inflation by using the net present value (NPV), but that is not stated in the question. In this scenario, the organization has established a threshold for all projects that the expected incremental revenue must exceed costs by at least 25%. Therefore, the project's BCR must exceed 1.25. Since the project's anticipated BCR of 1.75 exceeds the minimum threshold of 1.25, the project is in alignment with the organization's strategic goals and can be undertaken. [PMBOK  Guide  Sixth Edition, Page(s) 34-35]"
    },
    {
      "id": "e50bbccf-51ce-4dbd-be73-e20e057dc918",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 131,
      "title": "Eric, a project manager, is a certified PMP. He is responding to an RFP from a buyer and needs to fill in details on his company’s financial performance. His company has performed poorly during the current quarter, and the results will be published in two to three days. However, the company has done very well in the previous quarters. The RFP is due in 10 days, and all the information in the RFP is complete except the financial information. What should Eric do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Eric should fill in the financial information for the previous quarter and send out the RFP response before the current quarter results are published."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Eric should present the previous quarter's results as the latest results. This will give his company a better chance to win the project."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Eric should fill in the information for the previous quarter and ignore the current quarter. This is an aberration, and the company will eventually come out of the bad patch."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Eric should wait until the current results are out and update the latest financial information before sending out the RFP response."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "As a PMP, Eric must not behave in a manner that will mislead the buyer. Hence, given that there are still a sufficient number of days remaining before the RFP is due, it is his responsibility to wait for the current quarter results to be published and truthfully provide this information in the RFP. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "8f74f395-e03a-4f3e-a136-ee5a0725b136",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 132,
      "title": "You are executing a project for a new product that has been well received and supported by major stakeholders. However, three months into the yearlong project, a competitor launches a similar product. You are concerned that the attitude of several key project stakeholders toward your project will be negatively shifted.\n\nWhat should you do first?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Update the stakeholder engagement assessment matrix"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Document your concerns in the stakeholder register"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Add a new record to the issue log"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Resort to alternative dispute resolution"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "An issue is a current condition or situation that may have a negative impact on the project objectives. Monitoring stakeholder engagement throughout the project life cycle is an important duty of the project manager. A change (presumably negative) of stakeholder sentiment toward the project is an issue. However, this change has not yet been confirmed. What was confirmed is that the competitor launches a similar product. The latter is a major issue. Issues are captured in the issue log. Updates to the issue log are among the outputs of the Monitor Stakeholder Engagement process described in the scenario. Therefore, when you realize a competitor launches a similar product, you should first record this fact as an issue in the issue log accompanied by a note of the potential negative shift in the attitude of the key project stakeholders. By capturing this situation in the issue log first, you ensure the stakeholder engagement will not be overlooked and will be addressed or accounted for when reviewing the issue log. [PMBOK Guide Sixth Edition, Page(s) 536]"
    },
    {
      "id": "3b6fd7f0-391a-4cec-89cf-8871adf3723c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 133,
      "title": "Undertaking a project requires a business case to justify whether the project is worth the investment.\n\nWhich is the best example of a business case?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The operational budget is greater than previous years, and we must allocate those funds"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Technology is constantly changing, and we must learn the latest tools"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Carbon emissions can be reduced with the installation of filters on all current machines, and we can gain governmental environment certification"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Projects like this have been done in the past with great success, and we must have more successful projects this quarter"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "A business case is a reason and justification for a business to undertake and fund a project. The case to take on any project should fulfill the needs and objectives of the business. The goals of the business vary from one business to the next; even within businesses, there are various cases to take on projects. Whatever the case, there must be a legitimate, explicit outcome that can feasibly achieve benefits for the business and its objectives. Of the available choices, only one has all the characteristics of the valid business case, “Carbon emissions can be reduced with the installation of filters on all current machines, and we can gain government environment certification.” [PMBOK Guide  Sixth Edition, Page(s) 30-31]"
    },
    {
      "id": "13864105-0d82-4766-b727-cf722082dfff",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 134,
      "title": "A Project Manager works for a company that is preparing to develop a new product. The new product will require currently unavailable skills.\n \nTo initiate this project, what should the Project Manager do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Develop detailed project requirements"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Focus on quality control"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Focus on the assessment of high-level risks"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Develop a competitor analysis"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "If you plan to deliver a product and do not possess the skills required, this is a risk. [PMBOK Guide Sixth Edition page 441]"
    },
    {
      "id": "bc309062-be26-4f8f-8327-790a819c3b87",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 135,
      "title": "David was required to investigate a business problem and describe the higher-level needs of the business as a whole. David’s final reports describes in detail the features, functions and characteristics of the product that will meet the business and stakeholder requirements. What is wrong with David’s report?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "David was asked to analyze the non-functional requirements but he focused on the functional requirements."
          },
          {
            "k": "B",
            "s": 2,
            "t": "David was asked to analyze the functional requirements but he focused on the non-functional requirements."
          },
          {
            "k": "C",
            "s": 3,
            "t": "David was asked to analyze the solution requirements but he focused on the business requirements."
          },
          {
            "k": "D",
            "s": 4,
            "t": "David was asked to analyze the business requirements but he focused on the solution requirements."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "David was asked to analyze the business requirements but he focused on the solution requirements. Business requirements describe the higher-level needs of the organization as a whole, such as the business issues or opportunities. While the solution requirements describes in detail the features, functions and characteristics of the product that will meet the business and stakeholder requirements. [PMBOK® Guide 6th edition, Page 148]"
    },
    {
      "id": "5201b63a-fac2-4ae1-8cd1-32352289ca17",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 136,
      "title": "For an upcoming project, a needs assessment and business case have been completed, and the project management office (PMO) is reviewing a draft of the benefits management plan. The PMO highlights an element of the benefits management plan and requests that the element be removed before the document is finalized.\n\nWhich of the following was most likely the element the PMO requested to remove?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Expected tangible and intangible value to be gained by the implementation of the project"
          },
          {
            "k": "B",
            "s": 2,
            "t": "A set of options to be considered for addressing the business opportunity"
          },
          {
            "k": "C",
            "s": 3,
            "t": "A timeframe for realizing the benefits of the project"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Measures to be used to show benefits realized"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The key elements of a benefits management plan include target benefits, strategic alignment, a timeframe for realizing benefits, benefits owner, metrics, assumptions, and risks. Identification of a set of options to be considered for addressing the business problem or opportunity is a key element of the project business case and should not be included in the benefits management plan. This element is most likely what was marked for removal by the PMO."
    },
    {
      "id": "df183e4a-3741-4b13-9d77-9dd5229f989f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 137,
      "title": "Jane is responsible for migrating critical applications used in the organization over to a cloud platform. The non-critical applications that are currently integrated with these critical applications will be moved to the cloud once the current migration project is successful. Which of the following is the best approach for Jane given the high uncertainties associated with the project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Tackle the project via strict waterfall approach."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Break the interconnections and migrate one application at a time."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Tackle the project via small increments of work."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Migrate the critical and non-critical applications at the same time."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Migrating the non-critical applications is not in the scope. Breaking the interconnections might render the critical applications inoperative. Waterfall approach is not recommended in this scenario as the project has high uncertainties. Tackling the project via small increments of work sounds like the most reasonable approach among the given options. [Agile Practice Guide, 1st edition, Page 13]"
    },
    {
      "id": "36394998-af01-4183-a34e-fddeaa54e73a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 138,
      "title": "A three-phase project to build a prototype is underway. The first phase entails design. In the second phase, the manufacturing team would produce the parts from the design specifications. In the third phase, the production team would assemble the parts to construct the prototype. The project is now at the end of the first phase.\n\nWhat should be done with the phase's deliverables?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Verified by the testing team for quality compliance"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Transferred to the production team"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Transitioned to the project management office (PMO)"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Handed over to the manufacturing team"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The question states that the project is at the end of the first phase, implying the Close Project or Phase process is being carried out. An output of the Close Project or Phase is the transition of the final product, service, or result to a different group or organization that will operate, maintain, or support it throughout its life cycle. Officially transferring the ownership of deliverables to the assigned stakeholders facilitates project (or phase) closure. In this case, the project manager would transfer ownership of the design to the manufacturing team since they are responsible for the second phase of the project. [PMBOK Guide Sixth Edition, Page(s) 123, 127]"
    },
    {
      "id": "19cd972f-9eb1-4496-a516-afdcd514023e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 139,
      "title": "The manager in charge of your company‘s IT change control board is extremely difficult to deal with. He frequently denies change requests for petty reasons. You have a software patch change request pending that is a critical path item in your project. If the change is not approved at the upcoming change control meeting, there will be a two-week delay in your project until the next change control meeting. How do you handle this?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Ask the IT manager to install the patch as part of another change request that was approved."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Ask one of the systems engineers to install the patch during the next maintenance window."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Argue with the change manager until he relents."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Present the change request as per company process. If it is denied, escalate the issue to management for assistance and submit an emergency change request."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The proper approach is to follow all change management procedures but notify appropriate management of the delay and ask for assistance to get the change request approved. Project managers must act respectfully toward others even when it is not reciprocated and follow all policies and procedures. Intentional circumvention of policies is unprofessional and goes against the code of ethics. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "0ed38910-966c-4d33-afb9-4d7eeb76dc27",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 140,
      "title": "An accountant is concerned about how costs and returns are to be monitored on a newly initiated agile project.\n\nWhat words of advice could an agile practitioner give to the accountant?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Accounting in agile and traditional projects is the same."
          },
          {
            "k": "B",
            "s": 2,
            "t": "In agile projects, ROI could be generated while executing the project."
          },
          {
            "k": "C",
            "s": 3,
            "t": "ROI is always higher in agile projects than in traditional ones."
          },
          {
            "k": "D",
            "s": 4,
            "t": "In agile projects, the cost is not a concern since it is fixed."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "By prioritizing the highest value features and delivering them early and incrementally to the customer, agile projects provide an opportunity for an early return on investment. This affects how project accounting and funding is administered. The work in progress in traditional projects can be enormous and consumes capital, whereas agile projects focus on limited WIP and getting the product out to the marketplace sooner, which helps reduce capital consumption and financial risk."
    },
    {
      "id": "e76dfc70-072c-4aed-902b-2afd7db59fa4",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 141,
      "title": "You are developing an online complaint management system. Recently the product owner has requested you to drop a feature from the current iteration plan that was earlier requested by the compliance department. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Drop the feature from the release plan."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Drop the feature from the iteration plan and notify compliance."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Reject the change request as feature was requested by compliance."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Arrange a meeting between the product owner and compliance."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The product owner is ultimately responsible and accountable for the product being developed. If the product owner has request to drop a feature from the current iteration plan, that decision needs to be honored. To manage the stakeholder expectation at compliance, notifying compliance of the change is a good idea. [Agile Practice Guide, 1st edition, Page 41]"
    },
    {
      "id": "efb6a9c1-e69d-4ef8-8ee3-a9094db68125",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 142,
      "title": "A consultant has been engaged on a time-and-materials basis to support a very large project. The finance department asks you to approve several invoices this consultant submitted. After reviewing project records, you discover the consultant was not asked to perform any tasks or provide any materials yet. How do you respond?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Reject the invoices and send them back to the consultant"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Do not approve the invoices and notify appropriate management"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Approve the invoices but tell the consultant he must provide goods and services in an amount equivalent to the invoices"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Approve the invoices and notify the company‘s legal department"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The best response is to not approve the invoices and to notify appropriate management. The PMI code of ethics requires that a project manager adhere to the standards it sets forth, as well as mandating that the project manager require ethical and professional behavior from others. Therefore, the project manager is responsible for identifying and reporting possible fraud or other dishonest behavior in vendors, coworkers, or other project resources. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "4316a8fd-cc06-444e-af98-e0e07051f876",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 143,
      "title": "The organization’s strategy provides a strategic direction and performance parameters for identifying, selecting, and delivering the right mix of projects. If it is determined that some of the CEO’s favorite projects do not fully align with the business objective, the PMO manager should:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Terminate the project"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Recommend a realignment of the project objectives"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Honor the CEO’s desires and execute the project"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Recommendation a realignment of the strategy"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Honoring the CEO’s desires and executing the project is against the PMI’s Code of Ethics since the project manager knows that some of the projects are not fully aligned with the strategy. Terminating the project is an extreme and should not be the first consideration. The project manager must make a recommendation to realign the project objectives with the organizational strategy since value to the business can only be delivered when projects remain aligned with the strategic direction of the organization. [PMBOK® Guide 6th edition, Page 14]"
    },
    {
      "id": "c327c443-c833-4228-95ba-c4c52e1d459c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 144,
      "title": "Which of the following statements correctly describes the attitude of Agile teams towards changing requirements?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Agile teams welcome changing requirements during project planning."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Agile teams do not welcome change but not changing requirements."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Agile teams welcome changing requirements, even late in development."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Agile teams welcome changing requirements during the start of the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Agile teams welcome changing requirements, even late in development. Agile processes harness change for the customer’s competitive advantage. [Agile Practice Guide, 1st edition, Page 9]"
    },
    {
      "id": "a615437c-785c-4d47-b90c-5f6b89ff4e10",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 145,
      "title": "A key project resource is discussing the complexity of project deliverables with the Project Manager 1.5 weeks before the kick-off call. The resource expresses nervousness and concern regarding the deliverables. The Project Manager wants to ensure that the deliverables are realistic.\n \nWhat is the appropriate action to take?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Implement a feasibility study, and then assess and review the results."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Hold a meeting with the project sponsor to discuss the resource's concerns, and revise the project charter"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Ensure that the concerns are documented in the issue log for later review."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Start to identify threats and preventive actions by performing a risk assessment."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The feasibility study will support the business case to begin a new project [PMBOK Guide Sixth Edition page 30]"
    },
    {
      "id": "a7dbebe2-0153-4be6-b268-8be2acb20ca7",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 146,
      "title": "A contract for a vendor providing materials on your project has an 8 percent reward for early delivery, and a 0.25 percent per day penalty for late delivery. The supplier has just notified you that they will be making the delivery six days late due a major earthquake in the region. The vendor requested force majeure terms to avoid penalties. A review of his contract shows there is no current force majeure term in effect. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Deduct the penalty, because there was no force majeure clause in the contract or proposal."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Do not penalize the vendor."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Ask the supplier and your procurement manager to sit down together and revise the contract to include the force majeure clause."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Consult your legal department for guidance."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Contact your legal department for advice. They will be in the best position to advise you of the remedies available for the vendor. Good faith negotiation is required by the PMI Code of conduct. Penalizing the vendor for late delivery caused by a natural disaster is not a good faith effort. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "c909d1e5-0373-4d87-98ae-27d6a7d0679b",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 147,
      "title": "The sponsor of your facilities upgrade project has left the company to join another organization. Several weeks later, you are reviewing the business case for the project, and you find that there are several inconsistencies between what is stated in the business case and what is described in the project scope. Further research shows that the business case as a whole is based on inaccurate information. What do you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Update the requirements"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Call the sponsor for clarification"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Notify your project stakeholders immediately"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Add this to the risk log"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Notify your project stakeholders immediately. They can determine the best path forward. An incorrect business case could have a serious impact on the usability of the final output of your project, or it could even impact the company's strategic goals. Failure to point out this error to the appropriate management is a violation of the PMI Code of Ethics. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "b48548d0-82eb-4d57-954c-e27940768e85",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 148,
      "title": "A project manager in a seller organization discovered that certain deliverables had been delivered to the buyer without undergoing proper testing. Recalling the deliverables will result in a cost overrun on the project. What should the project manager do in such a case?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Recall the deliverables even though there will be a cost overrun."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Wait for the procuring organization to get back with their list of defects in the deliverables."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Terminate the project."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Approach management to obtain additional funding to handle the potential cost overrun."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "It is the project manager's primary responsibility to ensure that deliverables are tested and have gone through the process outlined in the project management plan. Hence, the project manager should recall the deliverables, even it involves a cost overrun. Approaching management may be the next step. Terminating the project is not called for, and it will be unethical to wait for the procuring organization to do their testing and find out the defects in deliverables. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "1b071430-6c63-4295-95ca-e1337dff8fe0",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 149,
      "title": "One of the 12 Agile principles states that, “Business people and developers must work together daily throughout the project”. Which of the following Agile techniques helps achieve this?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Retrospectives"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Daily standups"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Kanban boards"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Backlog preparation and refinement"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Backlog preparation and refinement are the activities where the business (product owner) and the developers (Agile team) work together to define and prioritize project objectives. The rest of the choices are tools used by Agile teams not necessarily with the direct involvement of the business. [Agile Practice Guide, 1st edition, Page 98]"
    },
    {
      "id": "5e2439d3-4188-46c8-b0ce-300094b019dd",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 150,
      "title": "You are managing the development of an accounting system for your organization. You were preparing for go-live when you realized that the system is not compliant with a state regulation. You conduct a cursory root cause analysis and find out that the state regulation was announced months after the product design was approved. Fixing the issue will require at least six months of development and testing effort and this will cost the organization both in terms of direct cost and business value. The next internal audit is due in 10 months. What should you do now?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Issue a change request and ask for additional time and budget."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Cancel the project since it has lost business value and notify the sponsor."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Go-live with the system now but fix the issue before the next internal audit."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Reprimand the legal team for not keeping tabs on the government regulations."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "If the product is non-compliant, you must not go live. You need to issue a change request along with the justification for the change and new cost and schedule estimates. The change control board should decide the future of the project based on this information. You cannot simply cancel the project without authorization. Reprimanding the legal team at this stage will yield no benefit. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "2d1e61b5-637a-4f9f-a029-29a2675a8fee",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 151,
      "title": "A construction company initiates a project to build a shelter in a highly-populated region that has been recently destroyed by a natural disaster.\n\nWhich of the following represents the fundamental category of factors that led to the initiation of the project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Market demand"
          },
          {
            "k": "B",
            "s": 2,
            "t": "New technology"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Social need"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Legal requirement"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Building shelter in a region that has been recently destroyed by a natural disaster is an example of a project initiated to address a social need. Other examples include but are not limited to providing potable water systems, latrines, and sanitation education to communities suffering from high rates of infectious diseases. Note, the scenario describes a construction company, not a governmental organization. The fact of being a nongovernmental entity is important for the project to meet the definition of an initiative that addresses a social need. [PMBOK Guide  Sixth Edition, Page(s) 9]"
    },
    {
      "id": "3d1e238f-1852-475d-9261-95e53b0568ed",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 152,
      "title": "A customer requests a change in the technical approach for a product currently in development. The Project Manager learns about this request during a reoccurring project review.\n \nWhat should the Project Manager do in response to the customer's request?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Work with team members to immediately implement the new approach."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Have the team decide on the appropriate approach, giving them authority to implement their decision and validating their decision in talks with stakeholders."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Discuss the pros and cons of the proposed approach with stakeholders, then select the approach that is best for the team and notify team members."
          },
          {
            "k": "D",
            "s": 4,
            "t": "In order to obtain sponsor buy-in, have the team to benchmark the approach."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "As a technical issue the project management should address the team to assess and select the best options to solve, empower then and improving engagement. [The Agile Practice Guide The Twelve Principles Behind the Agile Manifesto, page 9  Servant Leadership Empowers The Team, page 33]"
    },
    {
      "id": "362869d5-6398-4126-a5a0-b3396d275803",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 153,
      "title": "During lunch with a project manager from another department, you are told it is sufficient to adhere to the project’s applicable standards. Regulations are not necessarily applicable to projects since they are guidelines, and you as the project manager have the option to decide whether they are applicable. Your own understanding is that:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Standards are mandatory requirements the project team creates; regulations are mandatory requirements issued by the government."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Standards are internally issued guidelines; regulations are government-issued guidelines."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Both are the same. The usage of the term varies depending on the country you operate in."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Standards are guidelines established by consensus and approved by a recognized body, while regulations are mandatory, government-imposed requirements."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Standards are regarded as guidelines developed by a recognized body and established by consensus. In contrast, regulations are government-imposed requirements. For example, building codes are an example of regulations. [PMI Code of Ethics and Professional Responsibility]"
    },
    {
      "id": "7271a201-0185-41ca-9406-9b9bfc237d6e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 154,
      "title": "You are currently developing project management guidelines for a recently established PMO. You are required to recommend good project management practices that can be applied to all organizational projects regardless of a project's size and complexity. As a guiding principle, a project can be authorized by any of the following except:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The sponsor"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The PMO"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The project manager"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The portfolio steering committee"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Projects are authorized by someone external to the project such as a project sponsor, project management office (PMO), or portfolio steering committee. A project manager does not authorize the project. [PMBOK® Guide 6th edition, Page 77]"
    },
    {
      "id": "0aa48535-cb1a-451b-9da0-eb230df237e5",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 155,
      "title": "Organizations just beginning to use Agile approaches may find prototyping challenging due to the associated rework which can also be viewed negatively. Which of the following techniques should be used to address the hurdles of transitioning to the use of Agile approaches?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Change management"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Risk management"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Scope management"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Scrum management"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Leaders should consider change management techniques to address the hurdles of transitioning to the use of Agile approaches. [Agile Practice Guide, 1st edition, Page 73]"
    },
    {
      "id": "9c06cc33-b895-419e-b3ff-f0c5a4f1cebb",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 156,
      "title": "You are helping an organization uplift its project management practices. You have recommended developing a business case for each of the organizational projects followed by development of a project benefits management plan. Who would you recommend to be the owner of the business case?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Project sponsor"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Project team"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Change Control Board"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Project manager"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The project sponsor is generally accountable for the development and maintenance of the project business case document. The project manager is responsible for providing recommendations and oversight to keep the project business case, project management plan, project charter, and project benefits management plan success measures in alignment with one another and with the goals and objectives of the organization. [PMBOK® Guide, 6th edition, Page 29]"
    },
    {
      "id": "5b1c8198-9828-4d73-bbe4-16b94450f545",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 157,
      "title": "You are working as a project manager on a critical project for your company. All staff on the project have signed non-disclosure agreements and are given access to information on a need-to-know basis. During the closeout phase of the project, a government agency contacts your company in regard to a possible tax fraud committed by a finance employee at the company. One of the agency’s representatives contacts you directly and asks you to provide information about your project. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Contact the appropriate management at your company for advice how to proceed"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Provide all the documentation that the agency requests"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The PMI code of ethics doesn’t permit you to share confidential information"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Your NDA doesn’t allow the disclosure of information to unauthorized parties"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Contact the appropriate management to ask them how to proceed. Your organization may wish to conduct its own investigation and provide a coordinated communications channel with the agency. Independently deciding to share or not share information with the agency without involving your company's management may be a violation of the company's policies. Further, sharing confidential information without approval of your organization, regardless of the requesting party, is a violation of the PMI Code of Ethics and Professional Conduct. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "b82e546e-ffff-4614-b8f6-75fc8794af39",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 158,
      "title": "You and appropriate stakeholders have conducted the project benefit analysis and developed the business case for a project to build a new robotic production line. The business case indicates that the total cost of the project will be $150,000 including installation and setup, and the cost savings are expected to be $40,000 annually.\n\nWhat can be said about this project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The $150,000 investment is considered a sunk cost at this point in the project"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The opportunity cost is too high to continue with this project"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The robot will pay for itself within three years"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The payback period is 45 months"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Payback period is the time it takes for the organization to earn back the initial investment (in terms of monetary cost) to the project and begin making profits. In this case, the $150,000 investment divided by the cost savings of $40,000 annually is 3.75 years or 45 months. Therefore, the payback period is 45 months, and the only correct answer among the available choices.\n\nThe topic of this question is only briefly mentioned in the PMBOK Guide. However, the Project Management Professional (PMP)^® Examination Content Outline (ECO) indicates that while there are some commonalities between the PMBOK Guide and the ECO, the exam is not bound by the PMBOK  Guide. The list of enablers specified in the tasks of the ECO domains is not exhaustive either. The ECO assumes that prospective PMP aspirants are familiar with other sources of information/preparation, including but not limited to PMI Code of Ethics and Professional Conduct, PMI’s Practice Standards (e.g., Scheduling, Earned Value Management, etc.); organizational behavior theories such as Tuckman’s Ladder, Theory X and Theory Y, Maslow's hierarchy of needs; commonly frowned upon project management practices, such as gold plating; and others. We intentionally have these questions in our simulator so that you would be better prepared for the real exam. PMP aspirants are encouraged to explore additional sources of information and/or to be familiar with them from their project management experience. [PMBOK Guide Sixth Edition, Page(s) 34-35]"
    },
    {
      "id": "ae7e19dc-85c7-490b-a5e5-8fa279ccd600",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 159,
      "title": "The project charter for a project in the initiation stage provides an initial budget estimate of $1,000,000. The project will take four years to complete, and the revenues will be realized at the end of the project when the property is sold at the anticipated selling price of $1,100,000. You are of the opinion that the project should proceed since it is profitable, but the director of finance disagrees.\n\nWhat might have you done wrong?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Neglected opportunity costs in the calculation"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Did not account for project risk"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Used nominal dollars instead of net present value (NPV)"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Failed to account for sunk costs"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The question indicates that costs will be incurred throughout the project, but the revenue will only be received at the end of the four-year-long project. The anticipated nominal selling price of $1,100,000 does not take into account the effect of inflation over the four-year period of the project. Using net present value (NPV) adjusts for inflation to get a more accurate assessment of the true value of future revenues. If the majority of the expense is incurred up front, then even a modest inflation rate of 3% could make the project unprofitable in terms of real value. Had you, as the project manager, used NPV in your calculation for net profit instead of nominal dollars, you would not have advocated for the project based on an anticipated profit of $100,000. The incorrect answer choices are all viable options for mistakes that may have been made, but there is no information from the description provided by the question to indicate such one way or another. Therefore, of the available choices, the only clear mistake that was made was the use of nominal dollars instead of NPV. PMBOK Guide Sixth Edition, Page(s) 34]"
    },
    {
      "id": "f74f6209-8145-4793-8f0b-c2190d1d51ae",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 160,
      "title": "A Project Manager has been asked to conduct a risk analysis that is based on a high-level scope. As part of the this analysis, the Project Manager must use expert judgment to prepare a document.\n \nWhich document-based action is being performed?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Creating the project charter"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Preparing the scope statement document"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Creating a project management plan"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Documenting the risk management plan"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Project manager is asked to work on risk analysis on high-level scope. High-level scope was defied at Project Charter. Expert judgment is one of the tools and techniques for developing the project charter. [PMBOK® Guide Sixth Edition page 79]"
    },
    {
      "id": "1e8f6ca7-d2fb-44ac-a3a6-bc9011c404b7",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 161,
      "title": "Your organization has been awarded a contract by a major US oil company to build 500 US-style houses and 10 office buildings in a Middle Eastern country so that its American employees feel more like home when working abroad. There is a lack of workforce in this country skilled in US-styled construction. You cannot take the entire construction crew from the US to the site for this entire project due to cost constraints. Which of the following is LEAST recommended?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Consider taking the crew to build a few model houses and buildings."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Consider training the local workforce."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Outsource the project to local subcontractors and make US-style construction part of their contractual obligations."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Bring the senior construction managers from the US and hire the rest of the crew from the local market."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "If there is a shortage of a specific skill in the market, you need to determine ways you can meet the requirement. You cannot shrug the responsibility off your shoulders by outsourcing the project to multiple subcontractors and making US-style construction part of their contractual obligations, especially when you know that the local market is not skilled in US-style construction. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "97ba9c67-4904-480d-8bce-049a86a179f4",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 162,
      "title": "You are in the Validate Scope process of your electronic goods manufacturing project. While reviewing some products, you have noticed that the tolerance for one product is 0.01 percent less than what was listed in the requirements documentation. This deviation may not be a problem for the customers, and it may not impair the product’s operation. What is your best immediate action in such a situation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Change the project management plan to allow for small deviation"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Notify the stakeholders about the deviation"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Discuss with your team about the quality testing"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Reject all products and restart the project"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "When you find a defective product, you must notify stakeholders immediately even if the deviation may not affect customers. As a project manager, you must maintain honesty and should not hide facts. After notifying the stakeholders, the project manager must discuss the issue with the team and change the project management plan based on the stakeholders’ inputs. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "492c7b79-76da-45fb-a775-545754f28f22",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 163,
      "title": "You are in the process of monitoring the overall progress on your project. During this process, you have captured details of an effective response to a variance encountered on the project.\n\nWhat is the main reason for documenting this knowledge?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "To ensure project benefits have been realized"
          },
          {
            "k": "B",
            "s": 2,
            "t": "To keep stakeholders engaged and informed"
          },
          {
            "k": "C",
            "s": 3,
            "t": "To support continuous improvement efforts"
          },
          {
            "k": "D",
            "s": 4,
            "t": "To satisfy requirements set forth by the PMO"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Enabling continuous improvement is one of the project manager's responsibilities. Continuous improvement can be achieved by capturing, analyzing, and managing lessons that are learned throughout the project life cycle. The question implies that the lessons learned register had been updated with an effective response to a variance encountered during the Monitor and Control Project Work process. Lessons learned during the project should be captured in the lessons learned register where it can be used to improve performance on the current project. At the end of the project, the information documented in the lessons learned register is then transferred to an organizational process asset called the lessons learned repository, where the information can be used to benefit future projects. Therefore, of the available choices, the main reason for documenting knowledge gained during the project is to support continuous improvement efforts. [PMBOK Guide\nSixth Edition,  Page(s) 113, 104]"
    },
    {
      "id": "2f45cd1a-5951-4a9d-b3c7-550d21737871",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 164,
      "title": "A company is looking for an experienced project manager to manage a large construction project. You meet all the requirements for the position except for one: The organization is looking for a certified PMP with five years of experience, but you have just four years of experience managing similar projects. \nWhat is the best way to fill out your application?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Explain why years of experience should not matter."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Show how you meet the requirements but include your actual years of experience"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Since you have plenty of experience, embellish your actual years of experience."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Do not fill out that particular section."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "For project management professionals, honesty is the best policy. You should never mislead others about your experience in the field or your knowledge of the project management processes. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "b2996022-37a5-4ccf-83c2-33f40a45494c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 165,
      "title": "You diligently gather all the available information about the project and produce a draft of the project charter, which you submit to the sponsor for approval. The following day the sponsor calls you and states that the charter is missing an essential element.\n\nWhat did you most likely neglect to include?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The scope baseline for the project"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The project schedule"
          },
          {
            "k": "C",
            "s": 3,
            "t": "A detailed project description including boundaries and all deliverables"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The business needs to be satisfied with the execution of the project"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The business needs to be satisfied with the execution of the project are a significant component of the project charter and should always be included. Although each of the other answer choices is important to the successful completion of the project, none are available to be included in the project charter during the Initiating phase of a project."
    },
    {
      "id": "dd330a9a-45f5-437a-a8b3-dd28372211be",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 166,
      "title": "You are leading a project to renovate a faulty waste treatment facility, which will use the same waste disposal techniques as those currently in place. However, legislation for more stringent waste disposal techniques will likely be voted on in the near future.\n\nHow should you handle the legislation during the development of the project charter?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Ignore the legislation as it is an enterprise environmental factor\noutside the project scope"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Assume that the legislation will not pass during construction and update\nthe assumption log accordingly"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Consider the legislation a constraint of the project"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Identify the legislation as a high-level risk that should be documented"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "If passed, the legislation described in the scenario will require the project to implement waste disposal techniques that will be of more stringent standards than those currently planned for the project. The chance that legislation might pass during construction presents a risk that if realized, could have major implications on project constraints and may have a negative impact on the outcome of the project. Therefore, you should handle the legislation for more stringent waste disposal techniques as a high-level project risk that should be documented during project initiation. Later on, during project planning, the risk will be addressed by the processes of the Project Risk Management Knowledge Area where a risk response plan can be put in place to address the issue if needed. [PMBOK Guide Sixth Edition, Page(s) 31-32, 78]"
    },
    {
      "id": "a3b9c196-a95d-4a43-b341-e44723bf9425",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 167,
      "title": "Cindy has been working in a manufacturing project as a project manager. This project is intended to produce high-quality semiconductors to use in computers. Since semiconductors are produced from silicon wafers, she contracted a company to provide silicon wafers to the project on an ongoing basis. For unknown reasons, the contractor provided low-quality wafers to the project, compromising the electrical performance of the semiconductors. Overwhelmed by complaints from the computer division, Cindy is now obligated to correct the manufacturing defects to avoid future liabilities. In this scenario, the costs Cindy incurred are:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "External failure costs or Cost of nonconformance"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Prevention costs or Cost of conformance"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Appraisal costs or Cost of nonconformance"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Internal failure costs or Cost of conformance"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "In this scenario, Cindy is performing warranty work to correct manufacturing defects. These defects are identified by external customers, and the costs are known as external failure costs. These costs are also known as costs of nonconformance because the product did not meet the quality requirements. The cost of nonconformance is a part of the cost of quality. Therefore, Cindy is incurring external failure costs or costs of nonconformance. [PMBOK® Guide 6th edition, Page 283]"
    },
    {
      "id": "8b075d4f-8cc0-4b72-8cf8-60f8f7185067",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 168,
      "title": "You are leading an Agile team currently developing a mission-critical system. The product is complex as some of the critical requirements haven’t been clearly defined. You and the team understand that this project will involve a high degree of change and uncertainty. How should be the product complexity by tackled in this case?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Select simpler and clearer but valuable requirements to be prototyped and developed first."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Select complicated and clearer requirements to be prototyped and developed first."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Select a subset of the requirements randomly and develop them through prototyping."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Select the most complicated and ambiguous requirements to be prototyped and developed first."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "When product complexity is high, the team should be encouraged to determine simple solutions that would work and apply the Agile principle of “Simplicity – the art of minimizing the amount of work that needs to get done”. This helps reduce complexity. [Agile Practice Guide, 1st edition, Page 59]"
    },
    {
      "id": "eda1b788-d9db-4fb6-b69e-24f838a80cba",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 169,
      "title": "You have been assigned a new project. The project involves disruptive technologies. The project scope is not clear which has introduced a lot of risk into the project. You have requested to use Agile to manage this project. Why?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Agile techniques and approaches effectively manage project risk."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Agile techniques and approaches effectively manage scope changes."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Agile techniques and approaches effectively manage disruptive technologies."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Agile techniques and approaches effectively manage disruptive technologies, scope changes and project risk."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Agile techniques and approaches effectively manage disruptive technologies, scope changes and project risk. [Agile Practice Guide, 1st edition, Page 2]"
    },
    {
      "id": "67daed58-8cbf-4dba-bdbc-970e1574dbea",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 170,
      "title": "A company is considering two projects, project A with the internal rate of return (IRR) of 25% and project B with the IRR of 15%.\n\nWhich project should the company select and why?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Project B because a lower IRR represents lower costs"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Project A because it has a higher IRR"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Project B because a lower IRR represents a shorter payback period"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Project A because letter \"A\" comes before \"B"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The internal rate of return (IRR) is the interest rate at which the cash inflow and cash outflow of the project equal zero. The IRR can be an important metric for benefits analysis. The PMP exam will not likely ask you to calculate the IRR. However, two important concepts should be understood for the exam. First, a positive IRR means a positive rate of return. Second, all other things being equal or no other details are provided, a project with a higher IRR is typically selected over a project with a lower IRR. In the scenario described, the company should select project A with the IRR of 25% over project B with the IRR of 15%. [PMBOK Guide  Sixth Edition, Page(s) 34-35]"
    },
    {
      "id": "fc410ce9-15e5-48bd-8164-9954a4d1e52d",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 171,
      "title": "A project manager prepared quantitative assessments of the probable costs required to complete a project and produced activity cost estimates. He or she also prepared some supporting detail for these estimates. Which of the following would not be a supporting detail for cost estimates?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Documentation of the basis of the estimates"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Indication of the confidence level of the final estimate (ex: 90 percent )"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Indication of the profit margin that can be expected on the project"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Indication of the range of possible estimates (ex: $5,000 +/- 5%)"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Indication of the profit margin that can be achieved on the project is not a supporting detail for cost estimates. The focus of the Estimate Costs process is to perform a quantitative assessment of all costs that are probably required to accomplish the project work. [PMBOK® Guide 6th edition, Page 247]"
    },
    {
      "id": "c1f43428-4b12-41f1-a258-41e34f520d4e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 172,
      "title": "You are managing a project for your company constructing an office complex in another country. The construction work on two of the buildings is complete, and those buildings are ready for move-in. However, the construction supervisor informs you that you must pay a fee to a local government agency to issue an occupancy permit for any new construction in that country. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Notify project stakeholders that you have been asked to pay a bribe"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Do not pay the fee"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Ask your legal department if this is legal"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Pay the fee"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Pay the fee to the local agency. Because it is a standard fee for a permit that is required of all new construction, it is not a bribe. PMI's Code of Ethics and Professional Conduct prohibits accepting or paying bribes. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "afbfe2a4-b59a-4738-9cef-01cc36915c2c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 173,
      "title": "The manager of a project to design a new device is an electronics engineer but is not an expert in the technology used for this device. The client has requested a specification change in the design. The project manager brings the request to the project’s design leader. After reviewing the request’s details, the design leader states there are no experts in this technology in your organization. As a result, your team cannot assess the full impact of the requested change on the project. What should the project manager do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Reject the change, because it was not included in the project specifications"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Hire an outside consultant to provide the necessary expertise to evaluate the request"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Accept the change and note the lack of expertise as risk to the project"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Consult the sponsor"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The project manager’s best option is to hire an outside consultant to provide the necessary expertise to evaluate the request. Once the project manager has a better understanding of the feasibility of the request, he or she can bring it to the project stakeholders for discussion. PMI requires project managers to work within the realm of their experience and skills. Forming a recommendation to accept or reject the change without consulting an expert would be a violation of the PMI code. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "6d9c9668-938d-4a61-bfde-5f813a367c9e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 174,
      "title": "You are leading an XP software development project. Recently you found out that the underlying technology being used is unstable and has impacted several features already released. What should you do first?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Call a retrospective and discuss how such problems can be avoided in the future."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Explain the impact to the product owner."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Replace the unstable technology with a more stable one."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Apply pair programming technique."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Right now you have a major issue at hand that has impacted a big number of features that have already been released. Since the product owner is ultimately responsible for the system development, the first thing you need to do is present the impact to the product owner. [Agile Practice Guide, 1st edition, Page 153]"
    },
    {
      "id": "bf44c277-2cb0-46eb-a71d-a383cb2633a9",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 175,
      "title": "You are leading a complex organizational process automation project and are having a hard time in gathering and validating the requirements. You have recently formed a team of SMEs to help you with the requirements collection and documentation. The SMEs have now provided a huge set of diverse requirements. In order to reach a consensus among experts, which technique can be applied?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Variance analysis"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Facilitation"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Delta technique"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Monte Carlo method"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Well-facilitated sessions can build trust, foster relationships, and improve communications among the participant, which can lead to increased stakeholder consensus. [PMBOK® Guide 6th Edition, Page 145]"
    },
    {
      "id": "31bce8ea-510f-4301-b5ce-24aa1c1edc8b",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 176,
      "title": "You have recently taken over a project that is about to enter the execution stage. In order to get your head around the project, you started reviewing the project communications that happened prior to the project initiation and the project’s business case. You are not happy with the way the business case was put together because it doesn’t contain:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The project's BAC and ETC"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Project WBS"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Variance Analysis"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Identification of alternatives"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The business case for any project includes the analysis of the situation, recommended solutions and Identification of alternative solutions. [PMBOK® Guide 6th edition, Page 31]"
    },
    {
      "id": "d20eced3-49a4-4f78-8493-1dc18ec774a9",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 177,
      "title": "A project team has recently presented the project cost estimates of a project. The team doesn’t have any past experience of performing similar projects. This could be a major risk with the project but the team is of the view that they have included sufficient reserves in their estimates. What is the primary risk when including reserves, or contingency allowances, in your cost estimate?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Cancelling your project"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Overstating the cost estimate"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Understating the cost estimate"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Tracking the funds"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Contingency funds are used to handle cost uncertainty due to unforeseen events during a project. These funds are generally used for items that are likely to occur but are not certain to occur. If the team has no prior experience of similar projects, there is a risk that the team has overestimated the reserves to compensate for their lack of experience. [PMBOK® Guide 6th edition, Page 245]"
    },
    {
      "id": "5ff8c20b-ffd6-4e16-b1b8-ab9b6afd529f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 178,
      "title": "The usual moderator for your company’s weekly project review meeting is on vacation, and you have been asked to lead the meeting in his absence. While compiling the project reporting data to go into the master status report that is submitted to the executive team, you discover there are several projects that are reporting a negative CV, but the master report shows these as positive. What do you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Change the report to show accurate status"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Ask the regular moderator about the discrepancies when he returns"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Change the status report to show accurate status and report the discrepancies to the appropriate management"
          },
          {
            "k": "D",
            "s": 4,
            "t": "File a complaint with PMI"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "You should change the status report to reflect accurate project status and report this to the appropriate management. Project managers are required to provide accurate and timely information about projects and to inform appropriate management about the errors and omissions of others. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "d1bb3b71-2c91-45c8-b223-f3009d664b5c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 179,
      "title": "You are managing a business process optimization project for a client organization. Early during the project, you found out that the client’s IT department has initiated a business workflow automation project and one of the processes being automated is the one your team is trying to optimize. You are concerned with this overlapping project scope. What should you do now?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Escalate the issue in accordance to your contract."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Escalate the issue to the change control board."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Wait for IT to finish automating the process and then conduct a gap analysis."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Issue a change request for additional time and budget."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Sometimes projects with overlapping scope do get initiated. The only solution to this problem is managing communications. Since you are performing this project under a contract for a client organization, you need to escalate the matter in accordance with your contract. [PMBOK® Guide 6th edition, page 379]"
    },
    {
      "id": "78c09e9b-4e0e-4f7f-9965-0bfbbccdf6e9",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 180,
      "title": "Organizations usually prefer in-house Agile coaching instead of getting it from external coaches. This is due to:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Internal coaches cost less than external coaches."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Internal coaches have a wider breadth of cross-industry experience."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Internal coaches have stronger relationships in their organizations."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Internal coaches are more reliable."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Both external and internal coaches can be reliable. Internal coaches can be cheaper if they are 100% allocated to coaching, which is usually not the case. However, the benefit of internal coaches is their stronger relationships which they can use to be more effective. [Agile Practice Guide, 1st edition, Page 41]"
    },
    {
      "id": "0f6dee1c-a1d0-4a80-9a1b-279d8f535f4d",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 181,
      "title": "Danny is working as a project manager for a company that provides outsourcing services to banks. Recently, he sent a proposal to a local bank in response to a bid for a data warehouse project for which his company lacks expertise. Although his company lacks expertise, it has had a good working relationship with the bank in all its other projects. Which of the following statements is correct considering the proposal Danny submitted?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Danny has violated the company policy but not the PMI code"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Danny has violated the procurement code but not the PMI code"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Danny has not violated the PMI Code of Ethics and Professional Conduct."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Danny has violated the PMI Code of Ethics and Professional Conduct."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "One of the mandatory standards for a project manager is to behave responsibly and bid on only those projects for which the project manager’s employer has expertise and skills. Since Danny bid on a project for which his company lacks expertise, he violated the PMI Code of Ethics and Professional Conduct. There is no procurement code in project management. [PMI Code of Ethics and Professional Responsibility]"
    },
    {
      "id": "77d3639b-3bc7-4296-b74d-9f1950792718",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 182,
      "title": "A project team member ran an earned value analysis (EVA) report that showed an unexpected spike in actual costs over the last three weeks. The team member showed the report to the project manager and based on her analysis presents four possible reasons for the spike.\n\nWhich reason is most probable?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Soaring steel prices have impacted the fixed price with economic price adjustments procurement contracts"
          },
          {
            "k": "B",
            "s": 2,
            "t": "There was a strike at the loading dock which delayed many needed steel shipments until today"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Fewer employees are showing up for work the past two weeks causing a\nbacklog of unfinished work"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Much higher than expected quarterly bonuses were given to executives during that three week period"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Earned value analysis (EVA) is an example of the data analysis techniques that can be used as part of the processes in the Monitoring and Controlling Process Group. In the context of this question, the team member has applied the technique to the Control Costs process. By analyzing the earned values and associated costs of the project, the project team can react or make adjustments or request changes. To know the appropriate action to take, the project manager must know how to interpret the data. In the scenario, the variability of the steel prices would be a probable cause of the actual costs spiking beyond the planned values. The other three options do not directly impact the actual costs of the project within the scenario's circumstances. [PMBOK Guide Sixth Edition, Page(s) 261, 471]"
    },
    {
      "id": "868878c2-d252-432a-8e29-244b739169b0",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 183,
      "title": "A project manager has been assigned to a project just after the project charter was signed. The project manager conducted a benefits analysis with stakeholders which confirmed that the project was in alignment with the organizational strategy and expected business value. The project is now complete, and everybody agrees it was successful in meeting objectives for scope, schedule, and budget. However, the project was a failure from a business point of view.\n\nWhat most likely happened?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The competitive landscape changed"
          },
          {
            "k": "B",
            "s": 2,
            "t": "It is not possible for a project to meet its objectives and not be successful from a business perspective"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The project manager failed to execute the project management plan properly"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The benefits analysis was fundamentally flawed"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "It is possible for a project to be successful from a scope/schedule/budget viewpoint, and to be unsuccessful from a business perspective. This situation can occur when there is a change in the business needs or the market environment before the project is complete. A change in the competitive landscape may very well cause a project to meet its objectives but fail to deliver the intended benefits. For example, let's say that a pharmaceutical company develops a drug to treat the symptoms associated with a certain disease. Just as the new drug is ready for market, a competing company discovers a cure for the same disease. The drug developed to treat the disease has just been made obsolete by the cure. The project to develop the drug may have been successful in meeting its objectives for scope, schedule, and budget, but would fail to deliver the intended business value from selling the drug. [PMBOK Guide  Sixth Edition, Page(s) 35]"
    },
    {
      "id": "f20eddab-54b9-4654-970d-ec747cabd46f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 184,
      "title": "Impact mapping helps organizations determine which products to develop. It is a technique for building shared understanding between leaders and project teams. In Agile projects, who leads this work?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Agile team"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Servant-leader"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Product owner"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Scrum master"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Typically the product owner leads the impact mapping work. A servant-leader may facilitate any necessary meeting as a way of serving the project. [Agile Practice Guide, 1st edition, Page 52]"
    },
    {
      "id": "2810d45f-ac33-47d1-b531-2253e204b654",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 185,
      "title": "An RFP has been issued for services on your project. Citing time constraints, the project sponsor insists that the RFP be provided to only a handful of specific vendors rather than putting it out for public bid as your company typically does. During the vendor selection process, you learn that the project sponsor’s wife is an executive at one of the responding vendors. What do you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Do nothing"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Disqualify the vendor"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Excuse yourself from the interviewing process"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Notify the appropriate management of this potential conflict of interest"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Notify the appropriate management that there is a potential conflict of interest. Once they understand the circumstances, a plan of action can be developed. PMI's Code of Ethics required project managers to proactively report conflicts of interest to the appropriate management. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "b95ae602-93e1-40f1-9dc6-9e47f2c2b55a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 186,
      "title": "The software company where you are a project manager is attempting to make a sale to a large manufacturing company. The sales team has learned that a competing company where you had worked as a project manager several years before is also trying to get this same business. The sales team asks you to provide confidential information about your former employer‘s products and corporate operations in an attempt to gain a competitive advantage. \nWhat should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Inform your manager"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Provide the information"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Decline to provide the information"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Provide information with the caveat that you remain anonymous"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "c",
      "explanation": "Decline to provide the information. Project managers are required to protect the intellectual property of others. This situation is a clear conflict of interest between the current and former employers. Project managers must conduct themselves in a fair and honest manner and keep confidential information to themselves, as stated in the PMI Code of Ethics. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "9729c76d-b776-4557-a54b-71343f57f3fa",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 187,
      "title": "An agile team is working on a software release with an initial backlog of 720 story points. During sprints two to four, new user stories have been added. The following burndown chart represents the progress the team has made so far. The project manager has been requested to update the stakeholders on the project's status.\r\n\r\nWhat should the project manager tell the stakeholders?",
      "description": "",
      "image": "https://storage.pmcbd.net/uploads/question/1b7c2710-b976-48c7-a89b-86d670354201.jpg",
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "There is not enough information for the project manager to provide any status."
          },
          {
            "k": "B",
            "s": 2,
            "t": "The project team will not be able to complete the release on time."
          },
          {
            "k": "C",
            "s": 3,
            "t": "The team was only able to keep up with the scope added during these sprints."
          },
          {
            "k": "D",
            "s": 4,
            "t": "The project is progressing more quickly than initially planned."
          },
          {
            "k": "E",
            "s": 5,
            "t": "None"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "A release burndown chart is a visual representation, which displays the amount of work left to complete the target commitment for a product release. The chart accomplishes this by displaying the actual amount of work remaining to complete the release. The concept behind the burndown chart is that the amount of remaining work will burn down as time goes by until the team gets to 100% done for the release. New user stories have been added during the sprints two to four. If the team did not complete any work during those sprints, the curve of the burndown chart that represents the actual work completed would have pointed upwards. However, since the curve is flat, one can imply the team has completed the work that has been added, but not more than that. In other words, the team was only able to keep up with the scope added during these sprints."
    },
    {
      "id": "c50904e0-80be-4120-9d7f-6b3dddc6cefe",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 188,
      "title": "Your organization has initiated multiple projects during the current financial year and most of the projects are now struggling due to insufficient human resources available to execute all projects at the same time. As a seasoned project management professional, how would you advise the management to handle this issue?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Prioritize the projects based on business value and resource availability."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Execute the smaller projects first so that the maximum number of projects can be completed during the year."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Increase the budget and timeline for all projects so that the resources can be efficiently shared."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Prioritize the projects with higher ROI."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Projects compete for resources and the solution to this problem is prioritization. However, project prioritization is not always dependent on ROI (e.g., for some projects the ROI calculation is difficult due to intangible benefits). It is recommended to prioritize the projects based on business value. [PMBOK® Guide 6th edition, page 7]"
    },
    {
      "id": "e5ea9b0e-e183-4e3a-b199-40d36456c126",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 189,
      "title": "Danny works as a project manager for a company that provides outsourcing services to banks. Recently, he sent a proposal to a local bank for a data warehouse project for which his company lacks expertise. Although his company lacks expertise, it has a good working relationship with the bank in all its other projects. Which of the following statements is correct considering the proposal Danny submitted?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Danny has violated the Procurement Code but not the PMI code."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Danny has not violated the PMI Code of Ethics and Professional Conduct"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Danny has violated the PMI Code of Ethics and Professional Conduct"
          },
          {
            "k": "D",
            "s": 4,
            "t": "None of the above"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "One of the mandatory standards for a project manager is to behave responsibly and bid on only those projects for which his or her employer has relevant expertise and skills. Since Danny bid on a project for which his company lacks expertise, he violated the PMI code of ethics and professional conduct. There is no procurement code in project management. [PMI Code of Ethics and Professional Responsibility, Page 3]"
    },
    {
      "id": "1516cd85-5ba7-4335-821b-512b8a2eacd8",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 190,
      "title": "A project team learns that there is a new compliance requirement from an international entity that may impact the baseline business case for the project. They learn this right after project charter is completed and the project sponsor has signed. \n \nHow should the Project Manager proceed?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Research the requirement and possible consequences, then give the sponsor a recommendation."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Address the requirement through the creation of a quality management plan."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Decline to address the issue, as the new requirement is not part of the project's documented scope."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Ensure that the requirement is documented in the risk register, then ask for further guidance from all stakeholders."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The context of this scenario demands the Project Manager to influence the organization (sponsor) and recommend next steps after reviewing and understanding compliance requirements and consequences. [PMBOK® Guide Sixth Edition  page 78]"
    },
    {
      "id": "38907f5b-2d52-49bd-9b0f-a631f4912cac",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 191,
      "title": "You are finalizing payments to a vendor on a three-year-long project, but some of the procurement records were lost in the first year. The vendor has disputed a penalty that was deducted from their payment, maintaining that he is not at fault because the delay was a result of a last-minute change in specifications by your project team. He is willing to bear some portion of the penalty, but not the full charge. You contact your legal team to discuss the situation. After reviewing all the available documents, the legal team suggests litigation. Which one of the following would be the best course of action?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Deduct the penalty"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Go for litigation"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Do not deduct the penalty"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Attempt an alternate source of mediation"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Attempt an alternate source of mediation. There is some fault on both parties, and the lack of complete project records could work against both parties. Thus, a good faith negotiation process will be the best approach in the situation. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "f8f51951-dd2b-4473-aabf-9ae69d508c11",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 192,
      "title": "A new law is expected within the next four-to-five months that will affect the business’ type of products. The next product launch is starting, and should be completed within three months. Unfortunately, the new product would not meet the requirements of the proposed law.\n \nHow should the Project Manager respond to this potential problem?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Schedule a meeting with the sponsor and key stakeholders to discuss risks and using the results of the meeting, revise the assumption log and project charter."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Revise the risk management plan and move ahead with planning the project."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Move ahead with the project; following the plan and ensure on-time completion, so that the product will not be affected by any possible rule change."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Schedule a meeting with the sponsor and key stakeholders to warn them about the law and advise them to cancel the project until the legislation is finalized."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "This new law can have a profound effect on the project. It will certainly lead to new potential risks, new assumptions and a possible charter change.  [PMBOK® Guide Sixth Edition page 81]"
    },
    {
      "id": "e8e4e501-8ccf-4dec-afc2-cb346997b56d",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 193,
      "title": "As a project manager, you are developing the project charter for your new project. In reviewing the business case, you have noticed that an important element was not included in the economic feasibility study.\n\nWhat is the best course of action for you in this situation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Disregard the missing information as the project sponsor should be developing the project charter and not the project manager"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Update the business case with the missing information as necessary"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Escalate the issue with the business case to the project sponsor along\nwith recommendations"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The business case is not an input to the project charter, so the missing\ninformation is not relevant at this early stage of the project"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The project charter incorporates the appropriate information for the project from the business documents which include the business case and benefits management plan. The project manager does not update or modify the business documents since they are not considered project documents.\nThe project manager does not have the authority to update the business case as it is commonly used for decision making by managers or executives above the project level. However, the project manager may make recommendations. Therefore, of the available choices, escalating the issue with the business case to the project sponsor along with recommendations is the best course of action in this situation."
    },
    {
      "id": "41d857ee-d453-49f1-90dc-45e29428bf14",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 194,
      "title": "A project is about halfway complete. As the project manager, you receive formal notification from the customer that they no longer have funds available to continue the project. After further research, you learn that your customer is liquidating the company and selling off all assets to a competitor for pennies on the dollar.\n\nWhat should you do next?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Start the Close Project or Phase process"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Stop all work on the project and redeploy the resources to other projects"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Release the project team"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Put the project on hold until the acquiring company decides on how to proceed with the project"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Even though the project has been terminated by the customer, the Close Project or Phase process must be performed. The Close Project or Phase process establishes procedures to investigate and document the reasons for actions taken if a project is terminated before completion. Additionally, the project information will need to be archived, and established procedures followed to transfer finished and unfinished deliverables. The project team will then be released as part of the Close Project or Phase process. [PMBOK Guide  Sixth Edition, Page(s) 123, 128]"
    },
    {
      "id": "02029480-b5ce-4ba3-9238-24a0c0cbc6ae",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 195,
      "title": "You are leading a complex multi-phase construction project. The project requires construction of a new airport terminal along with all ancillary facilities required to smoothly operate the terminal. For this project, the procurement team has decided to close all procurements applicable to a particular phase of the project. What happens to unresolved claims at this stage?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Unresolved claims remain open for a period of one year from closure of procurements."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Unresolved claims are also closed when the procurements for that phase are closed."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Unresolved claims are usually resolved at the end of all phases of the project."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Unresolved claims may still be subject to litigation after closure."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Even after the procurements for a particular phase are closed, unresolved claims are still subject to litigation. [PMBOK® Guide 6th edition, Page 498]"
    },
    {
      "id": "3caf7551-0375-4fdd-bb43-1e2aff6df960",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 196,
      "title": "You are responsible for designing and a new handheld gadget followed by a mass rollout to the market. The project has been requested as a result of your organization’s blue ocean strategy, and if successful, will creating a market for its own. However, there is a high degree of uncertainty around the requirements which can only be uncovered through prototyping. Which of the following approaches is most likely to succeed?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Using a hybrid model; Agile approaches for the design phase followed by a predictive approach for the rollout."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Using a predictive approach for both design and rollout."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Using a hybrid model; predictive approach for the design phase followed by an Agile approach for the rollout."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Using an Agile approach for both design and rollout."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Since the product requirements are not known upfront and can only be discovered through a series of prototyping iterations, an Agile approach is suitable for the design phase. Once the product is developed, the mass rollout can be manage using a predictive life cycle. [PMBOK® Guide 6th edition, page 19]"
    },
    {
      "id": "f132a75f-5731-440b-862a-493b77e35467",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 197,
      "title": "You are managing the development of an information management system for a railway operator in your city. The information system will have to interface with multiple digital and manual systems in order to be fully operational. You want to graphically depict the system’s scope along with the interactions with the other systems. Which of the following graphical techniques visually depict the product scope by showing a business system and how other systems interact with it?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Ishikawa diagram"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Histogram"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Context diagram"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Influence diagram"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "A context diagram is a graphical technique that visually depicts the product scope by showing a business system and how other systems interact with it. The other choices are graphical techniques designed to achieve other objectives. [PMBOK® Guide 6th edition, Page 146]"
    },
    {
      "id": "d3e89cfa-dc53-4bae-8384-19a3325eafa2",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 198,
      "title": "You meet with the project sponsor to discuss the sponsor's idea which triggered the project. Even though the concept for the project is new and untested, the sponsor believes that the company's development team is prepared to execute her vision. You start documenting the reasons the sponsor thinks the company is capable to deliver this untested concept.\n\nWhich project document is being created?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Communications management plan"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Assumption log"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Requirements documentation"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Lessons learned register"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "There are a couple of ways you can determine the correct answer in this scenario. In one method, you would need to understand that the project management activities described in this scenario are part of the Initiating Process Group, and that the assumption log is the only project document of the four answer choices that is an output of a process in the Initiating Process Group, making the assumption log the only viable answer. The second method relies on knowing the meaning of an assumption. An assumption is a factor in the planning process that is considered to be true, real, or certain, without proof or demonstration. The assumption in this scenario is the sponsor's belief that the development team has the capabilities to deliver an untested concept. Documenting this assumption implies that the assumption log is being created, making the assumption log the best answer to the question asked. [PMBOK Guide Sixth Edition, Page(s) 81]"
    },
    {
      "id": "841b41e0-f3ad-4ec9-9ccd-d845f2d739e5",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 199,
      "title": "Your customer has just called and said they must have the final project schedule three weeks earlier than they previously stated. You have not yet completed the WBS, so you ask a colleague for advice as to how to proceed. Your colleague advises you to forget about finishing the WBS, ask the team to provide estimates based on past projects, and add those estimates together to come up with a date. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Follow the colleague‘s advice"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Pad the reserves an additional 20 percent"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Advise the customer that the shortened delivery time could significantly affect the accuracy of both the cost and schedule. Then, create a WBS and ask the team to provide analogous estimates of both timing and reserves required. Create the schedule based on this"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Create a WBS and ask the team to provide analogous estimates of both timing and reserves required. Create the schedule based on this and note the shortened schedule delivery deadline to the risk log."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Always advise the customer whenever there is a potential impact to scope, cost, or schedule. Failure to do so for any reason—even when requested by the customer—is unprofessional. Project managers must always provide accurate project information and follow all processes and policies. Following the colleague's advice to modify or not follow project management processes, noting the shortened delivery date in the risk log, and padding the reserves would all represent violations of the PMI code. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "3838cf5a-0649-4db9-8c10-e2d03fe540f0",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 200,
      "title": "You are the project manager of a project executing work under a contract signed with a buyer organization. Just after the project has started, you notice that the buyer organization had made a mistake in the financial terms, and your organization stands to benefit considerably from this oversight. What should your stance be?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Informally check with your counterpart in the buyer organization to see whether he or she noticed this error."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Bring the error to the notice of the buyer organization and have an amendment made to the contract since this was in good faith."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Do not take any action since a contract is a binding and legal document."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Discuss with your management how you could gain a bonus due to the increased revenue your company stands to gain."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The ethical thing to do would be to bring this to the notice of the buyer organization and have an amendment made to the contract. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "5a5badbf-baed-4d3a-8c2e-2b4116535b74",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 201,
      "title": "The project sponsor asks the project manager how they plan to meet customer expectations and ensure the achievement of project objectives.\n\nWhat is the best response the project manager can provide to the sponsor?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Identify key deliverables based on the customer requirements"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Develop a perfect project management plan"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Maintain quality of the deliverables within six sigma standards"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Make sure each project risk has a response and an owner"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Business requirements describe the higher-level needs of the organization as a whole, such as the business issues or opportunities, and reasons why a project has been initiated. Key deliverables are specified in the project charter, which is the document issued by the project initiator that formally authorizes the existence of the project. The project charter establishes a partnership between the performing and requesting organizations. A requesting organization is typically referred to as a customer. In order to manage customer expectations and direct the achievement of project goals, project managers have to identify key deliverables based on the business requirements provided by the customer.\nIt is hard to assume there is such a thing as a 'perfect' project management plan. [PMBOK Guide Sixth Edition, Page(s) 77-79, 81, 148]"
    },
    {
      "id": "e929c4a7-d126-408d-9464-f566cae9eea0",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 202,
      "title": "You have recently taken over a troubled automobile project, which has gone out of control. The project team missed many deadlines, and stakeholders were displeased with the project’s progress. As an experienced project manager, your first priority is to align the schedule with the project plan. You would like to use what-if scenario analysis to see how various factors affected the project schedule so you can develop a plan to reduce the impact of adverse conditions on the project schedule in the future. \nWhat would be your next course of action be, once you determine the factors that created schedule overruns?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Generate change requests for a corrective action"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Update activity lists to incorporate new activities into the schedule"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Prepare a resource breakdown structure to identify resources used"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Develop project schedule network diagrams to determine the total slack"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "You are in the process of determining the status of the project schedule and investigating the factors that caused schedule changes. From this scenario, you are currently in the Control Schedule process. What-if analysis is used in the Control Schedule process to see how various factors influence the schedule. One output of this process is to generate change requests to correct the schedule. Hence, you should generate a change request for the required corrective action. [PMBOK® Guide 6th edition, Page 229]"
    },
    {
      "id": "5727dcdc-3dea-49ef-a8e0-0389b052962b",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 203,
      "title": "A project manager is leading a process improvement project for a manufacturing company with a goal of improving the quality of the goods produced and reducing waste. The project manager wants to take a proactive approach to continuous improvement.\n\nIn addition to using a lessons learned register, what else might the project manager do to achieve the project goals?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Conduct a sensitivity analysis during the Control Quality process"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Create an iteration burndown chart for the project"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Implement the Deming cycle with the project team"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Tighten the specification limits of the existing production process"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The lessons learned register captures knowledge gained during the project so that it can be used in the current project and entered into the lessons learned repository. According to the scenario described, in addition to using the lessons learned register, the project manager is looking for further options to achieve the project goals of improving the quality of the goods manufactured by the company and reducing waste produced during the manufacturing process. The Deming cycle (also known as the plan-do-check-act cycle) takes an iterative and incremental approach to quality management which can reduce variations in a process (such as the manufacturing process). Additionally, with reduced variations in the goods produced, fewer of the finished goods will fall outside of the specification limits which will reduce waste from the scrapping of rejected goods. Thus, to achieve the project objectives, of the available choices, the implementation of the Deming cycle will have the greatest positive impact on improving quality and reducing waste and is, therefore, the best answer to the question asked. [PMBOK Guide  Sixth Edition, Page(s) 275]"
    },
    {
      "id": "024dde90-cfd9-4137-99be-e2692d276a8f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 204,
      "title": "Gordon is currently developing his project‘s stakeholder engagement strategy. All enterprise environmental factors should be considered during this process. Which of the following enterprise environmental factors should receive particular attention during this process?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The organization‘s culture and political climate"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Lessons learned from past similar projects"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Commercial databases"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Project templates"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The lessons learned and the project templates are not enterprise environmental factors, but organizational process assets. The commercial databases can provide only very limited information to develop the stakeholder engagement plan. During the Plan Stakeholder Engagement process, the organization's culture and political climate are of particular importance. [PMBOK® Guide 6th edition, Page 519]"
    },
    {
      "id": "fccedaf2-5a15-43be-96d0-0608fd013800",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 205,
      "title": "You are negotiating a supply contract with a contractor who is building a new ship yard in a developing country. The contractor is insisting that all payments to be made in the local currency where the project will be executed. This is risky as the currency’s exchange rate hasn’t been stable and fluctuated significantly in the past. Which of the following is NOT a recommended way to manage this risk?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Lock the exchange rate with a bank using a forward contract."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Document that as a risk and have contingency reserve allotted for the risk."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Ask for a cost-plus contract."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Ask for a fixed-price contract."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "If the fluctuation of exchange rate is a problem, so will be a cost-plus contract. A fixed-price contract can mitigate the risk to some extent while using a forward contract will avoid the risk. At the very least, you should document this as a risk and have some contingency reserves allotted for this risk. [PMBOK® Guide 6th edition, pages 471, 472]"
    },
    {
      "id": "2a8d33ff-977f-4671-949a-d057df1f831c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 206,
      "title": "You are beginning a new project. The project scope includes delivery of some key capabilities to the organization. The timely completion of this project is critical for the organization to maintain its market position in the industry. You are aware that due to the nature of the project, the project scope can never be locked and there are going to be a number of changes throughout the project. The change control process in your organization has historically been time a consuming activity. \nWhen should you use the Perform Integrated Change Control process on your project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Only after the project scope is clearly defined"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Only after the project is completely funded"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Only when closing out the project"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Throughout the entire project"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Changes can occur in the project at any time. The Perform Integrated Change Control process is valuable for managing and tracking those changes. [PMBOK® Guide 6th edition, Page 115]"
    },
    {
      "id": "c20aec16-a683-42e1-b184-fa47156ad8df",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 207,
      "title": "During a recession, a project manager posts a positive risk that in the current economic environment, cheaper resources may become available. On the way into work, the project manager hears about a competitor going out of business and contacts the competitor to acquire some equipment, materials, and supplies at a fraction of their normal value.\n\nWhat is the project manager doing?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Executing a mitigation plan"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Responding to a contingency plan trigger"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Transferring an identified risk"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Sharing a realized positive risk"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Some risk responses are designed for use only if certain events occur. For some risks, it is appropriate for the project team to make a response plan that will only be executed under certain predefined conditions. Risk responses identified using this technique are often called contingency plans or fallback plans and include identified triggering events that set the plans in effect.\n\nThe question describes a positive risk (opportunity) that was identified and captured in the risk register along with the risk trigger and responses. Part of the responsibility of the project manager and the risk owner is to understand what events may cause (or trigger) a risk to occur. In this case, the project manager heard of a competitor going out of business which triggered the action of contacting the competitor to acquire resources much cheaper than they otherwise could have been purchased. Note that the project manager also exploited an opportunity in this situation. However, exploiting the realized risk was not offered as an answer choice. Therefore, of the available options, reacting to a contingency plan trigger is the best response. [PMBOK Guide) Sixth Edition, page(s) 445]"
    },
    {
      "id": "217d7f57-43f5-4b15-8dae-e63cc22311fd",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 208,
      "title": "Mark is in the middle of a software development project. So far, the project has incurred a total cost of $50,000. If it is determined the project is no longer required, what would we call the cost incurred to date?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Return on investment"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Opportunity cost"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Breakeven cost"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Sunk cost"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Sunk cost is defined as a cost that has already been incurred and which cannot be recovered. [PMBOK® Guide 6th edition, Page 671]"
    },
    {
      "id": "68076123-507c-40fc-9549-7c7980aca2b8",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 209,
      "title": "A project manager has learned that new legislation has just been passed, which makes the regulatory standards even more stringent. The project manager needs to gain a better understanding of the new law and how it will affect the project which is already in execution.\n\nWhat tool or technique should the project manager use in this situation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Decomposition"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Decision-making techniques"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Expert judgment"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Risk register"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The question states that the project manager is leading the execution of a project, which suggests that the Direct and Manage Project Work process is underway. Expert judgment is one of the tools and techniques associated with this process. Expert judgment is judgment provided based upon expertise in an application area, knowledge area, discipline, industry, etc., as appropriate for the activity being performed. Such expertise may be provided by any group or person with specialized education, knowledge, skill, experience, or training. Expertise in legislation and regulations will provide insights into how the new law may impact the project. Additionally, among the available choices, only expert judgment is a tool or technique that is used during the Direct and Management Project Work process. [PMBOK Guide Sixth Edition, Page(s) 94]"
    },
    {
      "id": "9280e51d-3cce-4cd5-b9dc-c9bd21df3aa1",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 210,
      "title": "You are a consulting project manager and an investment bank has a contract with you to run a large information technology project that is expected to last 15 months. During the Direct and Manage Project Work process, you discover that several regulatory requirements were addressed in the project management plan but missed from the scope statement. Failure to meet these requirements could result in legal action against the company. However, implementing the technology to comply with these regulations could exceed the budget and scope of the project and result in the cancellation of the project. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Request additional funds to implement these requirements."
          },
          {
            "k": "B",
            "s": 2,
            "t": "This is a classic example of scope creep and such requirements must be ignored."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Do not do anything as these requirements are not a part of the scope baseline."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Submit a change request to incorporate the missed requirements in the project's scope."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "All regulatory requirements must be met. Doing nothing or considering this a scope creep are not valid options. You would have to request additional funds, but first you need to submit a change request for approval. A change request can be submitted as a part of the Direct and Manage Project Work process. [PMBOK® Guide 6th edition, Page 96]"
    },
    {
      "id": "dab466c6-8741-4d40-8aa2-36f98b2ad7b7",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 211,
      "title": "Albert is managing a system development project but so far has failed to actively engage the operations group during the system development. When you asked Albert about this, he told you that a focus group representing the users was formed during project planning phase that produced detailed and very specific requirements specifications and so there was no need to keep them engaged during the system development. What is your response?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Developing the system in a silo will introduce risk."
          },
          {
            "k": "B",
            "s": 2,
            "t": "The project will take more time to complete."
          },
          {
            "k": "C",
            "s": 3,
            "t": "User requirements cannot be accurately defined at the start of the project."
          },
          {
            "k": "D",
            "s": 4,
            "t": "The acceptance testing will fail."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Developing the system in a silo will introduce project risk. What if the user requirements change or there are changes in the project environment? Other choices are incorrect as they are extreme positions. [PMBOK® Guide 6th edition, page 397]"
    },
    {
      "id": "9a2616a6-e24a-4156-a816-5d6a3badec7c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 212,
      "title": "Your team develops an on-line shopping site for a strategic customer. During the demonstration of the site, the customer is very impressed and wants to launch it immediately. You know that one more sprint is needed to complete the documentation required by the Payment Card Industry Data Security Standard regulations. The sponsor insists on an immediate launch.\n\nWhat is your best course of action?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Launch the site to ensure that the customer and sponsor are satisfied"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Raise the paperwork as a roadblock at the next standup meeting"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Carry out one more sprint to complete the required documentation"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Remove the documentation user story from the sprint backlog"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Mandatory regulations usually require documentation to prove the product or service is compliant with rules and regulations. Launching the site without the documentation will expose the project, the client, and the delivering organization to risk. The expression \"the customer is always right\" does not apply in this case. The documentation is a part of the project. Without completing it, the project is not considered done. Many industries, such as finance, healthcare, government, have compliance-related projects and requirements. Agile teams may dislike completing documentation and may consider it as a non-value added activity that goes against one of the Agile Manifesto values. However, the values should not be abused. In this scenario, notwithstanding agile, according to the Payment Card Industry Data Security Standard (PCI DSS) regulations, the documentation is a mandatory requirement and, therefore, should be completed in spite of the customer's desire and sponsor's insistence to launch the site immediately. Hence, carrying out one more sprint to complete the required documentation is the best answer to the question asked. [Agile Practice Guide First Edition,  Page(s) 122]"
    },
    {
      "id": "9ffcb55c-d309-4c03-8d9c-a942ec5a8839",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 213,
      "title": "You have been requested to provide information on your project’s activities and processes to a unit within your company but external to the project. This group of individuals will compare the information to organizational and project policies, processes and procedures and identify good and best practices being used as well as nonconformity, gaps, and shortcomings within project activities and processes.\n\nWhat tool or technique is being conducted by the external team?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Audits"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Statistical sampling"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Data analysis"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Problem solving"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Audits which are defined as structured, independent processes assist project management in determining if project activity and processes comply with the policies and procedures prescribed. During the Manage Quality process, the data and results from the Control Quality process are used to determine the overall quality of the project work. The quality status is made available to the project stakeholders. Audits are one of many tools used to manage quality and increase the probability of meeting quality objectives and identify ineffective processes that cause poor quality. [PMBOK Guide  Sixth Edition, Page(s) 294, 288]"
    },
    {
      "id": "cc60fa21-28b9-451f-b80b-ec4035e78703",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 214,
      "title": "Your sponsor has committed to building a high-speed rail from one major inland city, Azules, to the coast. You have two possible routes, either Brazos or Corazon.\r\n\r\nGiven each route's costs, odds, and rewards of high demand and low demand in this decision tree, which route should you choose?",
      "description": "",
      "image": "https://storage.pmcbd.net/uploads/question/56f67d69-8994-482c-9eec-ef1d10d9c4b8.jpg",
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Brazos, because it has the highest expected monetary value (EMV) and avoids the worst-case scenario loss."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Corazon, because you gain 16 billion by building that route instead of gaining 10 billion by building the Brazos route."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Brazos, because 80% gives the highest chance of gaining 12 billion, which covers the 10 billion spent to build this route."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Corazon, because the probabilities of low demand and high demand are closer to 50/50, which reduces risk."
          },
          {
            "k": "E",
            "s": 5,
            "t": "None"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Decision tree analysis is a technique used for the Perform Quantitative Risk Analysis process. You must account for not only the investment cost of the decision but the probability and payoff for each effect.\nIn a decision tree, the best choice is the one with the largest expected monetary value (EMV). The EMV for the Brazos route is 0.8 billion, and the EMV for the Corazon route is -8.8 billion (note this is a negative number). Since the path with the largest expected monetary value is the Brazos route at 0.8 billion, that is the best choice."
    },
    {
      "id": "f79666af-3170-43c9-bd32-ec48180a4bd1",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 215,
      "title": "As your project has uncovered new methodologies to achieve results exceeding all expectations, your team sees an opportunity to attach the project work to a larger initiative in the company beyond the boundaries of the project. You and a few key team members present the idea with the project sponsor and other executives.\n\nWhich risk strategy was used?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Exploit"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Transfer"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Mitigate"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Escalate"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The question describes an opportunity that goes beyond the project and outside of the project manager’s scope of authority, in which case, the project manager and other key team members notify the project sponsor and other executives. After escalation, the opportunity is not further monitored by the project team. It is up to the project sponsors and other executives to take advantage of the opportunity. [PMBOK Guide Sixth Edition, Page(s) 444]"
    },
    {
      "id": "18a38093-d587-496b-8c5e-4721991574b4",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 216,
      "title": "A week prior to the project kick-off call, a Project Manager meets with a key project resource to gain a deeper understanding of how complex the project deliverables are. The resource expresses concern and worry regarding the deliverables.\n \nWhat should the Project Manager do to ensure that the deliverables are realistic?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Perform a feasibility study, and then assess the results."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Discuss the resource's concerns with the sponsor, and modify the project charter."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Note the concerns in the issue log to review at a later date."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Identify threats and preventive actions by conducting a risk assessment."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "To ensure that the deliverable are realistic, the Project Manager needs to conduct a feasibility study and then evaluate the results. none of the other choices will ensure this. [PMBOK® Guide Sixth Edition Project Management Business Documents, page 29]"
    },
    {
      "id": "464a54b6-c9be-47c9-a4ad-227d3063585f",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 217,
      "title": "You are managing the upgrade of your firm’s billing system. Midway through the project you have realized that the business requirements have changed and a new solution to the problem, originally thought to be solved by the outcome of your project, will be required. You have already consumed a lot of resources on this project. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Proceed with the project as per the approved plan unless a change request comes from the sponsor."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Notify the sponsor and discuss your concern."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Kill the project."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Issue a change request to change the course on the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Although you haven’t been officially notified of the change of business requirements, you don’t have to wait for it if you have any concerns or doubts regarding the alignment of the project objectives to the business objectives. Abruptly killing the project is not a project manager’s call. You should consult your project sponsor and discuss your concern as they are accountable for aligning the project goals with the business goals. [PMBOK® Guide 6th edition, page 60]"
    },
    {
      "id": "9c3b2e07-12ac-4f01-8ac3-9c6fa91f8fd6",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 218,
      "title": "Financial forecasts in the business case were of a higher order of magnitude based on the preliminary information available at that time. During the project planning it has now become clear that a number of other enabling activities need to be completed in order to deliver the project. This would mean at least a fifty percent increase in the project budget than what was stated in the business case. What should you do next?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Perform a cost/benefit analysis for the project."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Issue a change request for time and budget increase."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Document this as a project risk and inflate the contingency reserve."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Include the activities in the project scope and the new estimates in the product budget."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "If a significant cost increase is expected, you need to re-evaluate the project’s feasibility and reconfirm the validity of the business case, even if the project is in the planning stage. [PMBOK® Guide 6th edition, page 30]"
    },
    {
      "id": "7d807a81-bc1d-40a6-a0b1-ac8f339c8720",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 219,
      "title": "Jane is currently reviewing a list of project proposals. All the proposed projects achieve some of the organizational strategic objectives and their expected costs are known. However, Jane cannot execute all the projects due to the funding limitation. How shall Jane determine which projects she needs to execute this year?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Select the projects that maximize the business value"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Select the high-budget projects and drop the low-budget projects"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Select the low-budget projects and drop the high-budget projects"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Select the projects that maximize organizational revenue"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "Project should never be prioritized based on their budgets. Selecting the projects that maximize organizational revenue or selecting the projects that maximize the business value seem good options. However, adding to business value takes precedence over adding the organizational revenue, since there can be projects that add more to the revenue but add less to the business value. [PMBOK® Guide 6th edition, Page 7]"
    },
    {
      "id": "6096e15d-5782-40b9-bac7-f2810e59510b",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 220,
      "title": "You manage the construction of a new airport in your home country. Since your organization does not have experience deploying the sophisticated air-traffic control system, you outsourced this to a specialist organization. PMBOK® Guide’s Procurement Management knowledge will help you successfully administer this deal; however, for the supplier of the system, all the PMBOK® Guide processes will apply since this will be a complete project for the supplying organization. Which of the following will be a common denominator between your project and the supplier projects?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Project management plan"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Supply agreement"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Project’s scope of work"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Budget for the air-traffic control system"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The common denominator should be a document that is common between the buyer and the supplier, that is the supply agreement. The rest of the choices are the project artifacts what will be different for each party since supplier’s scope of work is limited in comparison to the buyer’s scope of work. [PMBOK® Guide 6th edition, Page 489]"
    },
    {
      "id": "08502ac7-f5e4-40ec-818c-a3d5d022af94",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 221,
      "title": "Team members are frequently changing during the long timeline of a multi-phase project. The project manager is questioning whether to include agile practices to accommodate the changes.\n\nWhat should the project manager do prior to moving to a hybrid approach?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Ensure project finances are secured for the next project phase"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Reduce the team size to nine people, plus or minus two"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Target a smaller project as a proof of concept to test the feasibility"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Evaluate the benefits of incorporating agile practices"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Shifting the management of a project to a hybrid approach is a decision that identifies and evaluates the potential benefits and value, along with any impediments, detriments, and consequences. Weighing the pros and cons of a hybrid approach enables the project manager to understand and appreciate the reason for the new approach. This evaluation also ensures other stakeholders beyond the project team members are on board with the decision and its rationale. [PMBOK Guide Sixth Edition, Page(s) 33, 29, 665-666; Agile Practice Guide First Edition,  Pages(s) 26]"
    },
    {
      "id": "900ad5c2-12ed-4e43-a515-a83e7350f1d5",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 222,
      "title": "Execution has begun for a project to establish retail distribution in a new area of the country. However, the performing organization has just announced the acquisition of a competitor that has a well-established retail distribution network in the target area rendering the project objectives obsolete.\n\nWhat is the best course of action for the performing organization?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Continue with the project as originally planned"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Submit a change request to update the project management plan"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Stop all project work and release the project team"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Terminate the project"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The question implies that the project objectives have been rendered obsolete with the acquisition of a competitor; thus, the need for the project no longer exists. A project typically ends when its objectives have been achieved or it is terminated when it cannot or will not meet its objectives, or when the need for the project no longer exists. The question asks what is the best course of action for the performing organization. The answer is to terminate the project. Note, a project manager is the person who is authorized by the performing organization to lead the project team to achieve the project objectives, but the project manager does not have the authority to terminate a project. An approval from the appropriate authority should be obtained. However, this option is not provided among the answer choices. Therefore, among the options available, terminating the project is the best answer to the question asked. [PMBOK Guide  Sixth Edition, Page(s) 5, 542]"
    },
    {
      "id": "98436afc-3c3c-4df7-870b-d286fdd98619",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 223,
      "title": "You just received an email from your client stating that as a result of changing government regulations, the current project is being canceled. You contact your supervisor, who confirms the news and asks you to terminate the project.\n\nWhat should you do next?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Release payments to your supplier"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Relieve the project team from their duties"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Identify lessons learned"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Check the termination clause of the contract"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Agreements, or contracts, are an output from the Conduct Procurements process and an input to the Close Project or Phase process which is, according to the scenario described, you are going to perform. A termination clause is one of the major components of an agreement. Therefore, before closing the project, you must first review the contractual rights and obligations with regard to contract termination and fulfill these obligations. In other words, to ensure that activities required by the contract are performed when closing the project, you must understand the termination clause in the contract. [PMBOK Guide Sixth Edition,  Page(s) 489, 123, 128"
    },
    {
      "id": "913f82c9-6e20-4e9f-957c-4d2cc684c59d",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 224,
      "title": "You have recently been asked to design and build a “complex” project that is supposed to somehow reduce the production costs by 20% or more. Together with the product owner, you developed a product roadmap using user story mapping, and impact mapping techniques. Now you want to assign business values to each user story. How should you proceed?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Bring the product owner and the team together again and determine the business value."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Randomly assign business values to the user stories so that you get a fine mix of user stories."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Ask the team to estimate the business value for each user story."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Ask the product owner to email you the business values for each user story."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The product owner should assign the business value. However, it is better that this is done in collaboration with (and presence of) the team. [Agile Practice Guide, 1st edition, Page 58]"
    },
    {
      "id": "9279434f-610e-433c-a545-ea69d92a4eb1",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 225,
      "title": "You are in the process of monitoring the overall progress of project work. Throughout your project, you have experienced recurring issues, and you want your current and future projects to run more smoothly.\n\nWhich of the following is least likely to proactively promote continuous improvement?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Holding lessons learned meetings at regular intervals"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Conducting retrospectives throughout the project"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Periodically updating the organizational knowledge base"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Timely implementing planned responses for the realized risks"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The question is asking for the response that is 'least' likely to promote continuous improvement. All of the answer choices represent proactive measures that can be taken to promote continuous improvement except for timely implementing planned responses for the realized risks. Implementing risk responses would address the risks as they occur, but would not contribute to proactive continuous improvement, because by definition, responding to risks is a reactive measure. [PMBOK Guide Sixth Edition Page(s) 110, 113, 96, 449]"
    },
    {
      "id": "9bbf3db6-4ce3-4bf2-88c2-c90ac0b40c75",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 226,
      "title": "Velvet is working for a chemical industry, and her management proposed two different projects to manufacture benzene for commercial use. After doing financial analysis, the financial advisor provided her with the following statistics about the projects: Project 1: 60 percent probability of success with a profit of $500,000 and 20 percent probability of failure with a loss of $200,000. Project 2: 30 percent probability of success with a profit of $300,000 and 30 percent probability of failure with a loss of $400,000. Based on the information above, Velvet should choose:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Neither project 1 nor project 2"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Project 1"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Project 2"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Either project 1 or project 2"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Profit or loss from a project = (Expected profit * probability of profit) - (Expected loss * probability of loss). For Project 1, the profit or loss = (500000*0.6 - 200000*0.2) = 300000 - 40000 = $260,000 profit. For Project 2, the profit or loss = (300000*0.3 - 400000*0.3) = 90000 - 120000 = ($30,000) = $30,000 loss. Hence, Velvet should select Project 1, which can yield a profit. [PMBOK® Guide 6th edition, Page 435]"
    },
    {
      "id": "97a19f25-fb8e-4c70-be01-7619ca805244",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 227,
      "title": "The business case documents the business need and the cost benefit analysis that justify the project. The summary of how the project has achieved the business needs identified in the business case is document in the:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Project WBS"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Project Scope Statement"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Project charter"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Project final report"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "The summary of how the project has achieved the business needs identified in the business case is included in a project’s final report. The other choices are either project initiating or planning documents. [PMBOK® Guide 6th edition, Page 128]"
    },
    {
      "id": "08ae8611-48f4-4fb3-b6a4-793f507806e3",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 228,
      "title": "A project manager is developing a plan that will describe how project communications will be planned, implemented, and monitored.\n\nWhat else should be included in this plan?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Strategies and actions needed to involve stakeholders in decision making"
          },
          {
            "k": "B",
            "s": 2,
            "t": "A list of potential risk responses"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Constraints derived from specific regulations, technology, or\norganizational policies"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Project team roles and responsibilities"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The scenario implies that the project manager is working on the communications management plan which describes the way communications will be planned, structured, implemented, and monitored for effectiveness. The question is essentially asking to select the answer choice which represents some of the information that should be included in the communications management plan. Constraints such as organizational policies regarding the use of social media, regulations related to confidential information, or the availability and reliability of certain types of technology will affect how project communications are managed and, therefore, would be included in the communications management plan. [PMBOK Guide  Sixth Edition, Page(s) 377]"
    },
    {
      "id": "5dce9552-3fea-4141-809c-43547bafb274",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 229,
      "title": "A seller was notified they were one of the selected sellers based on their proposal. The seller immediately circulated an internal newsletter stating they had just been awarded a large contract for a period of five years. Would the newsletter be factually correct?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "It is likely that the newsletter is factually incorrect. While the seller has been selected for the work, it is unlikely that the term of the project would have been five years."
          },
          {
            "k": "B",
            "s": 2,
            "t": "The newsletter is likely factually correct. A selected seller is one who has a contract based on the procurement process."
          },
          {
            "k": "C",
            "s": 3,
            "t": "It is likely that the newsletter is factually incorrect. A selected seller is one whose proposal is judged to be in a competitive range. It does not mean they have the work."
          },
          {
            "k": "D",
            "s": 4,
            "t": "The newsletter is likely factually incorrect. A selected seller is one whose proposal has been accepted, and a contract has been completed pending signatures of the authorized parties."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The newsletter will probably be factually incorrect. A selected seller is one whose proposal has been judged to be in the competitive range based on bid evaluation. The seller would have negotiated a draft contract that could become the actual contract when the award is made. [PMBOK® Guide 6th edition, Page 488]"
    },
    {
      "id": "19b4e064-1722-497a-813a-a9445adb1b21",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 230,
      "title": "During the detailed system requirements elicitation, you have identified that some of the requirements, although aligned with the project scope, conflict with the firm’s strategic objectives. When you escalated this to the project sponsor, she told you to proceed with the project anyway. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Escalate this to the sponsor’s manger."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Hold the project until you resolve this issue with the sponsor."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Move ahead with the project."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Issue a change request for additional contingency reserves."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The project sponsor is ultimately responsible for aligning the project goals to the organizational goals. If the sponsor has given you a go ahead, you need to proceed with the project. [PMBOK® Guide 6th edition, page 29]"
    },
    {
      "id": "1205b491-9cd7-4329-9636-ea37eeb0f1d0",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 231,
      "title": "Debby has been working as a project manager for a company that designs precision instruments for research labs. Her company is in the process of bidding on a project of the Food and Drug Administration. According to the FDA requirements, all bidders must have successfully completed three projects of similar size and scope. Although Debby’s company has experience in designing research instruments, it lacks the required experience to perform this project. What should Debby do in this situation?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "She must bid for the project but provide facts to the buyer."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Since the company lacks the required experience, the company is not qualified to bid."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Since the company has prior experience in the instrument design, she must bid."
          },
          {
            "k": "D",
            "s": 4,
            "t": "She must escalate this issue to the management for their advice."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Bidding on a project without meeting the qualification requirements is against the PMI code of conduct. Project managers must not bid on any work that their organization is not qualified to perform. A project manager must not do this knowingly. Hence, Debby must not bid on this project. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "70f127aa-9962-45d8-b492-18e63fb1aae3",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 232,
      "title": "A construction project has experienced weather-related delays as well as performance issues with several key vendors, and the risk responses have been implemented with varying degrees of success. A senior executive has asked the project manager for an update on the current overall project risk exposure.\n\nWhat should the project manager do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Provide the senior executive a copy of the updated risk register"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Make sure the risk report is updated and provide it to the senior executive"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Refer the senior executive to the risk management plan"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Send an updated copy of the risk exposure report to the senior executive"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The question suggests that the Implement Risk Responses process has been performed multiple times to address high-level project risks that were realized throughout project execution. The risk report is typically updated to reflect any changes to the previously agreed-upon risk responses to overall project risk exposure that are subsequently made as a result of the Implement Risk Responses process. Of the available choices, only the risk report provides information on overall project risks. Therefore, to address the senior executive’s request, the project manager should make sure the risk report is updated with the latest information and provide the report to the senior executive. 'Risk exposure report' is a fake term made up for this question. [PMBOK  Guide Sixth Edition, Page(s) 418, 452]"
    },
    {
      "id": "3179ff67-3c34-44bf-a308-104c35c20946",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 233,
      "title": "You are working on a waste management project that, upon completion, will be turned over to the local municipality for steady-state operation. Parking of trucks and other vehicles has become a serious problem because no parking area was allotted to you on the main dumping site. As a result, your trucks are parked on nearby roadsides. One of the fleet supervisors informs you that close to the main site, there is a large tract of land a local charity owns. Many locals park their cars on this tract of land. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Check the local parking laws."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Ask the supervisor to get contact information of the local charity."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Don’t park the trucks on that piece of land because it will be a violation of other’s property rights."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Since the piece of land is already used as parking, you can park your trucks over there."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "You must not use someone's property without permission, even if others are doing the same thing. The best option is to call the charity and ask for their permission. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "6beb19e1-96ac-409e-8495-9ce434e47218",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 234,
      "title": "You are developing a solution that will track corporate expenses in real time. During detailed design, the team finds out that the architecture for software would rely on a third-party open source component that causes stability issues at certain loads. This component is critical to the design of the overall system but introduces a significant risk to the project. What should you do first?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Develop the component from scratch."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Hire programmers to customize and enhance the third-party component."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Engage the third-party and work together on the stability issues."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Conduct an alternatives analysis."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "As the first step you need to conduct an alternatives analysis. Alternatives analysis is a technique used to evaluate identified options in order to select which options or approaches to use to execute and perform the work of the project. [PMBOK® Guide 6th edition, pages 245, 473]"
    },
    {
      "id": "5ff59a0e-c26b-46c9-8ea3-0a02b901a596",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 235,
      "title": "A project manager is currently managing a manufacturing process improvement project which will be completed in five phases. The project manager has prepared the following chart to review the status of the project.\r\n\r\nBased on the information provided, what is the earned value of the project?",
      "description": "",
      "image": "https://storage.pmcbd.net/uploads/question/00ca9fc6-7391-4c74-b088-1ea11567ec2e.jpg",
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "7750"
          },
          {
            "k": "B",
            "s": 2,
            "t": "9000"
          },
          {
            "k": "C",
            "s": 3,
            "t": "20000"
          },
          {
            "k": "D",
            "s": 4,
            "t": "8000"
          },
          {
            "k": "E",
            "s": 5,
            "t": "None"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "The question is asking for the current earned value (EV) of the project thus far. Earned value (EV) is the sum of the planned value of completed work. The define and measure phases are complete with planned values of $1,000 and $3,000 respectively. The analyze phase is 75% complete with a planned value of $5,000, which means the EV for the analyze phase is $3,750. Therefore, the sum of the planned values of the completed work is $1,000 + $3,000 + $3,750 which is a total EV of $7,750."
    },
    {
      "id": "9b694f96-5ef5-46af-ab8d-bdf130cc83a9",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 236,
      "title": "As a project manager, you want to establish a culture of continuous improvement with your project team, so you encourage the team to look for and implement small incremental improvements in the development process.\n\nWhich of the following are you recommending to the team?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Kaikaku"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Decomposition"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Ishikawa"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Kaizen"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Kaizen is the Japanese word for improvement. A kaizen approach makes incremental change through small steps, thereby establishing a process of continuous improvement. By applying kaizen, a development team can optimize efficiency and quality. The kaizen approach would establish a continuous improvement process by encouraging the development team to look for and implement small incremental improvements in the development process. [PMBOK Guide  Sixth Edition, Page(s) 310]"
    },
    {
      "id": "bfb57d5b-68c4-4dfb-95d0-f3a80d65ef2e",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 237,
      "title": "As part of the Estimate Costs process, a project manager obtained access to certain commercially available databases to get resource cost rate information. Such published commercial information is considered what type of input?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "HR Input"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Historical information"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Enterprise environmental factor"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Organizational process asset"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "Such published commercial information is considered part of enterprise environmental factors that influence the Estimate Costs process. [PMBOK® Guide 6th edition, Page 243]"
    },
    {
      "id": "a7ba8f07-35a4-4c81-9a5a-b2e989b74062",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 238,
      "title": "Which of the following events might call for early termination of a sprint in an iteration-based Agile project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The features currently being developed are no longer required."
          },
          {
            "k": "B",
            "s": 2,
            "t": "A significant number of new features have been requested."
          },
          {
            "k": "C",
            "s": 3,
            "t": "A significant number of change request against release features have been lodged."
          },
          {
            "k": "D",
            "s": 4,
            "t": "A project is no longer required."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Sprints, or iterations are time-boxed and are never terminated early. If the features being developed are suddenly not required, these will be replaced with other high priority features in the backlog. However, if the project is terminated, that would terminate the iteration. [Agile Practice Guide, 1st edition, Page 25]"
    },
    {
      "id": "193e1230-d447-428d-a9de-4521cc8e5453",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 239,
      "title": "After three iterations, a demo version of a new mobile app is demonstrated to end-users. The users complain that the app's security features are too complicated and would deter them from using it. The project manager realizes that modifications to the security features will require substantial rework that was not accounted for during risk planning.\n\nWhat should the project manager do now?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Instruct the team to modify security features to make the application more user-friendly"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Suggest that the team proceed with the development according to the original plan"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Submit a change request and ask the product owner to refine the product backlog"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Cease all project work to avoid any further damage to the company's reputation"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The scenario suggests that the development of the application is carried out using agile practices while some other aspects of the project are conducted using the traditional project management approach as implied by risk planning. Agile teams should verify and validate the value of what they are delivering. Changes are welcomed in Agile, even late in development. However, when traditional project elements are involved, changes should follow the established organization's change control process. The problem described in the scenario should be addressed using a hybrid approach. One aspect is submitting a change request to evaluate the impact of the changes on all project constraints. It is likely that additional funds will be required to cover the unknown costs of the rework. Another aspect is to request the product owner to refine the product backlog, specifically the user stories related to the security features. The product owner will then need to instruct the team on the\nmodifications that should be made. Therefore, of the choices provided, the combined response of submitting a change request and asking the product owner to refine the product backlog is likely to be the best answer to the question asked. [PMBOK Guide Sixth Edition, Page(s) 170; Agile Practice Guide/- First Edition, Page(s) 41, 52; Agile Project Management: Creating Innovative Products/, 2nd Edition, Jim Highsmith, 2009, Frequent verification and validation Customer Focus Groups]"
    },
    {
      "id": "6593b25b-0cbc-4512-b514-5b8f528e7427",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 240,
      "title": "A first-time project manager is advised by an experienced project manager to plan for cost of quality. The first-time project manager is not sure which costs are included in the cost of quality. What would your advice be?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Cost of quality only includes prevention costs and internal failure costs."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Cost of quality only includes cost of nonconformance."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Cost of quality only includes cost of conformance."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Cost of quality includes cost of conformance and cost of nonconformance."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Cost of quality (COQ) includes all costs related to quality management activities and quality issues incurred over the life of a product. It includes cost of conformance (prevention and appraisal costs) as well as cost of nonconformance (internal and external failure costs). [PMBOK® Guide 6th edition, Pages 282, 283]"
    },
    {
      "id": "8ae7edcb-b1fd-4f7e-802a-7c3836270180",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 241,
      "title": "What is the key benefit of developing a charter for a project?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Providing the project manager with the formal authority to manage the\nproject"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Creating a contract between the project manager and the performing\norganization"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Linking the project to the strategic objectives of the performing\norganization"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Creating a comprehensive document that defines the basis of all project work"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "This question is an example of a few straightforward one-line knowledge-based questions that prospective PMP aspirants may encounter on their exam. The question is not asking to provide a definition of a project charter. Rather, the question is asking to select an answer choice that best describes the key benefit of developing a charter for a project. In other words, the question is asking, \"What is the key benefit of the Develop Project Charter process?\" As stated in the reference provided, \"The key benefits of this process are that it provides a direct link between the project and the strategic objectives of the organization, creates a formal record of the project, and shows the organizational commitment to the project.\" [PMBOK Guide Sixth Edition, Page(s) 75]"
    },
    {
      "id": "b0b853d2-8f8a-447c-99ad-5db199618134",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 242,
      "title": "Your project is trending to meet or exceed all of its objectives, but the spend rate is higher than planned.\n\nWhich of the following most accurately describes the project's performance?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "The quality of the deliverables is lower than planned"
          },
          {
            "k": "B",
            "s": 2,
            "t": "The schedule performance index (SPI) is greater than 1.0"
          },
          {
            "k": "C",
            "s": 3,
            "t": "The earned value is less than the planned value"
          },
          {
            "k": "D",
            "s": 4,
            "t": "The to-complete performance index (TCPI) is greater than 1.0"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "The question indicates that the project is trending to meet or exceed all of its objectives. This means that if the current performance is maintained for the remainder of the project, the entire project scope will be completed on time or sooner and within or under budget. The spend rate only indicates that project costs have exceeded what was planned at this point in the project. The spend rate does not indicate if the actual costs have exceeded the value of the work completed. If the project work is being completed faster than planned, then it is possible to have a higher than expected spend rate with the project still trending to complete within budget. Thus, just because a project is spending money at a faster rate than planned, does not necessarily mean that the project's objectives are in jeopardy. All of the incorrect answer choices can be eliminated because they indicate that the project is trending to miss a project baseline. An SPI of greater than 1.0 indicates that the project is trending ahead of schedule, and is the only answer choice that is aligned with the scenario, according to which the project is trending to meet or exceed all of its objectives. [PMBOK Guide Sixth Edition, Page(s) 259-263]"
    },
    {
      "id": "08b0e147-a130-4a37-903b-b1806b50c5ae",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 243,
      "title": "Due to unforeseen challenges, it has been determined that your original budget of $500,000 is no longer realistic. You have estimated that the project will eventually cost $600,000. The table below represents the current status of the project. The method used to determine the earned value is based on percent complete.\r\n\r\nWhat is the cost performance efficiency that must be maintained to complete the project based on the estimate at completion?",
      "description": "",
      "image": "https://storage.pmcbd.net/uploads/question/8367012a-21bc-4cba-934c-32db754e4059.jpg",
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "1.5"
          },
          {
            "k": "B",
            "s": 2,
            "t": "0.75"
          },
          {
            "k": "C",
            "s": 3,
            "t": "0.88"
          },
          {
            "k": "D",
            "s": 4,
            "t": "1.17"
          },
          {
            "k": "E",
            "s": 5,
            "t": "None"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "C",
      "explanation": "The to-complete performance index (TCPI) is a measure of the cost performance that is required to be achieved with the remaining resources to meet a specified management goal, expressed as the ratio of the cost to finish the outstanding work to the remaining budget. In other words, the TCPI is the cost performance efficiency that must be maintained to complete the project based on the specified budget. In the scenario described, the question is asking to determine the cost performance efficiency that must be maintained to complete the project based on the estimate at completion (EAC). In this case, the TCPI should be calculated using the formula that considers the EAC, i.e., TCPI = (BAC - EV) / (EAC - AC), where BAC is budget at completion, EAC is estimate at completion, EV is earned value, and AC is actual costs. The BAC for this project is provided as $500,000 which is the planned value for the project. The EV is the sum of the planned work completed, which, in this case, is 100% of activity 1, 100% of activity 2, and 50% of activity 3. AC is the sum of the costs for each of the individual activities. The AC values for each activity are provided in the chart. The EAC is given in the scenario, \"You have estimated that the project will eventually cost $600,000.\" Note, since the scenario mentions that the method used to determine the earned value is based on percent complete, the earned value of a partially completed work package is calculated by multiplying the planned value of the work package by its the percent complete.\n\nThe calculations are as follows:\n\nEV = EV of activity 1 + EV of activity 2 + EV of activity 3 = (1 x $15,000) + (1 x $10,000) + (0.50 x $250,000) = $150,000\n\nAC = AC of activity 1 + AC of activity 2 + AC of activity 3 = $14,000 + $11,000 + $175,000 = $200,000\n\nTCPI = (BAC - EV) / (EAC - AC) = ($500,000 - $150,000) / ($600,000 - $200,000) = 0.88\n\nThe TCPI of 0.88 means that in order to complete the project with the new budget of EAC = $600,000 instead of the original budget of BAC = $500,000, the cost performance efficiency of 0.88 must be maintained.\nNote that the TCPI can also be calculated using only the BAC and not the EAC. However, since the question indicates that the original budget is no longer valid and provides a new estimate at completion, the EAC was used to calculate the TCPI."
    },
    {
      "id": "c30b926e-ebfb-4986-8db7-a5fb7062c097",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 244,
      "title": "Your organization is developing a new housing scheme for a state department on a firm fixed-price contract. The project was halfway through execution when a financial recession hits, causing the prices of raw materials to go through the roof. With the current prices, you might not be able to meet your cost targets and that will eat away a significant portion of the profit. You requested for additional funds but that was turned down by the state department. The contract doesn’t have any EPA clause. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "File a lawsuit against the state department."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Initiate alternative dispute resolution procedures as defined in your contract."
          },
          {
            "k": "C",
            "s": 3,
            "t": "Hold the project unless both parties reach an agreement."
          },
          {
            "k": "D",
            "s": 4,
            "t": "Comply with your contractual obligations and continue with the project."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Unfortunately, you have to accept this and continue with the project in line with your contractual obligations. It is your ethical responsibility to deliver what you have committed to deliver. [PMI Code of Ethics and Professional Conduct]"
    },
    {
      "id": "99395add-0839-4cdf-951c-1894c1a72d54",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 245,
      "title": "To reduce delivery delays and process downtime, your organization has recognized a need to replace their legacy manufacturing system with a modern software application. Your IT director anticipates a project to fulfill this business need; however, he warns that the new project’s budget cannot exceed $75,000 due to shortages in the department budget. He also indicates that no additional staff will be allocated to this project other than the existing IT staff. If you become the project manager, you would document these initial project conditions as:",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Project constraints"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Business case"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Enterprise environmental factors"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Project assumptions"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "A",
      "explanation": "A project constraint is a limiting factor that affects the execution of the project. Budget and staffing restrictions in this case are examples of project constraints. [PMBOK® Guide 6th edition, Page 701]"
    },
    {
      "id": "7713ba56-db3d-4b69-a3bd-fabe10771e12",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 246,
      "title": "You are conducting benefit analysis with relevant stakeholders in order to develop the benefits management plan for an e-commerce website development project. You have already documented the following items in\nthe benefits management plan:\n\n-The expected net present value (NPV) of $500,000\n-Revenues to begin with the completion of the website and will be ongoing\n-A person accountable to monitor, record, and report realized benefits\n-Metrics to be used to show benefits realized\n-Assumptions for the realization of benefits\n-Risks for the realization of benefits\n\nBased on this information, what might you have forgotten?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Target benefits"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Strategic alignment"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Benefits owner"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Timeframe for realizing benefits"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "Key elements of the project benefits management plan may include target benefits, strategic alignment, a timeframe for realizing benefits, benefits owner, metrics, assumptions, and risks. All of these elements are described in the bullet points presented by the question except for strategic alignment. Strategic alignment can be described as how well the project benefits align with the business strategies of the organization. Therefore, of the available choices, strategic alignment is the element of the benefits management plan that was most likely forgotten. [PMBOK Guide Sixth Edition, Page(s) 33]"
    },
    {
      "id": "880e3cb3-48d4-410e-9afe-b45ac98737a8",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 247,
      "title": "Which of the following Agile concepts implies “smallest possible deliverable that meets customer requirements”?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Theme"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Minimum viable product"
          },
          {
            "k": "C",
            "s": 3,
            "t": "User story"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Epic"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "B",
      "explanation": "A minimum viable product (MVP) is a product or a project outcome that contains sufficient features to satisfy project stakeholders. [Agile Practice Guide, 1st edition, Page 23]"
    },
    {
      "id": "75ed2cc3-d306-4e61-927c-74afb69ae70a",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 248,
      "title": "Jill is managing an organizational re-design project. Although the higher level operating model was approved by the project’s steering committee, most of the project stakeholders lack a clear understanding of their requirements and are struggling to envision future processes and workflows. This has brought a great deal of uncertainty around project requirements and how to fulfil those requirements. Which of the following is a major project risk at this stage?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Initial project duration cannot be determined."
          },
          {
            "k": "B",
            "s": 2,
            "t": "Initial project budget cannot be determined."
          },
          {
            "k": "C",
            "s": 3,
            "t": "These uncertainties would result in a big number of layoffs."
          },
          {
            "k": "D",
            "s": 4,
            "t": "These uncertainties can contribute to high rates of change and project complexity."
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Initial project budget and duration might be difficult to determine, but it should still be possible. Rough order of magnitude estimates can be used if detailed requirements are not known early during the project. The project might or might not result in layoffs and no relevant information has been provided to determine this. However, since the project has significant uncertainties, this can contribute to high rate of change and project complexity. [Agile Practice Guide, 1st edition, Page 13]"
    },
    {
      "id": "aace20cb-9abc-467f-ac0c-5c32c6976f3c",
      "user_answer": "",
      "mark_for_review": false,
      "is_correct": false,
      "is_answered": false,
      "display": 249,
      "title": "You just initiated a project to establish windmills in a developing country. To celebrate the initiation of the project, the customers arranged a party in which a key customer offered valuables to you and all your project team members with a request to complete the project sooner than the actual finish date. What should you do?",
      "description": null,
      "image": null,
      "type": {
        "value": "SINGLE_CHOICE",
        "name": "Single Choice"
      },
      "options": {
        "choices": [
          {
            "k": "A",
            "s": 1,
            "t": "Reject the offer and do not communicate with that customer"
          },
          {
            "k": "B",
            "s": 2,
            "t": "Accept the offer but refuse to complete the project early"
          },
          {
            "k": "C",
            "s": 3,
            "t": "Accept the offer and agree to finish the project early"
          },
          {
            "k": "D",
            "s": 4,
            "t": "Reject the offer because it violates the code of ethics and professional conduct"
          }
        ]
      },
      "explanation_image": null,
      "correct_answer": "D",
      "explanation": "Since the stakeholder made a request by offering gifts, you should refuse the offer. The PMI's Code of Ethics and Professional Conduct suggests that a project manager should never engage in unfairness. Favoring one or more customers by taking gifts is not allowed. Thus, you should reject the offer because it violates the Code of Ethics and Professional Conduct. Not communicating with one customer could impair relationships with other customers. If it is customary in that country to offer gifts, you might accept them without agreeing to the customer's request. [PMI Code of Ethics and Professional Responsibility]"
    }
  ]
  export {
      sampleData
  }


